"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18496],{

/***/ 99871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36456);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31567);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22318);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);
/* harmony import */ var _redux_actions_products__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86730);
/* harmony import */ var _BackInStockAlertForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65049);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        root: {
            borderRadius: '0.5rem',
            paddingBottom: '0.7rem',
            margin: '1rem 0',
            background: theme.extraColors.greyLight,
            display: 'flex',
            flexDirection: 'column',
            '&>.MuiButton-root>.Mui-disabled': {
                background: theme.extraColors.greyMedium
            }
        },
        titleContainer: {
            margin: '0.5rem 0 0 0.8rem',
            '&>ul': {
                listStyle: 'none',
                margin: 0,
                padding: 0,
                '&>li:': {
                    '&:before': {
                        content: '"•"',
                        marginRight: '0.2rem',
                        fontSize: '1.3rem',
                        color: theme.palette.warning.main,
                        display: 'inline-block'
                    }
                }
            }
        },
        title: _defineProperty({
            display: 'flex',
            alignItems: 'center',
            wordBreak: 'keep-all',
            '&>p': {
                fontWeight: 700
            }
        }, theme.breakpoints.down('sm'), {
            '&>p': {
                fontSize: '90%'
            }
        }),
        text: _defineProperty({
            margin: '0 0.5rem 1rem 0.8rem',
            wordBreak: 'keep-all'
        }, theme.breakpoints.down('sm'), {
            '&>p': {
                fontSize: '85%'
            }
        }),
        validationMessage: _defineProperty({
            color: theme.palette.success.main,
            margin: '0 0 1rem 0.8rem',
            wordBreak: 'keep-all'
        }, theme.breakpoints.down('sm'), {
            '&>p': {
                fontSize: '85%'
            }
        }),
        message: _defineProperty({
            margin: '1rem 0 1rem 0.8rem',
            wordBreak: 'keep-all'
        }, theme.breakpoints.down('sm'), {
            '&>p': {
                fontSize: '85%'
            }
        }),
        errorMessage: {
            color: theme.palette.error.main
        },
        failMessage: {
            color: theme.palette.warning.main
        },
        actionsContainer: _defineProperty({
            display: 'flex',
            margin: '0 0.8rem 0.5rem',
            justifyContent: 'center',
            alignItems: 'center'
        }, theme.breakpoints.down('sm'), {
            flexDirection: 'column'
        }),
        textField: _defineProperty({
            flex: 1,
            marginBottom: 0,
            '& input': {
                border: "1px solid ".concat(theme.palette.primary.main),
                padding: '0.8rem 0.8rem',
                backgroundColor: theme.palette.common.white
            }
        }, theme.breakpoints.down('sm'), {
            marginBottom: '0.8rem',
            width: '100%'
        }),
        button: _defineProperty({
            flex: 1,
            marginLeft: '2rem',
            height: '2.5rem',
            background: theme.palette.primary.main,
            marginTop: '0.1rem',
            '&:hover, &:active': {
                border: "1px solid ".concat(theme.palette.primary.main),
                '&>span': {
                    color: theme.palette.primary.main,
                    transition: '0.5s'
                },
                transition: '0.5s'
            },
            '&:disabled': {
                background: theme.extraColors.greyMedium,
                cursor: 'not-allowed'
            },
            '&>span': {
                color: theme.palette.common.white
            }
        }, theme.breakpoints.down('sm'), {
            marginLeft: 0,
            width: '100%',
            padding: '0.8rem',
            '&>span': {
                fontSize: '85%'
            }
        })
    });
});
var mapDispatchToProps = {
    postStockAlert: _redux_actions_products__WEBPACK_IMPORTED_MODULE_4__/* .postStockAlert */ .Gz
};
var BackInStockAlert = function(param) {
    var singleProductPrismicData = param.singleProductPrismicData, products = param.products, url = param.url, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    warehouseId = param.warehouseId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    postStockAlert = param.postStockAlert, isPack = param.isPack;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)().t;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)('backInStockAlert', classes.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)('backInStockAlert__titleContainer', classes.titleContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)('backInStockAlert__title', classes.title),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "h5",
                            component: "p",
                            children: isPack ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                asText: true,
                                data: singleProductPrismicData === null || singleProductPrismicData === void 0 ? void 0 : singleProductPrismicData.stock_alert_title_pack,
                                defaultText: t('texts:single_product:backInStock:stock_alert_title_pack')
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                asText: true,
                                data: singleProductPrismicData === null || singleProductPrismicData === void 0 ? void 0 : singleProductPrismicData.stock_alert_title,
                                defaultText: t('texts:single_product:backInStock:stock_alert_title')
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)('backInStockAlert__text', classes.text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    variant: "body1",
                    component: "p",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        asText: true,
                        data: singleProductPrismicData === null || singleProductPrismicData === void 0 ? void 0 : singleProductPrismicData.stock_alert_text,
                        defaultText: t('texts:single_product:backInStock:stock_alert_text')
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackInStockAlertForm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                selectedProducts: products,
                url: url
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(null, mapDispatchToProps)(BackInStockAlert));


/***/ }),

/***/ 65049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31567);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36456);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86700);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86010);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59000);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94455);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41107);
/* harmony import */ var _redux_actions_products__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86730);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66026);
/* harmony import */ var _utils_gtag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65809);
/* provided dependency */ var process = __webpack_require__(34155);















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        formContainer: _defineProperty({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }, theme.breakpoints.up('sm'), {
            flexDirection: 'row'
        }),
        actionsContainer: _defineProperty({
            display: 'flex',
            margin: '0 0.8rem 0.5rem',
            justifyContent: 'center',
            alignItems: 'center'
        }, theme.breakpoints.down('sm'), {
            flexDirection: 'column'
        }),
        textField: _defineProperty({
            flex: 1,
            marginBottom: 0,
            '& input': {
                border: "1px solid ".concat(theme.palette.primary.main),
                padding: '0.8rem 0.8rem',
                backgroundColor: theme.palette.common.white
            }
        }, theme.breakpoints.down('sm'), {
            marginBottom: '0.8rem',
            width: '100%'
        }),
        button: _defineProperty({
            flex: 1,
            marginLeft: '2rem',
            height: '2.5rem',
            background: theme.palette.primary.main,
            marginTop: '0.1rem',
            '&:hover, &:active': {
                border: "1px solid ".concat(theme.palette.primary.main),
                '&>span': {
                    color: theme.palette.primary.main,
                    transition: '0.5s'
                },
                transition: '0.5s'
            },
            '&:disabled': {
                background: theme.extraColors.greyMedium,
                cursor: 'not-allowed'
            },
            '&>span': {
                color: theme.palette.common.white
            }
        }, theme.breakpoints.down('sm'), {
            marginLeft: 0,
            width: '100%',
            padding: '0.8rem',
            '&>span': {
                fontSize: '85%'
            }
        }),
        message: _defineProperty({
            margin: '1rem 0 1rem 0.8rem',
            wordBreak: 'keep-all'
        }, theme.breakpoints.down('sm'), {
            '&>p': {
                fontSize: '85%'
            }
        }),
        errorMessage: {
            color: theme.palette.error.main
        },
        failMessage: {
            color: theme.palette.warning.main
        },
        validationMessage: _defineProperty({
            color: theme.palette.success.main,
            margin: '0 0 1rem 0.8rem',
            wordBreak: 'keep-all'
        }, theme.breakpoints.down('sm'), {
            '&>p': {
                fontSize: '85%'
            }
        })
    });
});
var BackInStockAlertForm = function(param) {
    var selectedProducts = param.selectedProducts, url = param.url, stores = param.stores, isSecondHand = param.isSecondHand, postStockAlert1 = param.postStockAlert;
    var ref8, ref1;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$)().t;
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().trackEvent;
    var classes = useStyles();
    var prismicProduct = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.prismic.prismicProduct;
    });
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), mail = ref2[0], setMail = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isMailGood = ref3[0], setIsMailGood = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showMessage = ref4[0], setShowMessage = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showFailMessage = ref5[0], setShowFailMessage = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), mailAlreadyDone = ref6[0], setMailAreadyDone = ref6[1];
    var customContainerClass = _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .isSubscription */ .Nn ? classes.actionsContainer : classes.formContainer;
    var errorMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        variant: "body1",
        component: "p",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)('backInStockAlert__errorMessage', classes.errorMessage, classes.message),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            asText: true,
            data: prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.stock_alert_mail_error,
            defaultText: t('texts:single_product:backInStock:stock_alert_mail_error')
        })
    });
    var failMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        variant: "body1",
        component: "p",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)('backInStockAlert__failMessage', classes.failMessage, classes.message),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            asText: true,
            data: mailAlreadyDone ? prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.stock_alert_already_fail : prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.stock_alert_validation_fail,
            defaultText: mailAlreadyDone ? t('texts:single_product:backInStock:stock_alert_already_fail') : t('texts:single_product:backInStock:stock_alert_validation_fail')
        })
    });
    var validationMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        variant: "body1",
        component: "p",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)('backInStockAlert__validationMessage', classes.validationMessage, classes.message),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            asText: true,
            data: prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.stock_alert_validation_message,
            defaultText: t('texts:single_product:backInStock:stock_alert_validation_message')
        })
    });
    var warehouseId = (stores === null || stores === void 0 ? void 0 : (ref8 = stores.selectedStore) === null || ref8 === void 0 ? void 0 : ref8.warehouseId) ? stores === null || stores === void 0 ? void 0 : (ref1 = stores.selectedStore) === null || ref1 === void 0 ? void 0 : ref1.warehouseId : process.env.CUSTOM_WAREHOUSE ? process.env.CUSTOM_WAREHOUSE : null;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(mail) === false && mail !== '') setIsMailGood(false);
        else setIsMailGood(true);
    }, [
        mail
    ]);
    var handleValidateAlert = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var controller, data, response, ref, ref7, data1;
            return _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        controller = new AbortController();
                        data = warehouseId ? {
                            email: mail,
                            products: selectedProducts,
                            url: url,
                            warehouseId: warehouseId,
                            isSecondHand: isSecondHand
                        } : {
                            email: mail,
                            products: selectedProducts,
                            url: url,
                            isSecondHand: isSecondHand
                        };
                        trackEvent({
                            category: 'Products',
                            action: "Stock alert",
                            name: mail
                        });
                        setShowFailMessage(false);
                        setShowMessage(false);
                        setMailAreadyDone(false);
                        _ctx.next = 8;
                        return postStockAlert1(data);
                    case 8:
                        response = _ctx.sent;
                        if (response.type === 'POST_STOCK_ALERT_SUCCESS') {
                            setShowMessage(true);
                            if (data.isSecondHand) {
                                trackEvent({
                                    category: 'Second Hand back in stock alert',
                                    action: "User subscribe to stock alert for sku n\xb0 ".concat(selectedProducts[0].sku)
                                });
                                _utils_gtag__WEBPACK_IMPORTED_MODULE_9__/* .tracker */ .ap("User subscribe to stock alert for sku n\xb0 ".concat(selectedProducts[0].sku), {
                                    value: selectedProducts[0].sku
                                });
                            }
                        }
                        if (response.type === 'POST_STOCK_ALERT_FAILURE') {
                            ;
                            data1 = response === null || response === void 0 ? void 0 : (ref = response.err) === null || ref === void 0 ? void 0 : (ref7 = ref.response) === null || ref7 === void 0 ? void 0 : ref7.data;
                            if ((data1 === null || data1 === void 0 ? void 0 : data1.message) === 'Stock alert already exists for this email and these products') {
                                setMailAreadyDone(true);
                            }
                            setShowFailMessage(true);
                        }
                        return _ctx.abrupt("return", controller.abort());
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleValidateAlert() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: showMessage ? validationMessage : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(customContainerClass, 'backInStockAlert__actionsContainer'),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)('backInStockAlert__textField', classes.textField),
                            type: "email",
                            value: mail,
                            placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* .prismicText */ .yz)(prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.stock_alert_input_placeholder, t('texts:single_product:backInStock:stock_alert_input_placeholder')),
                            onChange: function(value) {
                                setMail(value);
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)('backInStockAlert__button', classes.button),
                            onClick: handleValidateAlert,
                            color: "primary",
                            disabled: !isMailGood || mail === '' || selectedProducts[0].sku.length === 0 && !_utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .disableSecondHandSizeAndCondition */ .wK,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: prismicProduct === null || prismicProduct === void 0 ? void 0 : prismicProduct.stock_alert_button,
                                    defaultText: t('texts:single_product:backInStock:stock_alert_button')
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    children: [
                        !isMailGood && errorMessage,
                        showFailMessage && failMessage
                    ]
                })
            ]
        })
    }));
};
var mapDispatchToProps = {
    postStockAlert: _redux_actions_products__WEBPACK_IMPORTED_MODULE_7__/* .postStockAlert */ .Gz
};
var mapStateToProps = function(state) {
    return {
        stores: state.stores
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(BackInStockAlertForm));


/***/ }),

/***/ 74947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BackInStockAlert_SecondHandBackInStockAlertButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/BackInStockAlert/BackInStockAlertForm.tsx
var BackInStockAlertForm = __webpack_require__(65049);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./components/BackInStockAlert/SecondHandBackInStockAlertModal.tsx










function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        modal: {
            borderRadius: 0,
            '& .MuiPaper-root': _defineProperty({
                borderRadius: theme.shape.borderRadius
            }, theme.breakpoints.up('md'), {
                minWidth: 500
            })
        },
        modalHead: {
            padding: theme.spacing(1, 2),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: 0
        },
        modalTitle: {
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: 700,
            lineHeight: 1,
            color: theme.palette.primary.main,
            '&>.MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            }
        },
        modalClose: {
            cursor: 'pointer',
            padding: theme.spacing(0.5),
            width: theme.spacing(3),
            height: theme.spacing(3),
            borderRadius: theme.spacing(2),
            textAlign: 'center',
            color: 'white',
            background: theme.palette.primary.main,
            '&:hover, &:focus': {
                background: theme.extraColors.grey
            }
        },
        sizeButton: _defineProperty({
            height: theme.spacing(4),
            padding: theme.spacing(1, 2),
            margin: theme.spacing(0.5, 0.5, 0.5, 0),
            minWidth: 45,
            backgroundColor: theme.extraColors.greyLight,
            '&:hover': {
                backgroundColor: theme.palette.common.black,
                color: theme.palette.common.white
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        selected: _defineProperty({
            height: theme.spacing(4),
            padding: theme.spacing(1, 2),
            margin: theme.spacing(0.5, 0.5, 0.5, 0),
            minWidth: 45,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
            '&:hover': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.common.black
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        modalContent: {
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(0, 2, 2)
        },
        sizeContainer: {
            marginBottom: 10
        }
    });
});
var SecondHandBackInStockAlertModal = function(param) {
    var onClose = param.onClose, open = param.open, prismicTakeback = param.prismicTakeback, allVariantsNotInStock = param.allVariantsNotInStock;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = useStyles();
    var ref = (0,react.useState)(''), selectedSku = ref[0], setSelectedSku = ref[1];
    var baseUrl =  true && window.location.origin ? window.location.origin : '';
    var currentFullUrl = baseUrl + router["default"].asPath;
    var selectedProducts = [
        {
            sku: selectedSku,
            quantity: 1
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: open,
        onClose: onClose,
        className: classes.modal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.modalHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: 'h2',
                        className: classes.modalTitle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: prismicTakeback === null || prismicTakeback === void 0 ? void 0 : prismicTakeback.take_back_stock_alert_modal_title,
                                defaultText: t('texts:takeBack:take_back_stock_alert_modal_title')
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        onClick: onClose,
                        className: classes.modalClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.modalContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: prismicTakeback === null || prismicTakeback === void 0 ? void 0 : prismicTakeback.take_back_stock_alert_modal_text,
                            defaultText: t('texts:takeBack:take_back_stock_alert_modal_text')
                        })
                    }),
                    !constants/* disableSecondHandSizeAndCondition */.wK && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.sizeContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: 'div',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: prismicTakeback === null || prismicTakeback === void 0 ? void 0 : prismicTakeback.take_back_stock_alert_modal_size_label,
                                    defaultText: t('texts:takeBack:take_back_stock_alert_modal_size_label')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: allVariantsNotInStock === null || allVariantsNotInStock === void 0 ? void 0 : allVariantsNotInStock.map(function(variant, index) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "small",
                                        className: variant.sku === selectedSku ? "sizes__btn selected ".concat(classes.selected) : "sizes__btn ".concat(classes.sizeButton),
                                        onClick: function() {
                                            return setSelectedSku(variant.sku);
                                        },
                                        children: variant.size
                                    }, index));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockAlertForm/* default */.Z, {
                        selectedProducts: selectedProducts,
                        url: currentFullUrl,
                        isSecondHand: true
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var BackInStockAlert_SecondHandBackInStockAlertModal = (SecondHandBackInStockAlertModal);

// EXTERNAL MODULE: ./utils/gtag.ts
var gtag = __webpack_require__(65809);
;// CONCATENATED MODULE: ./components/BackInStockAlert/SecondHandBackInStockAlertButton.tsx










function SecondHandBackInStockAlertButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var SecondHandBackInStockAlertButton_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        backInStockAlertButtonContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            paddingRight: theme.spacing(0.6)
        },
        backInStockAlertLink: (_obj = {
            justifyContent: 'start',
            padding: theme.spacing(0),
            textDecoration: 'underline',
            textTransform: 'inherit',
            color: theme.palette.common.black
        }, SecondHandBackInStockAlertButton_defineProperty(_obj, theme.breakpoints.down('md'), {
            marginBottom: theme.spacing(1)
        }), SecondHandBackInStockAlertButton_defineProperty(_obj, '&:hover, &:focus', {
            background: 'none'
        }), _obj)
    });
});
var SecondHandBackInStockAlertButton = function(param) {
    var prismicTakeback = param.prismicTakeback, allVariantsNotInStock = param.allVariantsNotInStock, _displayTextBeforeButton = param.displayTextBeforeButton, displayTextBeforeButton = _displayTextBeforeButton === void 0 ? true : _displayTextBeforeButton;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = SecondHandBackInStockAlertButton_useStyles();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var ref = (0,react.useState)(false), openBackInStockAlertModal = ref[0], setOpenBackInStockAlertModal = ref[1];
    var handleCloseBackInStockAlert = function() {
        setOpenBackInStockAlertModal(false);
        trackEvent({
            category: 'Second Hand Back In Stock Alert',
            action: "User close stock alert modal"
        });
        gtag/* tracker */.ap('User close stock alert modal', {
            value: openBackInStockAlertModal
        });
    };
    var handleOpenBackInStockAlert = function() {
        setOpenBackInStockAlertModal(true);
        trackEvent({
            category: 'Second Hand Back In Stock Alert',
            action: "User open stock alert modal"
        });
        gtag/* tracker */.ap('User open stock alert modal', {
            value: openBackInStockAlertModal
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.backInStockAlertButtonContainer,
        children: [
            displayTextBeforeButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: prismicTakeback === null || prismicTakeback === void 0 ? void 0 : prismicTakeback.take_back_stock_alert_text,
                        defaultText: t('texts:takeBack:take_back_stock_alert_text')
                    }),
                    "\xa0"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                onClick: handleOpenBackInStockAlert,
                className: (0,clsx_m/* default */.Z)(classes.backInStockAlertLink),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    data: prismicTakeback === null || prismicTakeback === void 0 ? void 0 : prismicTakeback.take_back_stock_alert_link,
                    defaultText: t('texts:takeBack:take_back_stock_alert_link')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockAlert_SecondHandBackInStockAlertModal, {
                open: openBackInStockAlertModal,
                onClose: handleCloseBackInStockAlert,
                prismicTakeback: prismicTakeback,
                allVariantsNotInStock: allVariantsNotInStock
            })
        ]
    }));
};
/* harmony default export */ var BackInStockAlert_SecondHandBackInStockAlertButton = (SecondHandBackInStockAlertButton);


/***/ }),

/***/ 46802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59000);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: _defineProperty({
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, theme.breakpoints.down('sm'), {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
            fontSize: '0.5rem'
        }),
        container: {
            background: theme.palette.common.white,
            maxWidth: 600,
            margin: 'auto',
            padding: "0 ".concat(theme.spacing(4), "px")
        },
        inputsHeader: {
            padding: "".concat(theme.spacing(0.25), "px ").concat(theme.spacing(0), "px")
        },
        question: {
            padding: "".concat(theme.spacing(1), "px 0 !important"),
            '& p': {
                fontSize: '14px !important'
            }
        },
        alignCenter: {
            textAlign: 'center'
        },
        braSizeContainer: _defineProperty({
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
            fontSize: '1.5rem',
            background: theme.palette.primary.light,
            borderRadius: theme.spacing(2)
        }, theme.breakpoints.down('sm'), {
            margin: 0
        }),
        braSizeInfo: {
            fontSize: '1rem'
        },
        submitButton: {
            backgroundColor: theme.palette.primary.light
        },
        error: {
            color: theme.palette.error.main + ' !important',
            fontWeight: 700
        }
    });
});
var tableDos = [
    {
        min: 67,
        max: 67,
        taille: '70/75'
    },
    {
        min: 68,
        max: 71,
        taille: '75'
    },
    {
        min: 72,
        max: 72,
        taille: '75/80'
    },
    {
        min: 73,
        max: 76,
        taille: '80'
    },
    {
        min: 77,
        max: 77,
        taille: '80/85'
    },
    {
        min: 78,
        max: 81,
        taille: '85'
    },
    {
        min: 82,
        max: 82,
        taille: '85/90'
    },
    {
        min: 83,
        max: 86,
        taille: '90'
    },
    {
        min: 87,
        max: 87,
        taille: '90/95'
    },
    {
        min: 88,
        max: 91,
        taille: '95'
    },
    {
        min: 92,
        max: 92,
        taille: '95/100'
    },
    {
        min: 93,
        max: 96,
        taille: '100'
    },
    {
        min: 97,
        max: 97,
        taille: '100/105'
    },
    {
        min: 98,
        max: 101,
        taille: '105'
    },
    {
        min: 102,
        max: 102,
        taille: '105/110'
    },
    {
        min: 103,
        max: 106,
        taille: '110'
    },
    {
        min: 107,
        max: 107,
        taille: '110/115'
    },
    {
        min: 108,
        max: 111,
        taille: '115'
    },
    {
        min: 112,
        max: 112,
        taille: '115/120'
    },
    {
        min: 113,
        max: 116,
        taille: '120'
    },
    {
        min: 117,
        max: 117,
        taille: '120/125'
    },
    {
        min: 118,
        max: 121,
        taille: '125'
    },
    {
        min: 122,
        max: 122,
        taille: '125/130'
    },
    {
        min: 123,
        max: 126,
        taille: '130'
    },
    {
        min: 127,
        max: 127,
        taille: '130/135'
    },
    {
        min: 128,
        max: 131,
        taille: '135'
    },
    {
        min: 132,
        max: 132,
        taille: '135/140'
    },
    {
        min: 133,
        max: 136,
        taille: '140'
    },
    {
        min: 137,
        max: 141,
        taille: '140/145'
    },
    {
        min: 142,
        max: 145,
        taille: '145'
    }, 
];
var tableBonnets = [
    {
        min: 1,
        max: 3,
        bonnet: 'AA/A'
    },
    {
        min: 4,
        max: 5,
        bonnet: 'A'
    },
    {
        min: 6,
        max: 6,
        bonnet: 'B/A'
    },
    {
        min: 7,
        max: 7,
        bonnet: 'B'
    },
    {
        min: 8,
        max: 8,
        bonnet: 'C/B'
    },
    {
        min: 9,
        max: 10,
        bonnet: 'C'
    },
    {
        min: 11,
        max: 11,
        bonnet: 'D/C'
    },
    {
        min: 12,
        max: 12,
        bonnet: 'D'
    },
    {
        min: 13,
        max: 13,
        bonnet: 'E/D'
    },
    {
        min: 14,
        max: 15,
        bonnet: 'E'
    },
    {
        min: 16,
        max: 16,
        bonnet: 'F/E'
    },
    {
        min: 17,
        max: 17,
        bonnet: 'F'
    },
    {
        min: 18,
        max: 18,
        bonnet: 'G/F'
    },
    {
        min: 19,
        max: 20,
        bonnet: 'G'
    },
    {
        min: 21,
        max: 21,
        bonnet: 'H/G'
    },
    {
        min: 22,
        max: 22,
        bonnet: 'H'
    },
    {
        min: 23,
        max: 23,
        bonnet: 'I/H'
    },
    {
        min: 24,
        max: 25,
        bonnet: 'I'
    },
    {
        min: 26,
        max: 26,
        bonnet: 'J/I'
    },
    {
        min: 27,
        max: 27,
        bonnet: 'J'
    },
    {
        min: 28,
        max: 28,
        bonnet: 'K/J'
    },
    {
        min: 29,
        max: 30,
        bonnet: 'K'
    },
    {
        min: 31,
        max: 31,
        bonnet: 'L/K'
    },
    {
        min: 32,
        max: 32,
        bonnet: 'L'
    }, 
];
var BraSizeGuide = function() {
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        not_tight: '',
        slightly_tight: '',
        very_tight: '',
        standing_up_straight: '',
        leaning_forward: '',
        lying_on_your_back: ''
    }), form = ref[0], setForm = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), braSize = ref1[0], setBraSize = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), calculationError = ref2[0], setCalculationError = ref2[1];
    var handleChange = function(key, value) {
        setForm(_objectSpread({}, form, _defineProperty({}, key, value)));
    };
    var handleSubmit = function(event) {
        var underbust = [
            +form.not_tight,
            +form.slightly_tight,
            +form.very_tight, 
        ].filter(function(val) {
            return !isNaN(val) && val > 0;
        });
        var bust = [
            +form.standing_up_straight,
            +form.leaning_forward,
            +form.lying_on_your_back, 
        ].filter(function(val) {
            return !isNaN(val) && val > 0;
        });
        if (underbust.length !== 3 || bust.length !== 3) {
            return;
        }
        event.preventDefault();
        var avgUnderbust = Math.round(underbust.reduce(function(a, b) {
            return a + b;
        }, 0) / 3);
        var avgBust = Math.round(bust.reduce(function(a, b) {
            return a + b;
        }, 0) / 3);
        var diff = avgBust - avgUnderbust;
        var tailleDos = tableDos.find(function(r) {
            return avgUnderbust >= r.min && avgUnderbust <= r.max;
        });
        var tailleBonnet = tableBonnets.find(function(r) {
            return diff >= r.min && diff <= r.max;
        });
        if (!tailleDos || !tailleBonnet) {
            setCalculationError('error_size_not_found');
            setBraSize(undefined);
            return;
        }
        var tailles = tailleDos.taille.split('/');
        var bonnets = tailleBonnet.bonnet.split('/');
        var taillesFinales = "".concat(tailles[0]).concat(bonnets[0]);
        setCalculationError(undefined);
        setBraSize(taillesFinales);
    };
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "contact-page ".concat(classes.root),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
            className: classes.container,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h1',
                            align: "center",
                            children: t('texts:size_guide_page.size_guide')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.question,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: t('texts:size_guide_page.question')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.inputsHeader,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h3',
                            children: t('texts:size_guide_page.measure_your_back_circumference')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page.not_tight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 72cm",
                            value: form.not_tight,
                            required: true,
                            onChange: handleChange.bind(null, 'not_tight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page.slightly_tight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 70cm",
                            value: form.slightly_tight,
                            required: true,
                            onChange: handleChange.bind(null, 'slightly_tight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page.very_tight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 68cm",
                            value: form.very_tight,
                            required: true,
                            onChange: handleChange.bind(null, 'very_tight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        className: classes.inputsHeader,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h3',
                            children: t('texts:size_guide_page.measure_your_bust')
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page.standing_up_straight'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 85cm",
                            value: form.standing_up_straight,
                            required: true,
                            onChange: handleChange.bind(null, 'standing_up_straight'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page.leaning_forward'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 87cm",
                            value: form.leaning_forward,
                            required: true,
                            onChange: handleChange.bind(null, 'leaning_forward'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            label: t('texts:size_guide_page.lying_on_your_back'),
                            type: "number",
                            name: "email",
                            placeholder: "ex: 84cm",
                            value: form.lying_on_your_back,
                            required: true,
                            onChange: handleChange.bind(null, 'lying_on_your_back'),
                            noLabelPaddingLeft: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        className: classes.alignCenter,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            type: "submit",
                            variant: 'contained',
                            color: 'secondary',
                            onClick: handleSubmit,
                            className: classes.submitButton,
                            children: t('texts:size_guide_page.calculate_size')
                        })
                    }),
                    calculationError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        className: classes.alignCenter,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'body1',
                            className: classes.error,
                            children: t("texts:size_guide_page.".concat(calculationError))
                        })
                    }),
                    braSize && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        className: classes.braSizeContainer,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            variant: 'h3',
                            align: "center",
                            className: classes.braSizeInfo,
                            children: [
                                "✨ ",
                                t('texts:size_guide_page.bra_size'),
                                ": ",
                                braSize,
                                " ✨"
                            ]
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BraSizeGuide);


/***/ }),

/***/ 64060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useFilterDrawerStyles; }
/* harmony export */ });
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75154);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useFilterDrawerStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        drawer: {
            '& .MuiPaper-root': _defineProperty({
                width: 400
            }, theme.breakpoints.down('sm'), {
                width: '100%'
            })
        },
        drawerContainer: {
            width: '100%',
            backgroundColor: theme.palette.common.white,
            height: '100%'
        },
        /** Combined with header/footer via `&$anchoredRight` so position overrides win over `left: 0`. */ anchoredRight: {},
        header: _defineProperty({
            height: 50,
            width: 400,
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 30,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'center',
            padding: theme.spacing(2),
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
            backgroundColor: theme.palette.common.white,
            '&$anchoredRight': {
                left: 'auto',
                right: 0
            }
        }, theme.breakpoints.down('sm'), {
            width: '100%'
        }),
        subItem: {
            paddingLeft: theme.spacing(2)
        },
        footer: _defineProperty({
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: 400,
            height: 50,
            boxShadow: theme.shadows[1],
            backgroundColor: theme.palette.common.white,
            alignContent: 'center',
            display: 'flex',
            justifyContent: 'center',
            '&$anchoredRight': {
                left: 'auto',
                right: 0
            }
        }, theme.breakpoints.down('sm'), {
            width: '100%'
        }),
        return_btn: {
            margin: theme.spacing(1)
        },
        filterListItem: {
            marginTop: 50,
            cursor: 'pointer',
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            justifyContent: 'space-between',
            display: 'flex',
            alignContent: 'center',
            fontSize: 14,
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
            '&:active': {
                backgroundColor: theme.extraColors.greyLight
            }
        },
        breadcrumb: {
            backgroundColor: theme.palette.common.white,
            fontSize: 14,
            display: 'flex',
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight)
        },
        loaderContainer: {
            height: 200,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        activeFilter: {
            fontSize: 14
        },
        activeFilterText: {
            fontWeight: 700
        },
        taxonTitle: {
            fontSize: 14,
            lineHeight: '10px'
        },
        margin: {
            marginBottom: theme.spacing(3)
        },
        resetButton: {
            margin: theme.spacing(1),
            padding: theme.spacing(2),
            color: theme.extraColors.greyText,
            fontSize: 12,
            fontWeight: 400,
            width: '50%',
            whiteSpace: 'nowrap',
            '& .MuiSvgIcon-root': {
                width: '.75em',
                height: '.75em',
                marginRight: theme.spacing(1)
            }
        },
        applyButton: {
            fontSize: 12,
            padding: theme.spacing(2),
            margin: theme.spacing(1),
            width: '50%'
        },
        filterContainer: {
            marginTop: 50
        },
        filterBy_text: {
            color: theme.extraColors.greyText,
            fontSize: 10,
            marginLeft: theme.spacing(1)
        },
        sortSection: {
            padding: theme.spacing(2, 2, 1),
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
            '& .MuiFormControlLabel-root': {
                marginLeft: 0,
                marginRight: 0
            },
            '& .MuiFormControlLabel-label': {
                fontSize: 14
            }
        },
        sortTitle: {
            fontWeight: 700,
            fontSize: 14,
            marginBottom: theme.spacing(1)
        },
        filterTitleSection: {
            padding: theme.spacing(2, 2, 1)
        },
        transition: {
            animation: 'fadeIn 1s'
        },
        '@keyframes fadeIn': {
            '0%': {
                opacity: 0
            },
            '100%': {
                opacity: 1
            }
        },
        help: {
            cursor: 'pointer',
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            fontSize: 14,
            display: 'flex',
            alignItems: 'center',
            marginLeft: -theme.spacing(1)
        }
    });
});


/***/ }),

/***/ 75060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ hasAboveProductDescriptionText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);





var getProductData = function(productSettings) {
    var ref;
    if (!productSettings) return undefined;
    if ('above_product_description_text' in productSettings) {
        return productSettings;
    }
    return (ref = productSettings) === null || ref === void 0 ? void 0 : ref.data;
};
var AboveProductDescriptionText = function(param) {
    var productSettings = param.productSettings, className = param.className;
    var ref;
    var text = (ref = getProductData(productSettings)) === null || ref === void 0 ? void 0 : ref.above_product_description_text;
    if (!(0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* .isPrismicText */ .LT)(text)) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        component: "div",
        variant: "caption",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('above-product-description-text', className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            data: text
        })
    }));
};
var hasAboveProductDescriptionText = function(productSettings) {
    var ref;
    return (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* .isPrismicText */ .LT)((ref = getProductData(productSettings)) === null || ref === void 0 ? void 0 : ref.above_product_description_text);
};
/* harmony default export */ __webpack_exports__["Z"] = (AboveProductDescriptionText);


/***/ }),

/***/ 3977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22318);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31520);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43929);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94455);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);









var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        root: {
            width: '100%',
            position: 'relative',
            zIndex: 1
        }
    });
});
var LoginToSeePriceRow = function(param) {
    var text = param.text, customClasses = param.customClasses;
    var classes = useStyles();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var registerHref = "/register?redirect=".concat(encodeURIComponent(router.asPath));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classes.root, 'login_to_see_price_row', customClasses),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            container: true,
            direction: "column",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    item: true,
                    className: "login_to_see_price_row__title_grid",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        variant: "h5",
                        component: "p",
                        className: "login_to_see_price_row__title",
                        children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.login_to_see_price, t('texts:account:login_to_see_price'))
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    item: true,
                    className: "login_to_see_price_row__link_grid",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        href: registerHref,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: registerHref,
                            className: "login_to_see_price_row__link",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                component: "span",
                                variant: "contained",
                                color: "secondary",
                                children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.login_button, t('texts:account:login_button'))
                            })
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginToSeePriceRow);


/***/ }),

/***/ 30327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useProductStyles; }
/* harmony export */ });
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75154);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useProductStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        prev: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        main: {
            paddingTop: theme.spacing(3)
        },
        carouselMain: {
            margin: theme.spacing(0, 0, 3)
        },
        carouselThumbs: {
            '& .glider.draggable': {
                cursor: 'default'
            }
        },
        carouselThumbsSmall: {
            '& .glider-prev': {
                left: theme.spacing(2)
            },
            '& .glider-next': {
                right: theme.spacing(2)
            }
        },
        carouselThumb: {
            opacity: 1,
            transition: theme.transitions.create('opacity'),
            '&:hover, &:focus': {
                opacity: 0.5,
                cursor: 'pointer'
            }
        },
        carouselThumbCurrent: {
            opacity: 0.5
        },
        carouselThumbsImg: {
            borderRadius: theme.shape.borderRadius,
            cursor: 'pointer'
        },
        mediaMain: {
            borderRadius: theme.shape.borderRadius
        },
        mediaGap: _defineProperty({
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up('md'), {
            marginBottom: theme.spacing(4)
        }),
        content: {
            marginTop: theme.spacing(2)
        },
        contentSticky: (_obj = {}, _defineProperty(_obj, theme.breakpoints.down('md'), {
            zIndex: theme.zIndex.snackbar,
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            padding: theme.spacing(2, 2, 1),
            background: theme.palette.common.white,
            borderTop: "1px solid ".concat(theme.extraColors.greyLight)
        }), _defineProperty(_obj, theme.breakpoints.up('md'), {
            position: 'sticky',
            top: theme.sizes.headerHeight + theme.spacing(2)
        }), _obj),
        contentDetailsSticky: _defineProperty({}, theme.breakpoints.down('md'), {
            marginTop: 0
        }),
        desc: {
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2)
        },
        smallText: {
            fontSize: '75%'
        },
        selectors: {
            display: 'flex',
            justifyContent: 'flex-start'
        },
        loadingImg: {
            display: 'block',
            maxWidth: '100%',
            height: 480,
            borderRadius: theme.shape.borderRadius
        },
        loadingTitle: {
            margin: theme.spacing(0, 0, 3)
        },
        loadingBtn: {
            display: 'inline-block',
            margin: theme.spacing(3, 0),
            height: theme.spacing(6),
            borderRadius: theme.spacing(3)
        },
        related: _defineProperty({
            padding: theme.spacing(2, 0)
        }, theme.breakpoints.up('md'), {
            padding: theme.spacing(1, 0, 6)
        }),
        relatedTitle: {
            margin: theme.spacing(0, 0, 2)
        },
        col: {},
        md5: _defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        }),
        associationRow: {
            marginBottom: theme.spacing(3)
        },
        priceSmall: {},
        breadCrumbActiveItem: {
            fontWeight: 600,
            cursor: 'pointer'
        },
        productLeft: {
            position: 'relative'
        },
        productMainStickyLayout: _defineProperty({}, theme.breakpoints.up('md'), {
            alignItems: 'flex-start'
        }),
        productLeftSticky: _defineProperty({}, theme.breakpoints.up('md'), {
            position: 'sticky',
            top: theme.sizes.headerHeight + theme.spacing(2),
            alignSelf: 'flex-start',
            zIndex: 1
        }),
        likeButton: {
            position: 'absolute',
            top: theme.spacing(4),
            right: theme.spacing(4),
            zIndex: 10
        },
        reservationEnabled: {
            display: 'flex',
            flexDirection: 'column'
        }
    });
});


/***/ }),

/***/ 48833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Products_ProductTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./components/Shop/ProductPriceFormat.tsx
var ProductPriceFormat = __webpack_require__(45006);
// EXTERNAL MODULE: ./components/Shop/BuyAbleMention.tsx
var BuyAbleMention = __webpack_require__(3539);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Info.js
var Info = __webpack_require__(18362);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./utils/evaluateCondition.ts
var evaluateCondition = __webpack_require__(4676);
;// CONCATENATED MODULE: ./components/Products/ProductTag.tsx







var CHIP_COLORS = [
    'default',
    'primary',
    'secondary',
    'success',
    'info',
    'warning',
    'error', 
];
var resolveChipColor = function(value) {
    if (!value) return 'default';
    var lowerCased = value.toLowerCase();
    return CHIP_COLORS.includes(lowerCased) ? lowerCased : 'default';
};
var ProductTag = function(param) {
    var text = param.text, color = param.color, icon = param.icon, condition = param.condition, data = param.data;
    var label = (0,CMSText/* prismicText */.yz)(text);
    if (!label) return null;
    var chipColor = resolveChipColor(color);
    var shouldDisplay = (0,evaluateCondition/* evaluateCondition */.m)(condition, {
        data: data || {}
    });
    if (!shouldDisplay) return null;
    var chipAvatar = (icon === null || icon === void 0 ? void 0 : icon.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
        src: icon.url,
        alt: icon.alt || label,
        className: "product-dynamic-tag__avatar"
    }) : undefined;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        item: true,
        sm: "auto",
        className: "product-dynamic-tag",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            label: label,
            color: chipColor,
            avatar: chipAvatar,
            className: "product-dynamic-tag__chip"
        })
    }));
};
/* harmony default export */ var Products_ProductTag = (ProductTag);

;// CONCATENATED MODULE: ./components/Products/ProductTitle.tsx














function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/**
 * Vaude only : the "Auswahl" (code `selection`) attribute carries the
 * "B-Ware" value for second-choice items. We display the attribute value
 * as-is so the label follows what is set in the back-office.
 */ var VAUDE_SELECTION_ATTRIBUTE_CODES = [
    'selection',
    'auswahl'
];
var VAUDE_B_WARE_VALUE = 'b-ware';
var getVaudeBWareLabel = function(currentItem) {
    var ref2;
    if (false) {}
    var ref1;
    var attributes = (ref1 = currentItem === null || currentItem === void 0 ? void 0 : currentItem.attributes) !== null && ref1 !== void 0 ? ref1 : [];
    var selection = attributes.find(function(attr) {
        var ref;
        return VAUDE_SELECTION_ATTRIBUTE_CODES.includes(attr === null || attr === void 0 ? void 0 : (ref = attr.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
    });
    return selection === null || selection === void 0 ? void 0 : (ref2 = selection.value) === null || ref2 === void 0 ? void 0 : ref2.find(function(value) {
        return (value === null || value === void 0 ? void 0 : value.toLowerCase()) === VAUDE_B_WARE_VALUE;
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        head: {
            marginBottom: theme.spacing(2)
        },
        headNoPaddingTop: {
            paddingTop: 0
        },
        headSticky: {
            marginBottom: theme.spacing(0.5)
        },
        secondHandHead: {
            '& .MuiGrid-item': {
                maxWidth: '100%',
                flexBasis: '100%'
            }
        },
        rentalDuration: {
            display: 'flex',
            '& .paragraph-class': {
                margin: 0
            }
        },
        content: {
            marginTop: theme.spacing(2)
        },
        contentSticky: (_obj = {}, _defineProperty(_obj, theme.breakpoints.down('md'), {
            zIndex: theme.zIndex.snackbar,
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            padding: theme.spacing(2, 2, 1),
            background: theme.palette.common.white,
            borderTop: "1px solid ".concat(theme.extraColors.greyLight)
        }), _defineProperty(_obj, theme.breakpoints.up('md'), {
            position: 'sticky',
            top: theme.sizes.headerHeight + theme.spacing(2)
        }), _obj),
        contentDetailsSticky: _defineProperty({}, theme.breakpoints.down('md'), {
            marginTop: 0
        }),
        desc: {
            marginBottom: theme.spacing(2)
        },
        verticalAlign: {
            display: 'inline-flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            '&>.MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            }
        },
        labelReference: {
            marginBottom: theme.spacing(2)
        }
    });
});
var ProductTitle = function(param) {
    var productLayout = param.productLayout, isMobile = param.isMobile, currentItem = param.currentItem, addFromPack = param.addFromPack, promotions = param.promotions, minPrice = param.minPrice, takeBackPrice = param.takeBackPrice, main = param.main, isBuyableProduct = param.isBuyableProduct, discountPriceFormat = param.discountPriceFormat, selectedTakeBackOrRental = param.selectedTakeBackOrRental, takeback = param.takeback, displayFlexPrice = param.displayFlexPrice, isDisplayTotalRentPrice = param.isDisplayTotalRentPrice, productSettings = param.productSettings, dayRange = param.dayRange, currentPromotion = param.currentPromotion, selectedQuality = param.selectedQuality, originalPrice = param.originalPrice, takeBackPriceMin = param.takeBackPriceMin, takeBackPriceMinTtc = param.takeBackPriceMinTtc, takeBackAvailability = param.takeBackAvailability, _isDisplayedPrice = param.isDisplayedPrice, isDisplayedPrice = _isDisplayedPrice === void 0 ? true : _isDisplayedPrice, isSecondHand = param.isSecondHand, _isModal = param.isModal, isModal = _isModal === void 0 ? false : _isModal, _displayProductState = param.displayProductState, displayProductState = _displayProductState === void 0 ? true : _displayProductState, productTaxons = param.productTaxons, userIsLoggedIn = param.userIsLoggedIn;
    var ref, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var productClasses = useStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var taxonPromotion = (0,utils/* getProductTaxonPromotion */.jt)(promotions, productTaxons);
    var effectivePromotion = currentPromotion !== null && currentPromotion !== void 0 ? currentPromotion : taxonPromotion;
    var bWareLabel = getVaudeBWareLabel(currentItem);
    var _obj;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                className: (0,clsx_m/* default */.Z)('product__head', productClasses.head, (_obj = {}, _defineProperty(_obj, productClasses.headNoPaddingTop, isModal), _defineProperty(_obj, 'product__head__modal', isModal), _defineProperty(_obj, productClasses.headSticky, productLayout && isMobile), _defineProperty(_obj, productClasses.secondHandHead, selectedTakeBackOrRental === 1 || isSecondHand && !constants/* isSecondHandOnly */.G7), _obj)),
                alignItems: "center",
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        sm: "auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                component: "h1",
                                className: (0,clsx_m/* default */.Z)('product__title'),
                                children: currentItem.name
                            }),
                            selectedTakeBackOrRental === 1 && displayProductState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                component: "div",
                                className: (0,clsx_m/* default */.Z)('product__state'),
                                children: bWareLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product__state__b-ware",
                                    children: bWareLabel
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.second_hand_label,
                                    defaultText: t('texts:takeBack:second_hand_label')
                                })
                            }),
                            (productSettings === null || productSettings === void 0 ? void 0 : (ref3 = productSettings.data) === null || ref3 === void 0 ? void 0 : ref3.display_label_reference) && (currentItem === null || currentItem === void 0 ? void 0 : currentItem.stickerReference) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                component: "div",
                                className: (0,clsx_m/* default */.Z)('product__label-reference', productClasses.labelReference),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: productSettings === null || productSettings === void 0 ? void 0 : (ref4 = productSettings.data) === null || ref4 === void 0 ? void 0 : ref4.label_reference_text,
                                        defaultText: t('texts:productPage:label_reference')
                                    }),
                                    ' : ',
                                    currentItem.stickerReference
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Products_ProductTag, {
                        text: productSettings === null || productSettings === void 0 ? void 0 : (ref5 = productSettings.data) === null || ref5 === void 0 ? void 0 : ref5.product_tag_text,
                        color: "warning",
                        icon: productSettings === null || productSettings === void 0 ? void 0 : (ref6 = productSettings.data) === null || ref6 === void 0 ? void 0 : ref6.product_tag_icon,
                        condition: productSettings === null || productSettings === void 0 ? void 0 : (ref7 = productSettings.data) === null || ref7 === void 0 ? void 0 : ref7.show_product_tag_condition,
                        data: currentItem
                    }),
                     true && (isDisplayedPrice || isDisplayedPrice === null) && currentItem && (currentItem === null || currentItem === void 0 ? void 0 : currentItem.variants) && !addFromPack && (constants/* hidePricingOnGhostUser */.FB && userIsLoggedIn || !constants/* hidePricingOnGhostUser */.FB) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !constants/* displayTtcAndHtPrice */.r4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            sm: "auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: isMobile ? 'h4' : 'h3',
                                component: "div",
                                className: (0,clsx_m/* default */.Z)(productClasses.verticalAlign, 'product__price'),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceFormat/* default */.Z, {
                                        promotions: promotions,
                                        priceMin: minPrice,
                                        takeBackPrice: takeBackPrice,
                                        settings: main === null || main === void 0 ? void 0 : main.data,
                                        isBuyableProduct: isBuyableProduct,
                                        discountPriceFormat: discountPriceFormat,
                                        isDisplayPercentage: true,
                                        classe: 'product',
                                        selectedTakeBackOrRental: selectedTakeBackOrRental,
                                        takeback: takeback,
                                        selectedQuality: selectedQuality,
                                        originalPrice: originalPrice,
                                        productSettings: productSettings,
                                        takeBackPriceMin: takeBackPriceMin,
                                        takeBackAvailability: takeBackAvailability,
                                        variants: Object.values(currentItem.variants),
                                        productTaxons: productTaxons
                                    }),
                                    isBuyableProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyAbleMention/* default */.Z, {
                                        buyAbleMention: main === null || main === void 0 ? void 0 : (ref8 = main.data) === null || ref8 === void 0 ? void 0 : ref8.display_buyable_mention
                                    }),
                                    displayFlexPrice && !isBuyableProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)(productClasses.verticalAlign, 'product__information'),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                    title: t('texts:general:flex_price_information'),
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                        fontSize: "small"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            direction: "column",
                            sm: "auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: isMobile ? 'h4' : 'h3',
                                component: "div",
                                className: (0,clsx_m/* default */.Z)(productClasses.verticalAlign, 'product__price'),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceFormat/* default */.Z, {
                                        promotions: promotions,
                                        priceMin: minPrice,
                                        takeBackPrice: takeBackPriceMin,
                                        settings: main === null || main === void 0 ? void 0 : main.data,
                                        isBuyableProduct: isBuyableProduct,
                                        discountPriceFormat: discountPriceFormat,
                                        isDisplayPercentage: true,
                                        classe: 'product',
                                        selectedTakeBackOrRental: selectedTakeBackOrRental,
                                        takeback: takeback,
                                        selectedQuality: selectedQuality,
                                        originalPrice: originalPrice,
                                        productSettings: productSettings,
                                        takeBackPriceMin: takeBackPriceMin,
                                        takeBackAvailability: takeBackAvailability,
                                        variants: Object.values(currentItem.variants),
                                        afterCurrency: ' ' + t('texts:general:vat:excluded'),
                                        productTaxons: productTaxons
                                    }),
                                    isBuyableProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyAbleMention/* default */.Z, {
                                        buyAbleMention: main === null || main === void 0 ? void 0 : (ref9 = main.data) === null || ref9 === void 0 ? void 0 : ref9.display_buyable_mention
                                    }),
                                    displayFlexPrice && !isBuyableProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (0,clsx_m/* default */.Z)(productClasses.verticalAlign, 'product__information'),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                    title: t('texts:general:flex_price_information'),
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                                        fontSize: "small"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            isDisplayTotalRentPrice && !isBuyableProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)('product__rent-total', productClasses.rentalDuration),
                        component: 'div',
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: productSettings === null || productSettings === void 0 ? void 0 : (ref10 = productSettings.data) === null || ref10 === void 0 ? void 0 : ref10.total_rental_price_text
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                amount: effectivePromotion ? (minPrice - minPrice * effectivePromotion / 100) * dayRange : minPrice * dayRange,
                                buyAble: isBuyableProduct
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: productSettings === null || productSettings === void 0 ? void 0 : (ref11 = productSettings.data) === null || ref11 === void 0 ? void 0 : ref11.total_rental_price_for,
                                defaultText: t('texts:basket:for_short')
                            }),
                            "\xa0",
                            dayRange,
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: dayRange > 1 ? productSettings === null || productSettings === void 0 ? void 0 : (ref12 = productSettings.data) === null || ref12 === void 0 ? void 0 : ref12.total_rental_price_day_plural : productSettings === null || productSettings === void 0 ? void 0 : (ref13 = productSettings.data) === null || ref13 === void 0 ? void 0 : ref13.total_rental_price_day_singular,
                                defaultText: dayRange > 1 ? t('texts:general:days_plural') : t('texts:general:day_singular')
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
var mapStateToProps = function(state) {
    return {
        userIsLoggedIn: state.user.isLoggedIn
    };
};
var mapDispatchToProps = {};
/* harmony default export */ var Products_ProductTitle = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(ProductTitle));


/***/ }),

/***/ 8717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80366);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31567);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95477);
/* harmony import */ var _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20031);









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    var ref;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        paper: {
            borderRadius: 16,
            padding: theme.spacing(4),
            maxWidth: 420
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: theme.spacing(2)
        },
        title: {
            fontWeight: 700
        },
        body: {
            marginBottom: theme.spacing(2),
            color: (ref = theme.palette.common) === null || ref === void 0 ? void 0 : ref.black
        },
        expirationDate: {
            fontWeight: 700,
            marginBottom: theme.spacing(3)
        },
        errorText: {
            color: theme.palette.error.main,
            marginBottom: theme.spacing(2)
        },
        confirmButton: {
            width: '100%',
            position: 'relative',
            minHeight: 45,
            padding: theme.spacing(1.5),
            marginBottom: theme.spacing(1)
        },
        cancelButton: {
            width: '100%',
            textTransform: 'none',
            fontWeight: 600
        }
    });
});
/** Adds `days` business days to `startDate`, skipping weekends and the given holiday dates. */ function addBusinessDays(startDate, days, holidays) {
    var result = new Date(startDate);
    var added = 0;
    while(added < days){
        result.setDate(result.getDate() + 1);
        var dayOfWeek = result.getDay();
        var isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
        var dateStr = result.toISOString().split('T')[0];
        var isHoliday = holidays.has(dateStr);
        if (!isWeekend && !isHoliday) {
            added++;
        }
    }
    return result;
}
var ReservationConfirmModal = function(param) {
    var open = param.open, onClose = param.onClose, onConfirm = param.onConfirm, loading = param.loading, reservationDays = param.reservationDays, error = param.error;
    var classes = useStyles();
    var ref3 = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(), t = ref3.t, i18n = ref3.i18n;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Set()), holidays = ref1[0], setHolidays = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var fetchHolidays = function() {
            var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var currentYear, ref, resNow, resNext, ref2, dataNow, dataNext, allHolidays;
                return _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            currentYear = new Date().getFullYear();
                            _ctx.t0 = _slicedToArray;
                            _ctx.next = 5;
                            return Promise.all([
                                fetch("".concat(_redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.apiGouvFr */ .KU.apiGouvFr, "/").concat(currentYear, ".json")),
                                fetch("".concat(_redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.apiGouvFr */ .KU.apiGouvFr, "/").concat(currentYear + 1, ".json")), 
                            ]);
                        case 5:
                            _ctx.t1 = _ctx.sent;
                            ref = (0, _ctx.t0)(_ctx.t1, 2);
                            resNow = ref[0];
                            resNext = ref[1];
                            _ctx.t2 = _slicedToArray;
                            _ctx.next = 12;
                            return Promise.all([
                                resNow.json(),
                                resNext.json(), 
                            ]);
                        case 12:
                            _ctx.t3 = _ctx.sent;
                            ref2 = (0, _ctx.t2)(_ctx.t3, 2);
                            dataNow = ref2[0];
                            dataNext = ref2[1];
                            allHolidays = new Set(_toConsumableArray(Object.keys(dataNow)).concat(_toConsumableArray(Object.keys(dataNext))));
                            setHolidays(allHolidays);
                            _ctx.next = 23;
                            break;
                        case 20:
                            _ctx.prev = 20;
                            _ctx.t4 = _ctx["catch"](0);
                            console.error('Error fetching public holidays:', _ctx.t4);
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        20
                    ]
                ]);
            }));
            return function fetchHolidays() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchHolidays();
    }, []);
    var expirationDate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var date = addBusinessDays(new Date(), reservationDays, holidays);
        return new Intl.DateTimeFormat(i18n.language, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }, [
        reservationDays,
        i18n.language,
        holidays
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        PaperProps: {
            className: classes.paper
        },
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        variant: "h6",
                        className: classes.title,
                        children: t('texts:reservations:confirm_title')
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        size: "small",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                variant: "body2",
                className: classes.body,
                children: t('texts:reservations:confirm_body', {
                    days: reservationDays
                })
            }),
            expirationDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                variant: "body2",
                className: classes.expirationDate,
                children: [
                    t('texts:reservations:confirm_expiration'),
                    ' : ',
                    expirationDate
                ]
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                variant: "body2",
                className: classes.errorText,
                children: error === 409 ? t('texts:reservations:confirm_error_conflict') : t('texts:reservations:confirm_error')
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: classes.confirmButton,
                color: "primary",
                variant: "contained",
                onClick: onConfirm,
                disabled: loading,
                style: {
                    position: 'relative'
                },
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    size: '1.5em',
                    color: "inherit"
                }) : t('texts:reservations:confirm_cta')
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: classes.cancelButton,
                onClick: onClose,
                children: t('texts:reservations:confirm_cancel')
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ReservationConfirmModal);


/***/ }),

/***/ 3539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);





var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        buyAbleMention: {
            fontWeight: 400,
            fontSize: '80%'
        }
    });
});
var BuyAbleMention = function(param) {
    var buyAbleMention = param.buyAbleMention;
    var classes = useStyles();
    var mention = (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* .prismicText */ .yz)(buyAbleMention);
    return (mention === null || mention === void 0 ? void 0 : mention.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('buyAbleMention', classes.buyAbleMention),
        children: mention
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (BuyAbleMention);


/***/ }),

/***/ 18496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Shop_ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./components/Shop/QuantitySelector.tsx
var QuantitySelector = __webpack_require__(83230);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/Sizes/SizeModal.tsx + 4 modules
var SizeModal = __webpack_require__(26035);
// EXTERNAL MODULE: ./typings/base.ts
var base = __webpack_require__(88039);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./utils/addToCart.tsx
var addToCart = __webpack_require__(63226);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Shop/Shop.style.tsx
var Shop_style = __webpack_require__(45889);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./components/Shop/ProductPriceFormat.tsx
var ProductPriceFormat = __webpack_require__(45006);
// EXTERNAL MODULE: ./components/Shop/BuyAbleMention.tsx
var BuyAbleMention = __webpack_require__(3539);
;// CONCATENATED MODULE: ./components/Shop/ProductCardPrice.tsx








var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        price: {
            fontWeight: 700,
            marginTop: theme.spacing(1)
        },
        priceSecondHand: {
            marginTop: 0
        }
    });
});
var ProductCardPrice = function(param) {
    var priceMin = param.priceMin, isDisplayedPrice = param.isDisplayedPrice, secondHandAvailability = param.secondHandAvailability, isSecondHand = param.isSecondHand, takeback = param.takeback, promotions = param.promotions, productIsSecondHand = param.productIsSecondHand, availability = param.availability, isSecondHandTaxon = param.isSecondHandTaxon, settings = param.settings, isBuyableProduct = param.isBuyableProduct, discountPriceFormat = param.discountPriceFormat, _type = param._type, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, productTaxons = param.productTaxons;
    var ref;
    var layoutStyle = {
        isDisplayedPrice: isDisplayedPrice || isDisplayedPrice === null
    };
    var classes = useStyles(layoutStyle);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var afterCurrency = _type ? ' ' + (_type === 'ht' ? t('texts:general:vat:excluded') : t('texts:general:vat:included')) : null;
    if (priceMin === 0 || isDisplayedPrice !== true && isDisplayedPrice !== null) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !hideLabel && secondHandAvailability && isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "productCard__price_start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: takeback === null || takeback === void 0 ? void 0 : (ref = takeback.data) === null || ref === void 0 ? void 0 : ref.price_start,
                    defaultText: t('texts:takeBack:price_start')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                noWrap: true,
                variant: "body2",
                color: 'secondary',
                className: (0,clsx_m/* default */.Z)('productCard__price', classes.price, secondHandAvailability && isSecondHand && [
                    classes.priceSecondHand,
                    'productCard__price--second-hand', 
                ], _type === 'ttc' && 'productCard__price--ttc'),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceFormat/* default */.Z, {
                        promotions: promotions,
                        isSecondHand: !!productIsSecondHand,
                        avalableForRentalAndSecondHand: availability && secondHandAvailability,
                        isDisplayPercentage: true,
                        isSecondHandTaxon: isSecondHandTaxon,
                        priceMin: priceMin,
                        settings: settings,
                        isBuyableProduct: isBuyableProduct,
                        discountPriceFormat: discountPriceFormat,
                        classe: 'productCard',
                        afterCurrency: afterCurrency,
                        productTaxons: productTaxons
                    }),
                    isBuyableProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyAbleMention/* default */.Z, {
                        buyAbleMention: settings === null || settings === void 0 ? void 0 : settings.display_buyable_mention
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Shop_ProductCardPrice = (ProductCardPrice);

// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
// EXTERNAL MODULE: ./utils/filters.tsx
var filters = __webpack_require__(92412);
// EXTERNAL MODULE: ./node_modules/react-glider/dist/index.js
var dist = __webpack_require__(76142);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(53557);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(38579);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Add.js
var Add = __webpack_require__(63957);
;// CONCATENATED MODULE: ./components/Shop/ProductCardAddToCart.tsx







var ProductCardAddToCart = function(param) {
    var hidePrice = param.hidePrice, availability = param.availability, secondHandAvailability = param.secondHandAvailability, product = param.product, addButton = param.addButton, classes = param.classes, index = param.index, setOpenModalAndTrack = param.setOpenModalAndTrack, openModal = param.openModal, stock = param.stock, setOpenModal = param.setOpenModal, shopData = param.shopData, cart = param.cart, addProductWithSize = param.addProductWithSize, thumbRatio = param.thumbRatio, thumbWidth = param.thumbWidth, settings = param.settings, currentUrl = param.currentUrl, quantity = param.quantity, onQuantityChange = param.onQuantityChange, isSecondHandTaxon = param.isSecondHandTaxon, takeback = param.takeback, takeBackLP = param.takeBackLP, productSettings = param.productSettings;
    var closeSizesModal = function() {
        setOpenModal(false);
    };
    return !hidePrice && (availability && product && addButton && typeof product.variants !== 'undefined' && Object.keys(product.variants).length > 1 || isSecondHandTaxon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('productCard__add', classes.more),
        id: "add_button",
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                "data-testid": "buttonOpenModale-".concat(index),
                variant: "contained",
                className: availability ? (0,clsx_m/* default */.Z)('productCard__cta', classes.addButton) : (0,clsx_m/* default */.Z)('productCard__cta', classes.addButtonDisabled),
                disabled: !availability,
                onClick: setOpenModalAndTrack,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeModal/* default */.Z, {
                open: openModal,
                stock: stock,
                handleClose: closeSizesModal,
                products: product,
                text: shopData,
                type: 'product',
                cart: cart,
                onQuantityChange: addProductWithSize,
                thumbRatio: thumbRatio,
                thumbWidth: thumbWidth,
                settings: settings,
                currentUrl: currentUrl,
                isSecondHandTaxon: isSecondHandTaxon,
                secondHandAvailability: secondHandAvailability,
                takeback: takeback,
                takeBackLP: takeBackLP,
                productSettings: productSettings
            })
        ]
    }) : /* Product has 1 variant */ availability && addButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (settings === null || settings === void 0 ? void 0 : settings.has_quantity_selector) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)('productCard__add', classes.more),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                small: true,
                disable: cart.loading,
                value: quantity,
                handleChange: onQuantityChange,
                min: 0,
                max: (product === null || product === void 0 ? void 0 : product.variants[Object.keys(product === null || product === void 0 ? void 0 : product.variants)[0]].maxStock) ? product === null || product === void 0 ? void 0 : product.variants[Object.keys(product === null || product === void 0 ? void 0 : product.variants)[0]].maxStock : null,
                variantSku: product === null || product === void 0 ? void 0 : product.variants[Object.keys(product === null || product === void 0 ? void 0 : product.variants)[0]].sku
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)('productCard__add', classes.more),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    "data-testid": "buttonOpenModale-".concat(index),
                    variant: "contained",
                    className: availability ? (0,clsx_m/* default */.Z)('productCard__cta', classes.addButton) : (0,clsx_m/* default */.Z)('productCard__cta', classes.addButtonDisabled),
                    disabled: !availability,
                    onClick: function() {
                        return onQuantityChange(quantity + 1);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {})
                })
            })
        })
    }));
};
/* harmony default export */ var Shop_ProductCardAddToCart = (ProductCardAddToCart);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Favorite.js
var Favorite = __webpack_require__(76324);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FavoriteBorder.js
var FavoriteBorder = __webpack_require__(28106);
// EXTERNAL MODULE: ./redux/actions/wishList.ts + 1 modules
var wishList = __webpack_require__(94624);
;// CONCATENATED MODULE: ./utils/touchHandlers.ts
var createLongPressHandler = function(onLongPress) {
    var pressThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 400;
    var startTime;
    var touchStartX;
    var touchStartY;
    var touchMoveHandler;
    var touchEndHandler;
    var contextMenuHandler;
    var longPressTimeout;
    var handleTouchStart = function(e1) {
        // Prevent context menu immediately
        e1.preventDefault();
        var touch1 = e1.touches[0];
        startTime = Date.now();
        touchStartX = touch1.clientX;
        touchStartY = touch1.clientY;
        // Set up timeout to trigger long press
        longPressTimeout = setTimeout(function() {
            onLongPress === null || onLongPress === void 0 ? void 0 : onLongPress();
        }, pressThreshold);
        touchMoveHandler = function(e) {
            var touch = e.touches[0];
            var deltaX = Math.abs(touch.clientX - touchStartX);
            var deltaY = Math.abs(touch.clientY - touchStartY);
            // If user moved more than 10px, cancel the long press
            if (deltaX > 10 || deltaY > 10) {
                cleanup();
            }
        };
        touchEndHandler = function() {
            cleanup();
        };
        contextMenuHandler = function(e) {
            e.preventDefault();
        };
        document.addEventListener('touchmove', touchMoveHandler, {
            passive: false
        });
        document.addEventListener('touchend', touchEndHandler);
        document.addEventListener('contextmenu', contextMenuHandler);
    };
    var cleanup = function() {
        clearTimeout(longPressTimeout);
        document.removeEventListener('touchmove', touchMoveHandler);
        document.removeEventListener('touchend', touchEndHandler);
        document.removeEventListener('contextmenu', contextMenuHandler);
    };
    return {
        onTouchStart: handleTouchStart
    };
};

;// CONCATENATED MODULE: ./hooks/useIntersectionObserver.ts

var useIntersectionObserver = function(callback, isMobile) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };
    var ref = (0,react.useState)(null), element = ref[0], setElement = ref[1];
    var observer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!element || !isMobile) return;
        observer.current = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                callback(entry.isIntersecting);
            });
        }, options);
        observer.current.observe(element);
        return function() {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [
        element,
        callback,
        options,
        isMobile
    ]);
    return isMobile ? setElement : undefined;
};

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/taxPricing.ts
var taxPricing = __webpack_require__(59973);
// EXTERNAL MODULE: ./redux/actions/reservations.ts + 1 modules
var reservations = __webpack_require__(92324);
// EXTERNAL MODULE: ./components/Reservations/ReservationConfirmModal.tsx
var ReservationConfirmModal = __webpack_require__(8717);
// EXTERNAL MODULE: ./components/Products/LoginToSeePriceRow.tsx
var LoginToSeePriceRow = __webpack_require__(3977);
;// CONCATENATED MODULE: ./components/Shop/ProductCard.tsx





































function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ProductCard_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        loginToSeePriceRow: {
            '& .login_to_see_price_row__link_grid > a > span': {
                width: '100%'
            }
        },
        thumb: {
            borderRadius: theme.shape.borderRadius / 2,
            '&:not([src])': {
                background: theme.extraColors.greyLight,
                content: 'url("data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==")'
            }
        },
        fullWidth: {
            width: '100%',
            marginTop: '30px!important'
        },
        title: _defineProperty({
            minHeight: 33,
            fontSize: theme.typography.pxToRem(14),
            lineHeight: 1.2,
            textTransform: 'capitalize',
            '&>a': {
                color: 'inherit',
                textDecoration: 'none',
                '&:before': {
                    zIndex: 1,
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        }, theme.breakpoints.up('lg'), {
            fontSize: theme.typography.pxToRem(16)
        }),
        description: {
            display: function(LayoutStyle) {
                return !(LayoutStyle === null || LayoutStyle === void 0 ? void 0 : LayoutStyle.isDisplayedPrice) && 'flex';
            },
            justifyContent: function(LayoutStyle) {
                return !(LayoutStyle === null || LayoutStyle === void 0 ? void 0 : LayoutStyle.isDisplayedPrice) && 'space-between';
            },
            padding: theme.spacing(1)
        },
        row: _defineProperty({
            display: 'inline-flex',
            justifyContent: 'space-between',
            width: '100%'
        }, theme.breakpoints.down('xs'), {
            flexDirection: 'column',
            alignItems: 'center'
        }),
        rowCta: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        rowCtaSecondHand: {
            justifyContent: 'flex-start',
            gap: '.5ch',
            marginTop: theme.spacing(1)
        },
        availability: {
            position: 'absolute',
            zIndex: 2,
            top: theme.spacing(2),
            left: '50%',
            transform: 'translateX(-50%)',
            padding: theme.spacing(1, 1.5),
            fontSize: 11,
            borderRadius: 36,
            textAlign: 'center'
        },
        smallAvalability: {
            position: 'absolute',
            zIndex: 2,
            top: theme.spacing(2),
            left: '50%',
            transform: 'translateX(-50%)',
            padding: theme.spacing(1, 1.5),
            fontSize: 8,
            borderRadius: 36,
            textAlign: 'center'
        },
        unavailable: {
            opacity: 0.7
        },
        unavailableTitle: {
            color: theme.palette.common.white,
            background: theme.extraColors.grey
        },
        enought: {
            color: theme.palette.ternary.main,
            background: theme.palette.ternary.light
        },
        available: {
            color: theme.palette.common.white,
            background: theme.palette.primary.main
        },
        rowButtons: {
            padding: theme.spacing(0),
            '& > *': {
                margin: theme.spacing(0.5)
            },
            '& > button': {
                flex: '1 1 210px'
            },
            '& > div': _defineProperty({
                flexGrow: 2
            }, theme.breakpoints.up('md'), {
                order: 1
            })
        },
        more: {
            zIndex: 2,
            position: 'relative'
        },
        addButton: {
            padding: 0,
            minWidth: 32,
            height: 32,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark
            }
        },
        addButtonDisabled: {
            padding: 10,
            minWidth: 0,
            backgroundColor: theme.extraColors.greyMedium + ' !important',
            color: theme.palette.common.white + ' !important'
        },
        price: {
            fontWeight: 700,
            marginTop: theme.spacing(1)
        },
        priceSecondHand: {
            marginTop: 0
        },
        fixedHeightSmall: {
            height: 0
        },
        productThumb: {
            top: 0,
            left: 0,
            right: 0,
            width: 'auto',
            margin: 'auto !important',
            bottom: 0,
            height: '100%',
            display: 'block',
            position: 'absolute',
            objectFit: 'contain'
        },
        oldPrice: {
            textDecoration: 'line-through'
        },
        originalPrice: {
            fontSize: 12,
            fontWeight: 700
        },
        carouselContainer: _defineProperty({
            margin: theme.spacing(0),
            '& .glider-track': {
                width: '100% !important'
            },
            '& .glider-slide': {
                minWidth: '100%'
            },
            position: 'relative'
        }, theme.breakpoints.down('sm'), {
            zIndex: 10,
            '& .glider-prev, & .glider-next': {
                display: 'flex !important',
                opacity: '1 !important',
                visibility: 'visible !important'
            }
        }),
        variants: {
            width: '100%',
            position: 'absolute',
            bottom: 0,
            display: 'flex',
            gap: '4px',
            flexWrap: 'wrap',
            padding: '0.75rem 0.25rem',
            justifyContent: 'center'
        },
        variantChip: _defineProperty({
            backgroundColor: theme.extraColors.greyLight,
            '& span': {
                whiteSpace: 'nowrap'
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        likeButton: {
            position: 'absolute',
            top: theme.spacing(1),
            right: theme.spacing(1),
            zIndex: 10
        },
        priceContainer: {
            display: 'flex',
            flexDirection: 'column'
        },
        priceItem: {
            display: 'flex',
            gap: '0.25rem',
            minWidth: '5rem'
        }
    });
});
var ref;
var mapStateToProps = function(state) {
    var ref2, ref1;
    return {
        cart: state.cart,
        stock: state.stock,
        parameters: state.parameters,
        promotions: state.promotions,
        takeBackLP: state.takeBack,
        likedProducts: state.products.likedProductsSet,
        userLoggedIn: state.user.isLoggedIn,
        sizesNamePositionMap: state.taxons.sizesNamePositionMap,
        takeBackStockMap: (ref2 = state.takeBack) === null || ref2 === void 0 ? void 0 : ref2.takeBackStockMap,
        reservationCreating: (ref = (ref1 = state.reservations) === null || ref1 === void 0 ? void 0 : ref1.creating) !== null && ref !== void 0 ? ref : false,
        account: state.prismic.account
    };
};
var mapDispatchToProps = {
    addToWishList: wishList/* addToWishList */.s3,
    removeFromWishList: wishList/* removeFromWishList */.AW
};
var ProductCard = function(param) {
    var name = param.name, thumb = param.thumb, thumbRatio = param.thumbRatio, thumbWidth = param.thumbWidth, settings = param.settings, productCode = param.productCode, parameters = param.parameters, promotions = param.promotions, _isRelated = param.isRelated, isRelated = _isRelated === void 0 ? false : _isRelated, product = param.product, addButton = param.addButton, shopData = param.shopData, stock1 = param.stock, small = param.small, index = param.index, cart = param.cart, hidePrice = param.hidePrice, takeback = param.takeback, fromPack = param.fromPack, _isDisplayedPrice = param.isDisplayedPrice, isDisplayedPrice = _isDisplayedPrice === void 0 ? true : _isDisplayedPrice, _isReleatedProduct = param.isReleatedProduct, isReleatedProduct = _isReleatedProduct === void 0 ? false : _isReleatedProduct, isSecondHandTaxon = param.isSecondHandTaxon, showSizesOnHover = param.showSizesOnHover, sizeNotShown = param.sizeNotShown, showImagesSlider = param.showImagesSlider, takeBackLP = param.takeBackLP, productSettings = param.productSettings, productAvailability = param.productAvailability, likedProducts = param.likedProducts, mainData = param.mainData, userLoggedIn = param.userLoggedIn, addToWishList1 = param.addToWishList, removeFromWishList1 = param.removeFromWishList, sizesNamePositionMap = param.sizesNamePositionMap, takeBackStockMap = param.takeBackStockMap, reservationCreating = param.reservationCreating, account = param.account;
    var ref18, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,useCart/* useCart */.j)(), addProductToCart = ref9.addProductToCart, changeProductQuantityInCart = ref9.changeProductQuantityInCart, removeProductFromCart = ref9.removeProductFromCart;
    var LayoutStyle = {
        isDisplayedPrice: isDisplayedPrice || isDisplayedPrice === null
    };
    var classes = ProductCard_useStyles(LayoutStyle);
    var shopClasses = (0,Shop_style/* default */.Z)(LayoutStyle);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref10 = (0,react.useState)(false), openModal = ref10[0], setOpenModal = ref10[1];
    var ref11 = (0,useMatomo/* default */.Z)(), trackEvent = ref11.trackEvent, pushInstruction = ref11.pushInstruction;
    var router = (0,next_router.useRouter)();
    var ref12 = (0,react.useState)(''), currentUrl = ref12[0], setCurrentUrl = ref12[1];
    var ref13 = (0,react.useState)(false), isCarouselActive = ref13[0], setIsCarouselActive = ref13[1];
    var ref14 = (0,react.useState)(false), showFakeGlider = ref14[0], setShowFakeGlider = ref14[1];
    var gliderRef = (0,react.useRef)(null);
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));
    var hasTouch = (0,useMediaQuery/* default */.Z)('(hover: none) and (pointer: coarse)');
    var shouldUseIntersection = isMobile || hasTouch;
    // hide original price threshold
    var hideOriginalPriceThreshold = productSettings === null || productSettings === void 0 ? void 0 : (ref18 = productSettings.data) === null || ref18 === void 0 ? void 0 : ref18.hide_original_price_threshold;
    var quantity1 = (0,react.useMemo)(function() {
        var ref21, ref19, ref20;
        return ((ref20 = cart === null || cart === void 0 ? void 0 : (ref21 = cart.item) === null || ref21 === void 0 ? void 0 : (ref19 = ref21.items) === null || ref19 === void 0 ? void 0 : ref19.find(function(el) {
            var ref22;
            return ((ref22 = el.product) === null || ref22 === void 0 ? void 0 : ref22.code) === productCode;
        })) === null || ref20 === void 0 ? void 0 : ref20.quantity) || 0;
    }, [
        cart === null || cart === void 0 ? void 0 : (ref3 = cart.item) === null || ref3 === void 0 ? void 0 : ref3.items,
        productCode
    ]);
    var variants = (0,react.useMemo)(function() {
        var _variants = [];
        Object.keys(product.variants).map(function(variantIndex) {
            _variants.push(product.variants[variantIndex]);
        });
        var ref24, ref23;
        return _variants.sort(function(a, b) {
            return ((ref24 = sizesNamePositionMap === null || sizesNamePositionMap === void 0 ? void 0 : sizesNamePositionMap[a.size]) !== null && ref24 !== void 0 ? ref24 : a.position) - ((ref23 = sizesNamePositionMap === null || sizesNamePositionMap === void 0 ? void 0 : sizesNamePositionMap[b.size]) !== null && ref23 !== void 0 ? ref23 : b.position);
        });
    }, [
        product,
        sizesNamePositionMap
    ]);
    var preventAddingToCart = settings === null || settings === void 0 ? void 0 : settings.prevent_adding_to_cart_without_details;
    var discountPriceFormat = settings === null || settings === void 0 ? void 0 : settings.discounted_price_display_format;
    var isSecondHand = parameters === null || parameters === void 0 ? void 0 : (ref4 = parameters.items) === null || ref4 === void 0 ? void 0 : ref4.enableTakeBack;
    var isSki = product === null || product === void 0 ? void 0 : product.ski;
    var shouldDisplayRetailPrice = shopData === null || shopData === void 0 ? void 0 : (ref5 = shopData.data) === null || ref5 === void 0 ? void 0 : ref5.display_retail_price;
    var productIsSecondHand = (ref6 = product === null || product === void 0 ? void 0 : product.variants[0]) === null || ref6 === void 0 ? void 0 : ref6.secondHand;
    var likingEnabled = (settings === null || settings === void 0 ? void 0 : settings.wishlist_enabled) && userLoggedIn;
    var isLiked = likedProducts === null || likedProducts === void 0 ? void 0 : likedProducts.has(product.id);
    (0,react.useEffect)(function() {
        if (router.isReady) {
            setCurrentUrl(router.asPath);
        }
    }, [
        router.isReady
    ]);
    var ref15 = (0,react.useMemo)(function() {
        var _Math;
        var ref33;
        // Le produit est marqué comme disponible si une de ses variante est disponible
        // ou si une seconde main est disponible
        // si 2nde main dispo, on affiche le prix de l'état le moins bon indépendamment de sa disponibilité
        var priceArray = [];
        var keys = Object.keys(product.variants);
        var skus = (ref33 = Object.values(product.variants)) === null || ref33 === void 0 ? void 0 : ref33.map(function(variant) {
            return variant === null || variant === void 0 ? void 0 : variant.sku;
        });
        var _productAvailability = productAvailability !== null && productAvailability !== void 0 ? productAvailability : (0,utils/* checkProductAvailability */.HF)(stock1, product);
        var taxRateMap = new Map();
        var isBuyableProduct = false;
        var retailPrice = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var variant1 = _step.value;
                var ref25;
                var current = product.variants[variant1];
                if ((_productAvailability === null || _productAvailability === void 0 ? void 0 : _productAvailability.secondHandAvailable) && isSecondHand && isSecondHandTaxon) {
                    var ref26;
                    var currentVariant = void 0;
                    if (isReleatedProduct) {
                        var ref27, ref28;
                        currentVariant = stock1 === null || stock1 === void 0 ? void 0 : (ref27 = stock1.stock) === null || ref27 === void 0 ? void 0 : ref27.find(function(stock) {
                            return (stock === null || stock === void 0 ? void 0 : stock.secondHand) && skus.includes(stock === null || stock === void 0 ? void 0 : stock.lizeeSKU);
                        });
                        var sku1 = skus.find(function(sku) {
                            var ref34;
                            var stockElement = stock1 === null || stock1 === void 0 ? void 0 : (ref34 = stock1.stockMap) === null || ref34 === void 0 ? void 0 : ref34.get(sku);
                            return stockElement === null || stockElement === void 0 ? void 0 : stockElement.secondHand;
                        });
                        currentVariant = stock1 === null || stock1 === void 0 ? void 0 : (ref28 = stock1.stockMap) === null || ref28 === void 0 ? void 0 : ref28.get(sku1);
                    } else {
                        var ref29;
                        currentVariant = stock1 === null || stock1 === void 0 ? void 0 : (ref29 = stock1.stockMap) === null || ref29 === void 0 ? void 0 : ref29.get(current === null || current === void 0 ? void 0 : current.sku);
                    }
                    var conditions = (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.secondHand) && (currentVariant === null || currentVariant === void 0 ? void 0 : (ref26 = currentVariant.secondHand) === null || ref26 === void 0 ? void 0 : ref26.map(function(condition) {
                        return condition.quality;
                    }));
                    var lowestQualityAvailable = conditions && (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.secondHand) && (0,filters/* getLowestConditionByConditions */.bE)(conditions);
                    if (current === null || current === void 0 ? void 0 : current.resalePrice[lowestQualityAvailable]) {
                        priceArray.push(current === null || current === void 0 ? void 0 : current.resalePrice[lowestQualityAvailable]);
                        taxRateMap.set(current === null || current === void 0 ? void 0 : current.resalePrice[lowestQualityAvailable], {
                            taxRate: current === null || current === void 0 ? void 0 : current.taxRate,
                            taxIncludedInPrice: current === null || current === void 0 ? void 0 : current.taxIncludedInPrice
                        });
                    }
                } else if (!product.variants[variant1].purchase) {
                    var ref30;
                    priceArray.push(current === null || current === void 0 ? void 0 : (ref30 = current.price) === null || ref30 === void 0 ? void 0 : ref30.current);
                } else {
                    priceArray.push(Number(current === null || current === void 0 ? void 0 : current.purchasePrice) ? current === null || current === void 0 ? void 0 : current.purchasePrice : 0);
                    isBuyableProduct = true;
                }
                if (!retailPrice || (retailPrice === null || retailPrice === void 0 ? void 0 : retailPrice.current) < (current === null || current === void 0 ? void 0 : (ref25 = current.originalPrice) === null || ref25 === void 0 ? void 0 : ref25.current)) {
                    var ref31;
                    retailPrice = current === null || current === void 0 ? void 0 : (ref31 = current.originalPrice) === null || ref31 === void 0 ? void 0 : ref31.current;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if ((_productAvailability === null || _productAvailability === void 0 ? void 0 : _productAvailability.secondHandAvailable) && isSecondHand) {
            isBuyableProduct = true;
        }
        var priceMinHt = (_Math = Math).min.apply(_Math, _toConsumableArray(priceArray));
        var priceMinTtc = priceMinHt;
        if (taxRateMap.has(priceMinHt)) {
            var ref32 = taxRateMap.get(priceMinHt), taxRate = ref32.taxRate, taxIncludedInPrice = ref32.taxIncludedInPrice;
            var pricingWithTax = (0,taxPricing/* getPricingWithTaxInfo */.B)(priceMinHt, taxIncludedInPrice, taxRate);
            priceMinHt = pricingWithTax.priceHt;
            priceMinTtc = pricingWithTax.priceTtc;
        }
        return {
            isBuyableProduct: isBuyableProduct,
            retailPrice: retailPrice,
            availability: _productAvailability === null || _productAvailability === void 0 ? void 0 : _productAvailability.available,
            secondHandAvailability: _productAvailability === null || _productAvailability === void 0 ? void 0 : _productAvailability.secondHandAvailable,
            // Le prix affiché est celui du prix le plus bas entre toutes les variantes
            priceMinHt: priceMinHt,
            priceMinTtc: priceMinTtc
        };
    }, [
        stock1.stockMap,
        productAvailability
    ]), isBuyableProduct1 = ref15.isBuyableProduct, retailPrice1 = ref15.retailPrice, availability = ref15.availability, secondHandAvailability = ref15.secondHandAvailability, priceMinHt1 = ref15.priceMinHt, priceMinTtc1 = ref15.priceMinTtc;
    // QuantitySelector with no variant
    var onQuantityChange = (0,react.useCallback)(function(quantity) {
        var ref59;
        var productInCart = cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
            return el.product.code === productCode;
        }) !== 'undefined' && cart.item.items.find(function(el) {
            return el.product.code === productCode;
        });
        var inStock = 0;
        if (productInCart === null || productInCart === void 0 ? void 0 : (ref59 = productInCart.product) === null || ref59 === void 0 ? void 0 : ref59.variants[0]) {
            inStock = (0,utils/* checkStockQuantity */.LY)(stock1, productInCart.product.variants[0]);
        }
        var firstVariant = Object.keys(product.variants)[0] !== '0' ? Object.keys(product.variants)[0] : product.variants[0].code;
        var response = (0,addToCart/* addToCartUtility */.$)(firstVariant, quantity, cart, parameters, productInCart, false, inStock);
        if (availability) {
            var ref35, ref36, ref37;
            var unitaryPrice = (0,utils/* numberToPrice */.e8)((ref36 = productInCart === null || productInCart === void 0 ? void 0 : (ref35 = productInCart.product) === null || ref35 === void 0 ? void 0 : ref35.variants[0]) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.price) === null || ref37 === void 0 ? void 0 : ref37.current);
            var totalPrice = (0,utils/* numberToPrice */.e8)(unitaryPrice * quantity);
            switch(response.message){
                case 'limit':
                case 'max':
                case 'add':
                    trackEvent({
                        category: 'Add to Cart',
                        action: "".concat(name),
                        name: "".concat(router.pathname),
                        value: totalPrice
                    });
                    if (response.productInCart) {
                        var ref38, ref39, ref40, ref41, ref42, ref43, ref44;
                        changeProductQuantityInCart(productInCart.id, {
                            quantity: quantity
                        }, base/* GAEvent.ADD_TO_CART */.gB.ADD_TO_CART, inStock);
                        pushInstruction('addEcommerceItem', (ref39 = productInCart === null || productInCart === void 0 ? void 0 : (ref38 = productInCart.product) === null || ref38 === void 0 ? void 0 : ref38.variants[0]) === null || ref39 === void 0 ? void 0 : ref39.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref40 = productInCart.product) === null || ref40 === void 0 ? void 0 : ref40.name, productInCart === null || productInCart === void 0 ? void 0 : (ref41 = productInCart.product) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.taxons) === null || ref42 === void 0 ? void 0 : ref42.main, unitaryPrice, quantity);
                        pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref43 = cart.item) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.totals) === null || ref44 === void 0 ? void 0 : ref44.total));
                    } else {
                        if (product.isSimpleProduct) {
                            var ref45, ref46, ref47, ref48;
                            addProductToCart({
                                productCode: productCode,
                                quantity: quantity
                            });
                            pushInstruction('addEcommerceItem', (ref45 = product === null || product === void 0 ? void 0 : product.variants[firstVariant]) === null || ref45 === void 0 ? void 0 : ref45.sku, product === null || product === void 0 ? void 0 : product.name, product === null || product === void 0 ? void 0 : (ref46 = product.taxons) === null || ref46 === void 0 ? void 0 : ref46.main, (0,utils/* numberToPrice */.e8)((ref47 = product === null || product === void 0 ? void 0 : product.variants[firstVariant]) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.price) === null || ref48 === void 0 ? void 0 : ref48.current), quantity);
                            pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                        } else {
                            addProductToCart({
                                productCode: productCode,
                                quantity: quantity,
                                variantCode: firstVariant
                            });
                        }
                    }
                    break;
                case 'remove':
                    var ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56;
                    trackEvent({
                        category: 'Remove from Cart',
                        action: "".concat(name),
                        name: "".concat(router.pathname),
                        value: totalPrice
                    });
                    changeProductQuantityInCart(productInCart.id, {
                        quantity: quantity
                    }, base/* GAEvent.REMOVE_FROM_CART */.gB.REMOVE_FROM_CART, inStock);
                    pushInstruction('addEcommerceItem', (ref50 = productInCart === null || productInCart === void 0 ? void 0 : (ref49 = productInCart.product) === null || ref49 === void 0 ? void 0 : ref49.variants[0]) === null || ref50 === void 0 ? void 0 : ref50.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref51 = productInCart.product) === null || ref51 === void 0 ? void 0 : ref51.name, productInCart === null || productInCart === void 0 ? void 0 : (ref52 = productInCart.product) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.taxons) === null || ref53 === void 0 ? void 0 : ref53.main, (0,utils/* numberToPrice */.e8)((ref55 = productInCart === null || productInCart === void 0 ? void 0 : (ref54 = productInCart.product) === null || ref54 === void 0 ? void 0 : ref54.variants[0]) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.price) === null || ref56 === void 0 ? void 0 : ref56.current), quantity);
                    pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                    break;
                case 'delete':
                    var ref57, ref58;
                    trackEvent({
                        category: 'Delete from Cart',
                        action: "".concat(product === null || product === void 0 ? void 0 : product.name, " "),
                        name: "".concat(router.pathname),
                        value: totalPrice
                    });
                    removeProductFromCart(productInCart);
                    pushInstruction('removeEcommerceItem', (ref58 = productInCart === null || productInCart === void 0 ? void 0 : (ref57 = productInCart.product) === null || ref57 === void 0 ? void 0 : ref57.variants[0]) === null || ref58 === void 0 ? void 0 : ref58.sku);
                    pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
                    break;
                default:
                    break;
            }
            setOpenModal(false);
        }
    }, [
        cart,
        productCode,
        product,
        stock1,
        parameters,
        name,
        router
    ]);
    // add product with a variant
    var addProductWithSize = (0,react.useCallback)(function(variantCode, variantName, quantity) {
        var ref69, ref60, ref61;
        var productInCart = cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
            return el.product.variants[0].code === variantCode;
        }) !== 'undefined' && cart.item.items.find(function(el) {
            return el.product.variants[0].code === variantCode;
        });
        // check stock
        var inStock = 0;
        if (productInCart) {
            inStock = (0,utils/* checkStockQuantity */.LY)(stock1, productInCart.product.variants[0]);
        }
        var unitaryPrice = (0,utils/* numberToPrice */.e8)((ref60 = productInCart === null || productInCart === void 0 ? void 0 : (ref69 = productInCart.product) === null || ref69 === void 0 ? void 0 : ref69.variants[variantCode]) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.price) === null || ref61 === void 0 ? void 0 : ref61.current);
        var totalPrice = (0,utils/* numberToPrice */.e8)(unitaryPrice * quantity);
        var response = (0,addToCart/* addToCartUtility */.$)(variantName, quantity, cart, parameters, productInCart, false, inStock);
        if (response.productInCart) {
            var ref62, ref63, ref64, ref65, ref66;
            changeProductQuantityInCart(productInCart.id, {
                quantity: quantity
            }, base/* GAEvent.ADD_TO_CART */.gB.ADD_TO_CART, inStock);
            pushInstruction('addEcommerceItem', (ref63 = productInCart === null || productInCart === void 0 ? void 0 : (ref62 = productInCart.product) === null || ref62 === void 0 ? void 0 : ref62.variants[variantCode]) === null || ref63 === void 0 ? void 0 : ref63.sku, productInCart === null || productInCart === void 0 ? void 0 : (ref64 = productInCart.product) === null || ref64 === void 0 ? void 0 : ref64.name, productInCart === null || productInCart === void 0 ? void 0 : (ref65 = productInCart.product) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.taxons) === null || ref66 === void 0 ? void 0 : ref66.main, totalPrice, quantity);
            pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
        } else {
            if (response.message === 'add') {
                var ref67, ref68;
                trackEvent({
                    category: 'Add to Cart',
                    action: "".concat(name),
                    name: "".concat(router.pathname),
                    value: totalPrice
                });
                addProductToCart({
                    productCode: productCode,
                    quantity: quantity,
                    variantCode: variantCode
                });
                pushInstruction('addEcommerceItem', (ref67 = product === null || product === void 0 ? void 0 : product.variants[variantCode]) === null || ref67 === void 0 ? void 0 : ref67.sku, product === null || product === void 0 ? void 0 : product.name, product === null || product === void 0 ? void 0 : (ref68 = product.taxons) === null || ref68 === void 0 ? void 0 : ref68.main, unitaryPrice, quantity);
                pushInstruction('trackEcommerceCartUpdate', (0,utils/* numberToPrice */.e8)(cart.item.totals.total));
            }
        }
        setOpenModal(false);
    }, [
        cart,
        productCode,
        product,
        stock1,
        parameters,
        name,
        router
    ]);
    var setOpenModalAndTrack = (0,react.useCallback)(function() {
        setOpenModal(true);
        trackEvent({
            category: 'Products',
            action: "Open Product Card modale",
            name: "".concat(product.name, " from ").concat(currentUrl)
        });
    }, [
        product,
        currentUrl
    ]);
    var thumbTemp = (0,react.useMemo)(function() {
        return Array.isArray(thumb) ? thumb.filter(function(image) {
            return !!image.path;
        }) : [
            thumb
        ];
    }, [
        thumb
    ]);
    var hasArrows = showImagesSlider && (thumbTemp === null || thumbTemp === void 0 ? void 0 : thumbTemp.length) > 1;
    // Only show first image if carousel is not active
    var displayedImages = !isCarouselActive ? thumbTemp.slice(0, 1) : thumbTemp;
    var hasMultipleImages = (thumbTemp === null || thumbTemp === void 0 ? void 0 : thumbTemp.length) > 1;
    var activateCarousel = (0,react.useCallback)(function(isIntersecting) {
        if (isIntersecting) {
            if (shouldUseIntersection) {
                setShowFakeGlider(true);
            } else {
                setIsCarouselActive(true);
            }
        } else {
            setIsCarouselActive(false);
            setShowFakeGlider(false);
        }
    }, [
        shouldUseIntersection
    ]);
    var setRef = useIntersectionObserver(activateCarousel, shouldUseIntersection, {
        root: null,
        rootMargin: '50px',
        threshold: 0.1
    });
    var onTouchStart = (0,react.useMemo)(function() {
        return createLongPressHandler(function() {
            return setIsCarouselActive(true);
        });
    }, []).onTouchStart;
    var onArrowClick = function(event) {
        event.stopPropagation();
        event.preventDefault();
    };
    var onFakeGliderClick = (0,react.useCallback)(function(event) {
        onArrowClick(event);
        if (!hasMultipleImages) return;
        setIsCarouselActive(true);
        setShowFakeGlider(false);
        // Wait for Glider to be initialized
        setTimeout(function() {
            if (gliderRef.current) {
                gliderRef.current.scrollItem(1);
            }
        }, 0);
    }, [
        hasMultipleImages
    ]);
    var gotoProduct = function(event) {
        var target = event.target;
        if (target.tagName === 'BUTTON') {
            return;
        }
        router.push("/products/".concat(product.code));
    };
    (0,react.useEffect)(function() {
        if (shouldUseIntersection) {
            setShowFakeGlider(true);
        }
    }, [
        shouldUseIntersection
    ]);
    var handleLikeToggle = function(event) {
        event.stopPropagation();
        event.preventDefault();
        if (isLiked) {
            removeFromWishList1(product);
        } else {
            addToWishList1(product);
        }
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref16 = (0,react.useState)(false), reserveModalOpen = ref16[0], setReserveModalOpen = ref16[1];
    var ref17 = (0,react.useState)(false), reserveError = ref17[0], setReserveError = ref17[1];
    var firstAvailablePuid = (0,react.useMemo)(function() {
        var ref72;
        if (!(settings === null || settings === void 0 ? void 0 : settings.enable_reservation) || !takeBackStockMap) return null;
        var skus = (ref72 = Object.values(product.variants)) === null || ref72 === void 0 ? void 0 : ref72.map(function(v) {
            return v === null || v === void 0 ? void 0 : v.sku;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = skus[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var sku = _step.value;
                var ref70;
                var entry = takeBackStockMap.get(sku);
                if (entry === null || entry === void 0 ? void 0 : (ref70 = entry.productsByQuality) === null || ref70 === void 0 ? void 0 : ref70.length) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = entry.productsByQuality[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var q = _step1.value;
                            var ref71;
                            if ((ref71 = q.products) === null || ref71 === void 0 ? void 0 : ref71.length) return q.products[0].puid;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    }, [
        product.variants,
        takeBackStockMap
    ]);
    var reservationDays = (settings === null || settings === void 0 ? void 0 : settings.number_of_reservation_days) || 5;
    var handleReserveConfirm = (0,react.useCallback)(function() {
        if (!firstAvailablePuid) return;
        setReserveError(false);
        var locale = router.locale;
        var prismicLocale = "".concat(locale, "-").concat(locale);
        dispatch((0,reservations/* createReservation */.Rr)(firstAvailablePuid, prismicLocale)).then(function() {
            setReserveModalOpen(false);
        }).catch(function(error) {
            var ref73;
            setReserveError((error === null || error === void 0 ? void 0 : (ref73 = error.response) === null || ref73 === void 0 ? void 0 : ref73.status) || true);
        });
    }, [
        dispatch,
        firstAvailablePuid,
        router.locale
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "".concat(product.code),
        ref: setRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: (0,clsx_m/* default */.Z)('productCard', shopClasses.shopCard, !availability && !secondHandAvailability && classes.unavailable),
            onMouseEnter: function() {
                if (!shouldUseIntersection) {
                    setIsCarouselActive(true);
                }
            },
            onTouchStart: onTouchStart,
            onClick: gotoProduct,
            children: [
                likingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    className: classes.likeButton,
                    onClick: handleLikeToggle,
                    "data-testid": "like-button-".concat(product.code),
                    children: isLiked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite/* default */.Z, {
                        color: "secondary"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder/* default */.Z, {})
                }),
                !availability && !secondHandAvailability && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    noWrap: true,
                    component: "p",
                    className: (0,clsx_m/* default */.Z)('productCard__soldout', small ? classes.smallAvalability : classes.availability, classes.unavailableTitle),
                    variant: "body2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: shopData === null || shopData === void 0 ? void 0 : (ref7 = shopData.data) === null || ref7 === void 0 ? void 0 : ref7.sold_out,
                        defaultText: t('texts:shop:victim_of_success')
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(classes.carouselContainer, isMobile && 'mobile-carousel'),
                    children: [
                        isCarouselActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                            ref: gliderRef,
                            hasArrows: hasArrows,
                            itemWidth: 0,
                            draggable: true,
                            scrollLock: true,
                            slidesToShow: 1,
                            iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: onArrowClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
                                    className: "productCard__glider_buttons"
                                })
                            }),
                            iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: onArrowClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                    className: "productCard__glider_buttons"
                                })
                            }),
                            propagateEvent: false,
                            children: displayedImages === null || displayedImages === void 0 ? void 0 : displayedImages.map(function(image, key) {
                                return image.path && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: image.path,
                                    "data-ratio": thumbRatio,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                        alt: "",
                                        imagePaths: image,
                                        classes: classes.productThumb,
                                        settings: (0,utils/* getProductImageKitSettings */.rI)(thumbWidth, thumbRatio)
                                    })
                                }, key);
                            })
                        }) : showFakeGlider && showImagesSlider ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "glider-contain",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    disabled: true,
                                    className: "glider-prev disabled",
                                    "aria-label": "Previous",
                                    "aria-disabled": "true",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
                                        className: "productCard__glider_buttons"
                                    })
                                }),
                                displayedImages === null || displayedImages === void 0 ? void 0 : displayedImages.slice(0, 1).map(function(image, key) {
                                    return image.path && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: image.path,
                                        "data-ratio": thumbRatio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                            alt: "",
                                            imagePaths: image,
                                            classes: classes.productThumb,
                                            settings: (0,utils/* getProductImageKitSettings */.rI)(thumbWidth, thumbRatio)
                                        })
                                    }, key);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: onFakeGliderClick,
                                    disabled: !hasMultipleImages,
                                    className: (0,clsx_m/* default */.Z)('glider-next', !hasMultipleImages && 'disabled'),
                                    "aria-label": "Next",
                                    "aria-disabled": !hasMultipleImages,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                        className: "productCard__glider_buttons"
                                    })
                                })
                            ]
                        }) : displayedImages === null || displayedImages === void 0 ? void 0 : displayedImages.map(function(image, key) {
                            return image.path && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: image.path,
                                "data-ratio": thumbRatio,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                    alt: "",
                                    imagePaths: image,
                                    classes: classes.productThumb,
                                    settings: (0,utils/* getProductImageKitSettings */.rI)(thumbWidth, thumbRatio)
                                })
                            }, key);
                        }),
                        !sizeNotShown && showSizesOnHover && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.variants, 'product__variants'),
                            children: variants.map(function(variant) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    label: variant.size,
                                    className: (0,clsx_m/* default */.Z)(classes.variantChip, 'sizes__btn', 'sizes__btn--hover_sizes'),
                                    clickable: false,
                                    classes: {
                                        label: 'sizes__chip__label'
                                    }
                                }, variant.code);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)('productCard__desc', classes.description),
                    children: [
                         true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "productCard__desc__title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)('productCard__title', classes.title),
                                        variant: "body1",
                                        component: "h2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: {
                                                pathname: !isRelated || fromPack ? '../products/[product]' : './[product]',
                                                query: {
                                                    code: productCode
                                                }
                                            },
                                            as: !isRelated || fromPack ? "../products/".concat(productCode) : "./".concat(productCode),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                "data-testid": 'link-to-single',
                                                onClick: function() {
                                                    return trackEvent({
                                                        category: 'Select Product',
                                                        action: "Select ".concat(name, " from ").concat(currentUrl)
                                                    });
                                                },
                                                children: small ? (0,utils/* truncateString */.aS)(name, 40) : (0,utils/* truncateString */.aS)(name, 80)
                                            })
                                        })
                                    })
                                }),
                                constants/* hidePricingOnGhostUser */.FB && !userLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginToSeePriceRow/* default */.Z, {
                                    text: account,
                                    customClasses: (0,clsx_m/* default */.Z)(classes.loginToSeePriceRow, 'login_to_see_price_row--product_card')
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !hidePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)('productCard__rowCta', classes.rowCta, (hideOriginalPriceThreshold !== undefined || hideOriginalPriceThreshold !== null || (0,utils/* numberToPrice */.e8)(retailPrice1) == hideOriginalPriceThreshold) && [
                                                classes.fullWidth
                                            ], secondHandAvailability && isSecondHand && [
                                                classes.rowCtaSecondHand,
                                                'productCard__rowCta--second-hand', 
                                            ]),
                                            children: [
                                                !constants/* displayTtcAndHtPrice */.r4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_ProductCardPrice, {
                                                    priceMin: priceMinHt1,
                                                    isDisplayedPrice: isDisplayedPrice,
                                                    secondHandAvailability: secondHandAvailability,
                                                    isSecondHand: isSecondHand,
                                                    takeback: takeback,
                                                    promotions: promotions,
                                                    productIsSecondHand: productIsSecondHand,
                                                    availability: availability,
                                                    isSecondHandTaxon: isSecondHandTaxon,
                                                    settings: settings,
                                                    isBuyableProduct: isBuyableProduct1,
                                                    discountPriceFormat: discountPriceFormat,
                                                    productTaxons: product === null || product === void 0 ? void 0 : product.taxons
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.priceContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classes.priceItem,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_ProductCardPrice, {
                                                                priceMin: priceMinHt1,
                                                                isDisplayedPrice: isDisplayedPrice,
                                                                secondHandAvailability: secondHandAvailability,
                                                                isSecondHand: isSecondHand,
                                                                takeback: takeback,
                                                                promotions: promotions,
                                                                productIsSecondHand: productIsSecondHand,
                                                                availability: availability,
                                                                isSecondHandTaxon: isSecondHandTaxon,
                                                                settings: settings,
                                                                isBuyableProduct: isBuyableProduct1,
                                                                discountPriceFormat: discountPriceFormat,
                                                                _type: "ht",
                                                                productTaxons: product === null || product === void 0 ? void 0 : product.taxons
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classes.priceItem,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_ProductCardPrice, {
                                                                priceMin: priceMinTtc1,
                                                                isDisplayedPrice: isDisplayedPrice,
                                                                secondHandAvailability: secondHandAvailability,
                                                                isSecondHand: isSecondHand,
                                                                takeback: takeback,
                                                                promotions: promotions,
                                                                productIsSecondHand: productIsSecondHand,
                                                                availability: availability,
                                                                isSecondHandTaxon: isSecondHandTaxon,
                                                                settings: settings,
                                                                isBuyableProduct: isBuyableProduct1,
                                                                discountPriceFormat: discountPriceFormat,
                                                                _type: "ttc",
                                                                hideLabel: true,
                                                                productTaxons: product === null || product === void 0 ? void 0 : product.taxons
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !preventAddingToCart && !isSki && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shop_ProductCardAddToCart, {
                                                    hidePrice: hidePrice,
                                                    availability: availability || secondHandAvailability,
                                                    secondHandAvailability: secondHandAvailability,
                                                    product: product,
                                                    addButton: addButton,
                                                    classes: classes,
                                                    index: index,
                                                    setOpenModalAndTrack: setOpenModalAndTrack,
                                                    openModal: openModal,
                                                    stock: stock1,
                                                    setOpenModal: setOpenModal,
                                                    shopData: shopData,
                                                    cart: cart,
                                                    addProductWithSize: addProductWithSize,
                                                    thumbRatio: thumbRatio,
                                                    thumbWidth: thumbWidth,
                                                    settings: settings,
                                                    currentUrl: currentUrl,
                                                    quantity: quantity1,
                                                    onQuantityChange: onQuantityChange,
                                                    isSecondHandTaxon: isSecondHandTaxon,
                                                    takeback: takeback,
                                                    takeBackLP: takeBackLP,
                                                    productSettings: productSettings
                                                })
                                            ]
                                        }),
                                        shouldDisplayRetailPrice && !!retailPrice1 && (hideOriginalPriceThreshold === undefined || hideOriginalPriceThreshold === null || (0,utils/* numberToPrice */.e8)(retailPrice1) != hideOriginalPriceThreshold) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (0,clsx_m/* default */.Z)(classes.originalPrice, "productCard__price--original"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: takeback === null || takeback === void 0 ? void 0 : (ref8 = takeback.data) === null || ref8 === void 0 ? void 0 : ref8.original_price,
                                                    defaultText: t('texts:takeBack:original_price')
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                    amount: retailPrice1,
                                                    buyAble: true
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ 0,
                        (settings === null || settings === void 0 ? void 0 : settings.enable_reservation) && firstAvailablePuid && constants/* enableProductCardReservation */.o6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        padding: '8px',
                                        position: 'relative',
                                        zIndex: 2
                                    },
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "primary",
                                        variant: "outlined",
                                        fullWidth: true,
                                        onClick: function() {
                                            return setReserveModalOpen(true);
                                        },
                                        children: t('texts:reservations:reserve_cta', {
                                            days: reservationDays
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationConfirmModal/* default */.Z, {
                                    open: reserveModalOpen,
                                    onClose: function() {
                                        return setReserveModalOpen(false);
                                    },
                                    onConfirm: handleReserveConfirm,
                                    loading: reservationCreating,
                                    reservationDays: reservationDays,
                                    error: reserveError
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Shop_ProductCard = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(ProductCard));


/***/ }),

/***/ 45006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useStyles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22318);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31567);
/* harmony import */ var _Price__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31907);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66026);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var _BackInStockAlert_SecondHandBackInStockAlertButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74947);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16502);
/* harmony import */ var _TaxonPromotionBadge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96780);











var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        oldPrice: {
            textDecoration: 'line-through'
        },
        marginLeft: {
            marginLeft: theme.spacing(1)
        },
        prices: {
            display: 'flex',
            gap: theme.spacing(1),
            alignItems: 'center'
        },
        pricesOriginal: {
            fontSize: 12,
            paddingLeft: theme.spacing(1),
            borderLeft: "1px solid ".concat(theme.palette.common.black)
        },
        startPrice: {
            paddingRight: theme.spacing(0.5)
        },
        startPriceAfter: {
            marginLeft: '4px'
        },
        unavailableContainer: {
            display: 'flex',
            flexDirection: 'row'
        }
    });
});
var ProductPriceFormat = function(param) {
    var promotions = param.promotions, productPrice = param.priceMin, takeBackPrice = param.takeBackPrice, selectedTakeBackOrRental = param.selectedTakeBackOrRental, settings = param.settings, isBuyableProduct = param.isBuyableProduct, discountPriceFormat = param.discountPriceFormat, _isDisplayPercentage = param.isDisplayPercentage, isDisplayPercentage = _isDisplayPercentage === void 0 ? false : _isDisplayPercentage, classe = param.classe, takeback = param.takeback, selectedQuality = param.selectedQuality, originalPrice = param.originalPrice, productSettings = param.productSettings, takeBackPriceMin = param.takeBackPriceMin, takeBackAvailability = param.takeBackAvailability, isSecondHand = param.isSecondHand, avalableForRentalAndSecondHand = param.avalableForRentalAndSecondHand, isSecondHandTaxon = param.isSecondHandTaxon, variants = param.variants, afterCurrency = param.afterCurrency, _hideOriginalPrice = param.hideOriginalPrice, hideOriginalPrice = _hideOriginalPrice === void 0 ? false : _hideOriginalPrice, productTaxons = param.productTaxons;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var classes = useStyles();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)().t;
    var globalPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.currentPromotion;
    var taxonPromotion = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .getProductTaxonPromotion */ .jt)(promotions, productTaxons);
    var currentPromotion = globalPromotion !== null && globalPromotion !== void 0 ? globalPromotion : taxonPromotion;
    var hasTaxonPromotion = !globalPromotion && taxonPromotion !== null;
    var displayFlexPrice = settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day;
    var isPerMonth = settings === null || settings === void 0 ? void 0 : settings.show_price_per_month;
    var priceMin = productPrice * (isPerMonth ? 30 : 1);
    var hideOriginalPriceThreshold = productSettings === null || productSettings === void 0 ? void 0 : (ref = productSettings.data) === null || ref === void 0 ? void 0 : ref.hide_original_price_threshold;
    if (isSecondHandTaxon === false) {
        // if we are in rental taxon and we have stock both (rental + 2ndhand)
        isBuyableProduct = avalableForRentalAndSecondHand ? !avalableForRentalAndSecondHand : false;
    }
    var noPromoOrSecondHand = (currentPromotion == null || isSecondHand) && !selectedTakeBackOrRental;
    var discountedPrice = currentPromotion ? priceMin - priceMin * currentPromotion / 100 : priceMin;
    var renderPromoPercentBadge = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TaxonPromotionBadge__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            percent: currentPromotion,
            inline: true,
            display: isDisplayPercentage
        });
    };
    var regularPriceElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "".concat(classe, "__amount"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            amount: priceMin,
            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
            showDayOrMonth: true,
            isShort: false,
            buyAble: isBuyableProduct,
            displayFlexPrice: displayFlexPrice,
            afterCurrency: afterCurrency
        })
    });
    var promotionPriceElement = isDisplayPercentage && currentPromotion !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat(classe, "__oldPrice"), classes.oldPrice),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    amount: priceMin,
                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                    showDayOrMonth: false,
                    buyAble: isBuyableProduct,
                    displayFlexPrice: displayFlexPrice
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat(classe, "__amount"), classes.marginLeft),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    amount: discountedPrice,
                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                    showDayOrMonth: true,
                    buyAble: isBuyableProduct,
                    displayFlexPrice: displayFlexPrice
                })
            }),
            renderPromoPercentBadge()
        ]
    });
    var soldOutElement = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                variant: "h4",
                className: "product__unavailable",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    asText: true,
                    data: productSettings === null || productSettings === void 0 ? void 0 : (ref1 = productSettings.data) === null || ref1 === void 0 ? void 0 : ref1.sold_out,
                    defaultText: t('texts:packs:victim_of_success')
                })
            }),
            _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .isSecondHandOnly */ .G7 && (takeback === null || takeback === void 0 ? void 0 : (ref2 = takeback.data) === null || ref2 === void 0 ? void 0 : ref2.take_back_stock_alert_enable) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackInStockAlert_SecondHandBackInStockAlertButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                prismicTakeback: takeback === null || takeback === void 0 ? void 0 : takeback.data,
                allVariantsNotInStock: variants,
                displayTextBeforeButton: false
            })
        ]
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            noPromoOrSecondHand && (priceMin !== 0 ? currentPromotion === null ? regularPriceElement : promotionPriceElement : soldOutElement),
            !isSecondHand && currentPromotion !== null && currentPromotion && !hasTaxonPromotion && discountPriceFormat === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PRICE_WITHOUT_DISCOUNT */ .HB && !selectedTakeBackOrRental && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat(classe, "__amount"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    amount: priceMin,
                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                    showDayOrMonth: true,
                    isShort: false,
                    buyAble: isBuyableProduct,
                    displayFlexPrice: displayFlexPrice
                })
            }),
            !isSecondHand && currentPromotion !== null && currentPromotion && !hasTaxonPromotion && discountPriceFormat === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .DISCOUNTED_PRICE_ONLY */ .Qn && !selectedTakeBackOrRental && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat(classe, "__amount"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    amount: discountedPrice,
                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                    dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                    showDayOrMonth: true,
                    buyAble: isBuyableProduct,
                    displayFlexPrice: displayFlexPrice
                })
            }),
            !isSecondHand && currentPromotion !== null && currentPromotion !== undefined && (discountPriceFormat === _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .DISCOUNTED_PRICE_WITH_DETAILS */ .B8 || hasTaxonPromotion) && !selectedTakeBackOrRental && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat(classe, "__oldPrice"), classes.oldPrice),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            amount: priceMin,
                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                            showDayOrMonth: false,
                            buyAble: isBuyableProduct,
                            displayFlexPrice: displayFlexPrice
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat(classe, "__amount"), classes.marginLeft),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            amount: discountedPrice,
                            dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                            dayOrMonthShort: settings === null || settings === void 0 ? void 0 : settings.day_or_month_short,
                            showDayOrMonth: true,
                            buyAble: isBuyableProduct,
                            displayFlexPrice: displayFlexPrice
                        })
                    }),
                    renderPromoPercentBadge()
                ]
            }),
            selectedTakeBackOrRental === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat(classe, "__prices"), selectedQuality !== '' && classes.prices),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: selectedQuality !== '' ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                !takeBackAvailability && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes.startPrice,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                        asText: true,
                                        data: takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.price_start,
                                        defaultText: t('texts:takeBack:price_start')
                                    })
                                }),
                                currentPromotion ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat(classe, "__oldPrice"), classes.oldPrice),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                amount: takeBackPrice,
                                                showDayOrMonth: false,
                                                isShort: false,
                                                buyAble: isBuyableProduct
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat(classe, "__amount"), classes.marginLeft),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    amount: takeBackPrice - takeBackPrice * currentPromotion / 100,
                                                    showDayOrMonth: false,
                                                    isShort: false,
                                                    buyAble: isBuyableProduct
                                                }),
                                                afterCurrency
                                            ]
                                        }),
                                        renderPromoPercentBadge()
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "".concat(classe, "__amount"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            amount: takeBackPrice,
                                            showDayOrMonth: false,
                                            isShort: false,
                                            buyAble: isBuyableProduct
                                        }),
                                        afterCurrency
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "".concat(classe, "__price--start"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes.startPrice,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                        asText: true,
                                        data: takeback === null || takeback === void 0 ? void 0 : (ref4 = takeback.data) === null || ref4 === void 0 ? void 0 : ref4.price_start,
                                        defaultText: t('texts:takeBack:price_start')
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "".concat(classe, "__amount"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        amount: takeBackPriceMin,
                                        showDayOrMonth: false,
                                        isShort: false,
                                        buyAble: isBuyableProduct
                                    })
                                })
                            ]
                        })
                    }),
                    !hideOriginalPrice && Number.isFinite(originalPrice) && originalPrice > 0 && !(hideOriginalPriceThreshold !== undefined && hideOriginalPriceThreshold !== null && (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .numberToPrice */ .e8)(originalPrice) >= hideOriginalPriceThreshold) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(classes.pricesOriginal, "".concat(classe, "__price--original")),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classes.startPrice,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: takeback === null || takeback === void 0 ? void 0 : (ref5 = takeback.data) === null || ref5 === void 0 ? void 0 : ref5.original_price,
                                    defaultText: t('texts:takeBack:original_price')
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                amount: originalPrice,
                                buyAble: true
                            }),
                             true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classes.startPriceAfter,
                                children: ", je inkl. 19 % MwSt."
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductPriceFormat);


/***/ }),

/***/ 26035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Sizes_SizeModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./components/Shop/QuantitySelector.tsx
var QuantitySelector = __webpack_require__(83230);
// EXTERNAL MODULE: ./typings/base.ts
var base = __webpack_require__(88039);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./managers/product/productVariantManager.tsx
var getProductVariantIdByCode = function(variants, code) {
    return variants.findIndex(function(variant) {
        return variant.code === code;
    });
};

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/BackInStockAlert/BackInStockAlert.tsx
var BackInStockAlert = __webpack_require__(99871);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@prismicio/client/dist/index.js + 3 modules
var dist = __webpack_require__(73897);
// EXTERNAL MODULE: ./node_modules/@prismicio/next/dist/enableAutoPreviews.js
var enableAutoPreviews = __webpack_require__(95596);
;// CONCATENATED MODULE: ./prismicio.js
/* provided dependency */ var process = __webpack_require__(34155);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * Redis client
 * @type {Redis | undefined}
 */ var redis;
if (false) {}
var endpoint = process.env.PRISMIC_URL;
var REPOSITORY_REF_TTL = 60 * 15 // 15 minutes (same as document cache)
;
var hasLoggedMissingTokenInProd = false;
var checkPrismicTokenInProd = function() {
    if (false) {}
};
var logPrismicCall = function(context, hasToken) {
    if (process.env.PRISMIC_DEBUG_LOGS === 'true') {
        var tokenStatus = hasToken ? 'WITH access_token ✓' : 'WITHOUT access_token ✗';
        console.log("[Prismic] ".concat(context, " - ").concat(tokenStatus));
    }
};
/**
 * Wrapper fetch pour tracer les requêtes Prismic et FORCER le token sur l'endpoint repository (/api/v2).
 * Le client Prismic peut appeler /api/v2 sans token (getCachedRepository) ; on l'ajoute systématiquement.
 * Activé via PRISMIC_DEBUG_LOGS=true pour les logs.
 */ var createPrismicFetch = function() {
    var realFetch = typeof globalThis.fetch === 'function' ? globalThis.fetch : undefined;
    if (!realFetch) return undefined;
    return function(url) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var finalUrl = url;
        var isRepositoryEndpoint = typeof url === 'string' && url.includes('prismic') && url.includes('/api/v2') && !url.includes('/api/v2/documents/');
        if (isRepositoryEndpoint) {
            var token = process.env.PRISMIC_ACCESS_TOKEN;
            if (token && !url.includes('access_token=')) {
                finalUrl = "".concat(url.includes('?') ? url + '&' : url + '?', "access_token=").concat(token);
            }
        }
        var headers = new Headers(options.headers);
        headers.set('User-Agent', 'lizee-debug/1.0');
        try {
            var parsedUrl = new URL(finalUrl);
            var queryParams = Object.fromEntries(parsedUrl.searchParams.entries());
            console.log('[Prismic fetch]', {
                url: "".concat(parsedUrl.origin).concat(parsedUrl.pathname),
                headers: Object.fromEntries(headers.entries()),
                queryParams: queryParams
            });
        } catch (e) {
            console.log('[Prismic fetch]', {
                url: finalUrl
            });
        }
        return realFetch(finalUrl, _objectSpread({}, options, {
            headers: headers
        }));
    };
};
var REPOSITORY_CACHE_KEY =  true ? "prismic:".concat("vaude-demo", ":repository-ref") : 0;
/**
 * Fetch vers l'endpoint repository (/api/v2) - on force toujours le token si dispo.
 * Le client Prismic peut faire des appels /api/v2 sans token dans certains cas ;
 * ce wrapper garantit que toutes les requêtes repository ont le token.
 */ var fetchRepositoryWithToken = function(url) {
    var token = process.env.PRISMIC_ACCESS_TOKEN;
    var urlWithToken = token && !url.includes('access_token=') ? "".concat(url.includes('?') ? url + '&' : url + '?', "access_token=").concat(token) // eslint-disable-line
     : url;
    var reqHeaders = {
        'User-Agent': 'lizee-debug/1.0'
    };
    try {
        var parsedUrl = new URL(urlWithToken);
        var queryParams = Object.fromEntries(parsedUrl.searchParams.entries());
        console.log('[Prismic fetchRepository]', {
            url: "".concat(parsedUrl.origin).concat(parsedUrl.pathname),
            headers: reqHeaders,
            queryParams: queryParams
        });
    } catch (e) {
        console.log('[Prismic fetchRepository]', {
            url: urlWithToken
        });
    }
    return fetch(urlWithToken, {
        headers: reqHeaders
    });
};
/**
 * Get the Prismic master ref from Redis cache or by fetching the Repository API.
 * Caching the ref in Redis avoids /api/v2 calls on every serverless cold start.
 */ var getMasterRef = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, ref1, cached, hasToken, response, data, masterRef;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (false) {}
                    return _ctx.abrupt("return", undefined);
                case 3:
                    if (!(redis && REPOSITORY_CACHE_KEY)) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 6;
                    return redis.get(REPOSITORY_CACHE_KEY);
                case 6:
                    cached = _ctx.sent;
                    if (!cached) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", cached);
                case 9:
                    hasToken = !!process.env.PRISMIC_ACCESS_TOKEN;
                    logPrismicCall('getMasterRef (repository /api/v2)', hasToken);
                    _ctx.next = 13;
                    return fetchRepositoryWithToken(endpoint);
                case 13:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 16;
                        break;
                    }
                    throw new Error("Prismic repository fetch failed: ".concat(response.status));
                case 16:
                    _ctx.next = 18;
                    return response.json();
                case 18:
                    data = _ctx.sent;
                    masterRef = (ref1 = (ref = data.refs) === null || ref === void 0 ? void 0 : ref.find(function(r) {
                        return r.isMasterRef;
                    })) === null || ref1 === void 0 ? void 0 : ref1.ref;
                    if (masterRef) {
                        _ctx.next = 22;
                        break;
                    }
                    throw new Error('No master ref in Prismic repository');
                case 22:
                    if (!(redis && REPOSITORY_CACHE_KEY)) {
                        _ctx.next = 25;
                        break;
                    }
                    _ctx.next = 25;
                    return redis.set(REPOSITORY_CACHE_KEY, masterRef, 'EX', REPOSITORY_REF_TTL);
                case 25:
                    return _ctx.abrupt("return", masterRef);
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMasterRef() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Shared Prismic client singleton (server-side only).
 * Uses ref from Redis cache to avoid /api/v2 repository calls on cold starts.
 */ var sharedClient;
var getSharedClient = function() {
    if (!sharedClient) {
        var accessToken = process.env.PRISMIC_ACCESS_TOKEN;
        logPrismicCall('createClient (shared) - client configur\xe9', !!accessToken);
        var clientOptions = {
            ref: getMasterRef,
            accessToken: accessToken
        };
        var prismicFetch = createPrismicFetch();
        if (prismicFetch) {
            clientOptions.fetch = prismicFetch;
        }
        sharedClient = dist/* createClient */.eI(endpoint, clientOptions);
    }
    return sharedClient;
};
/**
 * Create a Prismic client
 * @description Returns the shared singleton client for normal requests,
 * or a fresh client when preview mode is active (previewData / req).
 * Uses Redis-cached master ref to avoid /api/v2 calls on every serverless instance.
 * @warning Prismic api calls should be only on server side
 * @param {Object} config - The configuration object
 */ var prismicio_createClient = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    checkPrismicTokenInProd();
    var isPreview = config.previewData || config.req;
    var accessToken = process.env.PRISMIC_ACCESS_TOKEN;
    if (isPreview) {
        logPrismicCall('createClient (preview) - client configur\xe9', !!accessToken);
    }
    var clientOptions = {
        ref: getMasterRef,
        accessToken: accessToken
    };
    var prismicFetch = createPrismicFetch();
    if (prismicFetch) {
        clientOptions.fetch = prismicFetch;
    }
    var client = isPreview ? dist/* createClient */.eI(endpoint, clientOptions) : getSharedClient();
    (0,enableAutoPreviews/* enableAutoPreviews */.L)({
        client: client,
        previewData: config.previewData,
        req: config.req
    });
    return client;
};
/**
 * Wrapper function for Prismic API calls with Redis caching and retry logic
 * @description Handles caching, retry logic, and error handling for Prismic API calls
 * @param {string} cacheKey - The Redis cache key
 * @param {Function} fetchFn - The Prismic API call function to execute
 * @param {string} errorContext - Context string for error logging
 */ var NOT_FOUND = '__NOT_FOUND__';
var CACHE_TTL = 60 * 15 // 15 minutes
;
var CACHE_TTL_ALL = 60 * 60 // 1 hour for getAllDocuments (used by sitemap, changes rarely)
;
var NOT_FOUND_TTL = 60 * 60 * 24 // 24 hours
;
var RETRY_TTL = 60 // 1 minute
;
var MAX_RETRIES = 3;
// --- Lizee CMS ---
var USE_LIZEE_CMS = "true" === 'true';
var lizetCMSFetch = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(path) {
        var queryParams, baseUrl, token, url, response, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryParams = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    baseUrl = "https://api-staging.lizee.io";
                    token = "n0oh7ifOrgMLwAzfTnQqCONFfxp0JAhc";
                    url = new URL("".concat(baseUrl).concat(path));
                    Object.entries(queryParams).forEach(function(param) {
                        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                        if (value !== undefined && value !== null && value !== '') {
                            url.searchParams.set(key, String(value));
                        }
                    });
                    _ctx.next = 7;
                    return fetch(url.toString(), {
                        headers: {
                            'x-api-key': token
                        }
                    });
                case 7:
                    response = _ctx.sent;
                    if (!(response.status === 404)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 10:
                    if (response.ok) {
                        _ctx.next = 12;
                        break;
                    }
                    throw new Error("Lizee CMS fetch failed: ".concat(response.status));
                case 12:
                    return _ctx.abrupt("return", response.json());
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function lizetCMSFetch(path) {
        return _ref.apply(this, arguments);
    };
}();
var getLizeeSingleDocument = function(lang, type) {
    var cacheKey =  true ? "lizee-cms:".concat("vaude-demo", ":").concat(type, ":").concat(lang) : 0;
    return withPrismicCache(cacheKey, _asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, data, ref2;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return lizetCMSFetch('/api/cms/documents', {
                        type: type,
                        lang: lang,
                        pageSize: 1
                    });
                case 3:
                    data = _ctx.sent;
                    ;
                    return _ctx.abrupt("return", (ref2 = data === null || data === void 0 ? void 0 : (ref = data.results) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref2 !== void 0 ? ref2 : null);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), "Error fetching Lizee CMS document \"".concat(type, "\" in \"").concat(lang, "\":"));
};
var getLizeeByUID = function(documentType, uid, lang) {
    var cacheKey =  true ? "lizee-cms:".concat("vaude-demo", ":").concat(documentType, ":").concat(uid, ":").concat(lang) : 0;
    return withPrismicCache(cacheKey, _asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, data, ref3;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return lizetCMSFetch('/api/cms/documents', {
                        type: documentType,
                        lang: lang
                    });
                case 3:
                    data = _ctx.sent;
                    ;
                    return _ctx.abrupt("return", (ref3 = data === null || data === void 0 ? void 0 : (ref = data.results) === null || ref === void 0 ? void 0 : ref.find(function(doc) {
                        return doc.uid === uid;
                    })) !== null && ref3 !== void 0 ? ref3 : null);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), "Error fetching Lizee CMS document \"".concat(documentType, "\" with UID \"").concat(uid, "\" in \"").concat(lang, "\":"));
};
var getLizeeByType = function(documentType, lang) {
    var cacheKey =  true ? "lizee-cms:".concat("vaude-demo", ":type:").concat(documentType, ":").concat(lang) : 0;
    return withPrismicCache(cacheKey, function() {
        return lizetCMSFetch('/api/cms/documents', {
            type: documentType,
            lang: lang
        });
    }, "Error fetching Lizee CMS documents of type \"".concat(documentType, "\" in \"").concat(lang, "\":"));
};
var getLizeeAllDocuments = function() {
    var cacheKey =  true ? "lizee-cms:".concat("vaude-demo", ":all") : 0;
    return withPrismicCache(cacheKey, function() {
        return lizetCMSFetch('/api/cms/documents');
    }, 'Error fetching all Lizee CMS documents:', CACHE_TTL_ALL);
};
var isDocumentNotFound = function(error) {
    var ref;
    return error === null || error === void 0 ? void 0 : (ref = error.message) === null || ref === void 0 ? void 0 : ref.includes('No documents were returned');
};
var logPrismicCacheError = function(message) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var cacheKey = _param.cacheKey, error = _param.error, extra = _objectWithoutProperties(_param, [
        "cacheKey",
        "error"
    ]);
    console.error("[Prismic cache] ".concat(message), _objectSpread({
        cacheKey: cacheKey !== null && cacheKey !== void 0 ? cacheKey : null
    }, error && {
        errorMessage: error === null || error === void 0 ? void 0 : error.message,
        errorStack: error === null || error === void 0 ? void 0 : error.stack
    }, extra));
};
var logPrismicCacheDebug = function(message) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var cacheKey = _param.cacheKey, extra = _objectWithoutProperties(_param, [
        "cacheKey"
    ]);
    if (process.env.PRISMIC_DEBUG_LOGS !== 'true') return;
    console.log("[Prismic cache] ".concat(message), _objectSpread({
        cacheKey: cacheKey !== null && cacheKey !== void 0 ? cacheKey : null
    }, extra));
};
var withPrismicCache = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(cacheKey, fetchFn, errorContext) {
        var ttl, cachedData, parsed, data, prefix, keys, _redis, cachedData1, parsed1, retryCount, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ttl = _args.length > 3 && _args[3] !== void 0 ? _args[3] : CACHE_TTL;
                    _ctx.prev = 1;
                    if (false) {}
                    _ctx.next = 5;
                    return fetchFn();
                case 5:
                    return _ctx.abrupt("return", _ctx.sent);
                case 6:
                    if (!(!redis || !cacheKey)) {
                        _ctx.next = 11;
                        break;
                    }
                    logPrismicCacheDebug('Cache bypassed (Redis or cacheKey missing)', {
                        cacheKey: cacheKey,
                        hasRedis: Boolean(redis),
                        errorContext: errorContext
                    });
                    _ctx.next = 10;
                    return fetchFn();
                case 10:
                    return _ctx.abrupt("return", _ctx.sent);
                case 11:
                    _ctx.next = 13;
                    return redis.get(cacheKey);
                case 13:
                    cachedData = _ctx.sent;
                    if (!cachedData) {
                        _ctx.next = 25;
                        break;
                    }
                    parsed = JSON.parse(cachedData);
                    if (!(parsed === NOT_FOUND)) {
                        _ctx.next = 19;
                        break;
                    }
                    logPrismicCacheDebug('Cache hit: NOT_FOUND', {
                        cacheKey: cacheKey
                    });
                    return _ctx.abrupt("return", null);
                case 19:
                    if (!(typeof parsed === 'object' && parsed !== null)) {
                        _ctx.next = 22;
                        break;
                    }
                    logPrismicCacheDebug('Cache hit', {
                        cacheKey: cacheKey
                    });
                    return _ctx.abrupt("return", parsed);
                case 22:
                    logPrismicCacheDebug('Cache miss (retry counter)', {
                        cacheKey: cacheKey,
                        retryCount: parsed
                    });
                    _ctx.next = 26;
                    break;
                case 25:
                    {
                        logPrismicCacheDebug('Cache miss', {
                            cacheKey: cacheKey,
                            errorContext: errorContext
                        });
                    }
                case 26:
                    _ctx.next = 28;
                    return fetchFn();
                case 28:
                    data = _ctx.sent;
                    if (!data) {
                        _ctx.next = 35;
                        break;
                    }
                    _ctx.next = 32;
                    return redis.set(cacheKey, JSON.stringify(data), 'EX', ttl);
                case 32:
                    logPrismicCacheDebug('Fetched and cached', {
                        cacheKey: cacheKey,
                        ttl: ttl
                    });
                    _ctx.next = 36;
                    break;
                case 35:
                    {
                        logPrismicCacheDebug('Fetch returned empty data', {
                            cacheKey: cacheKey,
                            errorContext: errorContext
                        });
                    }
                case 36:
                    return _ctx.abrupt("return", data);
                case 39:
                    _ctx.prev = 39;
                    _ctx.t0 = _ctx["catch"](1);
                    logPrismicCacheError(errorContext, {
                        cacheKey: cacheKey,
                        error: _ctx.t0
                    });
                    if (!(redis && cacheKey)) {
                        _ctx.next = 86;
                        break;
                    }
                    if (!cacheKey.includes('general')) {
                        _ctx.next = 59;
                        break;
                    }
                    prefix = "prismic:".concat("vaude-demo", ":*");
                    _ctx.prev = 45;
                    _ctx.next = 48;
                    return redis.keys(prefix);
                case 48:
                    keys = _ctx.sent;
                    if (!(keys.length > 0)) {
                        _ctx.next = 53;
                        break;
                    }
                    ;
                    _ctx.next = 53;
                    return (_redis = redis).del.apply(_redis, _toConsumableArray(keys));
                case 53:
                    logPrismicCacheError('Purged client cache after general document failure', {
                        cacheKey: cacheKey,
                        keysDeleted: keys.length,
                        prefix: prefix
                    });
                    _ctx.next = 59;
                    break;
                case 56:
                    _ctx.prev = 56;
                    _ctx.t1 = _ctx["catch"](45);
                    logPrismicCacheError('Failed to purge client cache', {
                        cacheKey: cacheKey,
                        error: _ctx.t1,
                        prefix: prefix
                    });
                case 59:
                    if (!isDocumentNotFound(_ctx.t0)) {
                        _ctx.next = 64;
                        break;
                    }
                    logPrismicCacheError('Document not found, caching NOT_FOUND marker', {
                        cacheKey: cacheKey,
                        error: _ctx.t0,
                        notFoundTtl: NOT_FOUND_TTL
                    });
                    _ctx.next = 63;
                    return redis.set(cacheKey, JSON.stringify(NOT_FOUND), 'EX', NOT_FOUND_TTL);
                case 63:
                    return _ctx.abrupt("return", null);
                case 64:
                    _ctx.next = 66;
                    return redis.get(cacheKey);
                case 66:
                    cachedData1 = _ctx.sent;
                    parsed1 = cachedData1 ? JSON.parse(cachedData1) : null;
                    if (!(typeof parsed1 === 'object' && parsed1 !== null)) {
                        _ctx.next = 73;
                        break;
                    }
                    logPrismicCacheError('Returning stale cached data after fetch error', {
                        cacheKey: cacheKey,
                        error: _ctx.t0
                    });
                    _ctx.next = 72;
                    return redis.expire(cacheKey, ttl);
                case 72:
                    return _ctx.abrupt("return", parsed1);
                case 73:
                    retryCount = 0;
                    if (typeof parsed1 === 'number') {
                        retryCount = parsed1;
                    }
                    if (!(retryCount < MAX_RETRIES)) {
                        _ctx.next = 81;
                        break;
                    }
                    logPrismicCacheError('Fetch failed, incrementing retry counter', {
                        cacheKey: cacheKey,
                        error: _ctx.t0,
                        retryCount: retryCount + 1,
                        maxRetries: MAX_RETRIES,
                        retryTtl: RETRY_TTL
                    });
                    _ctx.next = 79;
                    return redis.set(cacheKey, JSON.stringify(retryCount + 1), 'EX', RETRY_TTL);
                case 79:
                    _ctx.next = 84;
                    break;
                case 81:
                    logPrismicCacheError('Max retries reached, caching null response', {
                        cacheKey: cacheKey,
                        error: _ctx.t0,
                        maxRetries: MAX_RETRIES,
                        cacheTtl: CACHE_TTL
                    });
                    _ctx.next = 84;
                    return redis.set(cacheKey, JSON.stringify(null), 'EX', CACHE_TTL);
                case 84:
                    _ctx.next = 87;
                    break;
                case 86:
                    {
                        logPrismicCacheError('Cannot recover via Redis (missing client or cacheKey)', {
                            cacheKey: cacheKey,
                            error: _ctx.t0,
                            hasRedis: Boolean(redis)
                        });
                    }
                case 87:
                    return _ctx.abrupt("return", null);
                case 88:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                39
            ],
            [
                45,
                56
            ]
        ]);
    }));
    return function withPrismicCache(cacheKey, fetchFn, errorContext) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get a single document from Prismic
 * @description Get a single document from Prismic with the given configuration
 * @warning Prismic api calls should be only on server side
 * @param {Object} client - The Prismic client
 * @param {string} lang - The language of the document
 * @param {string} document - The document type
 */ var prismicio_getSingleDocument = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(client, lang, document) {
        var cacheKey;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!USE_LIZEE_CMS) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", getLizeeSingleDocument(lang, document));
                case 2:
                    logPrismicCall("getSingleDocument(".concat(document, ", ").concat(lang, ")"), !!process.env.PRISMIC_ACCESS_TOKEN);
                    cacheKey =  true ? "prismic:".concat("vaude-demo", ":").concat(document, ":").concat(lang) : 0;
                    return _ctx.abrupt("return", withPrismicCache(cacheKey, function() {
                        return client.getSingle(document, {
                            lang: lang
                        });
                    }, "Error fetching document \"".concat(document, "\" in \"").concat(lang, "\":")));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSingleDocument(client, lang, document) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get a document by UID from Prismic
 * @description Get a document by UID from Prismic with the given configuration
 * @warning Prismic api calls should be only on server side
 * @param {Object} client - The Prismic client
 * @param {string} documentType - The document type
 * @param {string} uid - The document UID
 * @param {string} lang - The language of the document
 */ var getByUID = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(client, documentType, uid, lang) {
        var cacheKey;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!USE_LIZEE_CMS) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", getLizeeByUID(documentType, uid, lang));
                case 2:
                    logPrismicCall("getByUID(".concat(documentType, ", ").concat(uid, ", ").concat(lang, ")"), !!process.env.PRISMIC_ACCESS_TOKEN);
                    cacheKey =  true ? "prismic:".concat("vaude-demo", ":").concat(documentType, ":").concat(uid, ":").concat(lang) : 0;
                    return _ctx.abrupt("return", withPrismicCache(cacheKey, function() {
                        return client.getByUID(documentType, uid, {
                            lang: lang
                        });
                    }, "Error fetching document \"".concat(documentType, "\" with UID \"").concat(uid, "\" in \"").concat(lang, "\":")));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getByUID(client, documentType, uid, lang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get documents by type from Prismic
 * @warning Prismic api calls should be only on server side
 * @param {Object} client - The Prismic client
 * @param {string} documentType - The document type to query
 * @param {string} lang - The language of the documents
 */ var getByType = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(client, documentType, lang) {
        var cacheKey;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!USE_LIZEE_CMS) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", getLizeeByType(documentType, lang));
                case 2:
                    logPrismicCall("getByType(".concat(documentType, ", ").concat(lang, ")"), !!process.env.PRISMIC_ACCESS_TOKEN);
                    cacheKey =  true ? "prismic:".concat("vaude-demo", ":type:").concat(documentType, ":").concat(lang) : 0;
                    return _ctx.abrupt("return", withPrismicCache(cacheKey, function() {
                        return client.get({
                            predicates: dist/* predicate.at */.lx.at('document.type', documentType),
                            lang: lang
                        });
                    }, "Error fetching documents of type \"".concat(documentType, "\" in \"").concat(lang, "\":")));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getByType(client, documentType, lang) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get all documents from Prismic (no type filter)
 * @warning Prismic api calls should be only on server side
 * @param {Object} client - The Prismic client
 */ var getAllDocuments = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(client) {
        var cacheKey;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!USE_LIZEE_CMS) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", getLizeeAllDocuments());
                case 2:
                    logPrismicCall('getAllDocuments()', !!process.env.PRISMIC_ACCESS_TOKEN);
                    cacheKey =  true ? "prismic:".concat("vaude-demo", ":all") : 0;
                    return _ctx.abrupt("return", withPrismicCache(cacheKey, function() {
                        return client.get({
                            predicates: ''
                        });
                    }, 'Error fetching all documents:', CACHE_TTL_ALL));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAllDocuments(client) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get multiple documents from Prismic
 * @description Get multiple documents from Prismic with the given configuration
 * @warning Prismic api calls should be only on server side
 * @param {Object} documents - The documents to get
 * @param {string} locale - The language of the documents
 * @param {Object} previewData - The preview data
 */ var getPrismicDocuments = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(documents, locale, previewData) {
        var client, lang, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    client = prismicio_createClient({
                        previewData: previewData
                    });
                    lang = (0,utils/* setFullLocale */.vQ)(locale);
                    _ctx.next = 4;
                    return Promise.all(Object.values(documents).map(function(document) {
                        return prismicio_getSingleDocument(client, lang, document);
                    }));
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", Object.fromEntries(Object.keys(documents).map(function(key, index) {
                        return [
                            key,
                            data[index]
                        ];
                    })));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPrismicDocuments(documents, locale, previewData) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/Sizes/SizeButton.tsx



var SizeButton = function(param) {
    var variant = param.variant, index = param.index, code = param.code, type = param.type, cart = param.cart, classes = param.classes, handleChange = param.handleChange;
    var ref2;
    var isSelected = variant.code === code;
    var selectedClass = isSelected ? "selected ".concat(classes.selected) : '';
    var buttonClass = "sizes__btn ".concat(classes.sizeButton, " ").concat(selectedClass);
    var quantityChipClass = "sizes__chip ".concat(classes.quantityChip, " ").concat(isSelected ? '' : classes.quantityChipSelected);
    var variantInCart = (0,react.useMemo)(function() {
        var ref, ref1;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.find(function(el) {
            return el.product.variants[0].code === variant.code;
        });
    }, [
        cart,
        variant.code
    ]);
    var quantity = variantInCart === null || variantInCart === void 0 ? void 0 : variantInCart.quantity;
    var onSelect = function() {
        handleChange(variant.code, variant.name);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        size: "small",
        "data-testid": "sizebuttonAdd-".concat(index),
        className: buttonClass,
        onClick: onSelect,
        children: [
            type === 'pack' ? variant === null || variant === void 0 ? void 0 : (ref2 = variant.newSize) === null || ref2 === void 0 ? void 0 : ref2.name : variant === null || variant === void 0 ? void 0 : variant.size,
            quantity && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: quantityChipClass,
                children: quantity
            })
        ]
    }));
};
/* harmony default export */ var Sizes_SizeButton = (SizeButton);

// EXTERNAL MODULE: ./components/Sizes/TakeBackSize.tsx + 1 modules
var TakeBackSize = __webpack_require__(95189);
// EXTERNAL MODULE: ./components/Products/Product.styles.ts
var Product_styles = __webpack_require__(30327);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
// EXTERNAL MODULE: ./utils/takeBack.tsx + 2 modules
var takeBack = __webpack_require__(71323);
// EXTERNAL MODULE: ./redux/actions/takeBack.ts + 1 modules
var actions_takeBack = __webpack_require__(42738);
// EXTERNAL MODULE: ./components/Products/ProductTitle.tsx + 1 modules
var ProductTitle = __webpack_require__(48833);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./utils/takeBackFiltersConditions.tsx
var takeBackFiltersConditions = __webpack_require__(61429);
// EXTERNAL MODULE: ./utils/filters.tsx
var filters = __webpack_require__(92412);
// EXTERNAL MODULE: ./utils/taxPricing.ts
var taxPricing = __webpack_require__(59973);
;// CONCATENATED MODULE: ./components/Sizes/SizeCard.tsx
/* provided dependency */ var SizeCard_process = __webpack_require__(34155);































function SizeCard_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SizeCard_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SizeCard_arrayLikeToArray(arr);
}
function SizeCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SizeCard_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SizeCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SizeCard_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SizeCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SizeCard_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SizeCard_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SizeCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SizeCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SizeCard_toConsumableArray(arr) {
    return SizeCard_arrayWithoutHoles(arr) || SizeCard_iterableToArray(arr) || SizeCard_unsupportedIterableToArray(arr) || SizeCard_nonIterableSpread();
}
function SizeCard_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SizeCard_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SizeCard_arrayLikeToArray(o, minLen);
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1;
    return (0,createStyles/* default */.Z)({
        root: SizeCard_defineProperty({
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            padding: theme.spacing(2),
            marginBottom: theme.spacing(0)
        }),
        productCard: (_obj = {
            //display: 'flex',
            position: 'relative',
            minWidth: 320,
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            margin: theme.spacing(1, 0),
            padding: theme.spacing(1)
        }, SizeCard_defineProperty(_obj, theme.breakpoints.down('sm'), {
            display: 'block'
        }), SizeCard_defineProperty(_obj, theme.breakpoints.up('lg'), {
            minWidth: 460
        }), _obj),
        image: {
            borderRadius: theme.shape.borderRadius
        },
        details: SizeCard_defineProperty({
            flexGrow: 1,
            padding: theme.spacing(0, 0, 0, 0.5)
        }, theme.breakpoints.down('xs'), {
            padding: 0
        }),
        closeButton: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
            backgroundColor: theme.extraColors.greyLight
        },
        cross: {
            cursor: 'pointer',
            height: 40,
            width: 40,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.secondary.main,
            borderRadius: 20,
            margin: theme.spacing(1)
        },
        productName: {
            fontWeight: 400,
            fontSize: 14,
            marginTop: theme.spacing(1)
        },
        sizes: {
            marginTop: theme.spacing(1),
            '& .MuiTypography-root': {
                fontWeight: 400
            }
        },
        sizes__list: {
            padding: theme.spacing(0.25),
            borderRadius: theme.spacing(1),
            textAlign: 'left',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gridTemplateRows: '1fr 1fr 1fr',
            columnGap: '0.5rem',
            justifyContent: 'center',
            width: '100%'
        },
        withoutStock: {
            height: '6px',
            width: '6px',
            backgroundColor: '#B5B5B5',
            borderRadius: '50%',
            position: 'relative',
            top: '30%',
            left: '82%',
            zIndex: 1
        },
        withStock: {
            height: '6px',
            width: '6px',
            backgroundColor: '#47E169',
            borderRadius: '50%',
            position: 'relative',
            top: '30%',
            left: '82%',
            zIndex: 1
        },
        addButton: (_obj1 = {
            display: 'flex',
            justifyContent: 'flex-end'
        }, SizeCard_defineProperty(_obj1, theme.breakpoints.down('sm'), {
            justifyContent: 'flex-end'
        }), SizeCard_defineProperty(_obj1, "marginTop", theme.spacing(1)), _obj1),
        returnButton: {
            justifyContent: 'flex-start'
        },
        sizeButton: SizeCard_defineProperty({
            backgroundColor: theme.extraColors.greyLight,
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.common.black,
                color: theme.palette.common.white
            },
            '&.sold-out': {
                opacity: 0.5,
                color: theme.palette.error.main
            },
            '& span': {
                whiteSpace: 'nowrap'
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        selected: {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
            '&:hover': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.common.black
            }
        },
        quantSelector: {
            marginRight: theme.spacing(2),
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex'
        },
        quantityChip: {
            position: 'absolute',
            top: -5,
            right: -5,
            minWidth: 20,
            height: 20,
            lineHeight: 1,
            borderRadius: 10,
            display: 'flex',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.palette.secondary.main,
            padding: theme.spacing(0.5),
            color: theme.palette.common.white,
            marginLeft: theme.spacing(2)
        },
        quantityChipSelected: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white
        },
        titleInHeader: {
            padding: theme.spacing(1)
        },
        selectContainer: {
            position: 'relative'
        },
        sizeSelector: {
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.5, 2, 0.5, 1),
            margin: theme.spacing(0.5),
            backgroundColor: theme.extraColors.greyLight,
            minWidth: '84%',
            color: theme.palette.common.black,
            height: 40,
            fontWeight: 700,
            border: 'none'
        },
        quantitySelected: {
            position: 'absolute',
            top: 0,
            right: 'auto',
            left: "calc(84% - ".concat(theme.spacing(0.5), "px)"),
            margin: 0
        },
        availability: {
            position: 'absolute',
            zIndex: 2,
            top: '50%',
            left: '50%',
            transform: 'translate3D(-50%, -50%, 0)',
            padding: theme.spacing(1, 1.5),
            fontSize: 11,
            borderRadius: 36,
            textAlign: 'center'
        },
        unavailable: {
            color: theme.palette.common.white,
            background: theme.extraColors.greyMedium
        },
        valign: {
            display: 'flex',
            minHeight: '100%',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        media: {
            position: 'relative'
        },
        badge: {
            zIndex: 2,
            position: 'absolute',
            top: 0,
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '90%',
            fontWeight: 700,
            lineHeight: 1,
            padding: '.25em',
            minWidth: '1.75em',
            height: '1.75em',
            borderRadius: '1.75em',
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        }
    });
});
var mapStateToProps = function(state) {
    return {
        stores: state.stores,
        takeBackLP: state.takeBack,
        promotions: state.promotions,
        taxons: state.taxons.items
    };
};
var mapDispatchToProps = {
    getTakeBackStock: actions_takeBack/* getTakeBackStock */.Rl
};
var SizeCard = function(param) {
    var product = param.product, productsQty = param.productsQty, onQuantityChange = param.onQuantityChange, handlePackSelection = param.handlePackSelection, stock = param.stock, type = param.type, cart = param.cart, text = param.text, thumbRatio = param.thumbRatio, thumbWidth = param.thumbWidth, settings = param.settings, currentUrl = param.currentUrl, stores = param.stores, singleProductRes = param.singleProductRes, productSettings = param.productSettings, takeBackLP = param.takeBackLP, takeback = param.takeback, isSecondHandTaxon = param.isSecondHandTaxon, secondHandAvailability = param.secondHandAvailability, getTakeBackStock1 = param.getTakeBackStock, addedToCart = param.addedToCart, promotions = param.promotions, taxons = param.taxons;
    var ref43, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var classes = useStyles();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref20 = (0,react.useState)(''), code1 = ref20[0], setCode = ref20[1];
    var ref21 = (0,react.useState)(''), name1 = ref21[0], setName = ref21[1];
    var ref22 = (0,react.useState)(0), cartQuantity1 = ref22[0], setCartQuantity = ref22[1];
    var ref23 = (0,react.useState)(type === 'pack' ? productsQty : 1), choosenQuantity = ref23[0], setChoosenQuantity = ref23[1];
    var ref24 = (0,react.useState)(null), maxItemStock = ref24[0], setMaxItemStock = ref24[1];
    var ref25 = (0,react.useState)(true), availability = ref25[0], setAvailability = ref25[1];
    var ref26 = (0,react.useState)(-1), hasInStock = ref26[0], setHasInStock = ref26[1];
    var productClasses = (0,Product_styles/* useProductStyles */.p)();
    var ref27 = (0,react.useState)(false), noMoreStockAvailable = ref27[0], setNoMoreStockAvailable = ref27[1];
    var ref28 = (0,react.useState)(true), showQualities = ref28[0], setShowQualities = ref28[1];
    var ref29 = (0,react.useState)(''), selectedQuality = ref29[0], setSelectedQuality = ref29[1];
    var ref30 = (0,react.useState)([]), currentSizeQualities = ref30[0], setCurrentSizeQualities = ref30[1];
    var ref31 = (0,react.useState)(''), currentVariantCode = ref31[0], setCurrentVariantCode = ref31[1];
    var ref32 = (0,react.useState)(''), currentSku = ref32[0], setCurrentSku = ref32[1];
    var ref33 = (0,react.useState)([]), remainSecondHandSkusAfterCheckCart = ref33[0], setRemainSecondHandSkusAfterCheckCart = ref33[1];
    var ref34 = (0,react.useState)(0), minPrice = ref34[0], setMinPrice = ref34[1];
    var ref35 = (0,react.useState)(false), takeBackAvailability = ref35[0], setTakeBackAvailability = ref35[1];
    var ref36 = (0,react.useState)(false), isBuyableProduct = ref36[0], setIsBuyableProduct = ref36[1];
    var ref37 = (0,react.useState)(0), originalPrice = ref37[0], setOriginalPrice = ref37[1];
    var ref38 = (0,react.useState)(0), takeBackPrice = ref38[0], setTakeBackPrice = ref38[1];
    var ref39 = (0,react.useState)(0), takeBackPriceMin = ref39[0], setTakeBackPriceMin = ref39[1];
    var ref40 = (0,react.useState)(0), takeBackPriceMinTtc = ref40[0], setTakeBackPriceMinTtc = ref40[1];
    var ref41 = (0,react.useState)(0), selectedTakeBackOrRental = ref41[0], setSelectedTakeBackOrRental = ref41[1];
    var ref42 = (0,react.useState)(product), currentItem = ref42[0], setCurrentItem = ref42[1];
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var states = productCheckState(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    var addProductToCart = (0,useCart/* useCart */.j)().addProductToCart;
    var start = dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref43 = cart.item) === null || ref43 === void 0 ? void 0 : ref43.startLeasingDate, 'DD/MM/YYYY');
    var end = dayjs_min_default()(cart === null || cart === void 0 ? void 0 : (ref1 = cart.item) === null || ref1 === void 0 ? void 0 : ref1.endLeasingDate, 'DD/MM/YYYY');
    var dayRange = end.diff(start, 'day') + 1;
    var selectVariantLimit = (settings === null || settings === void 0 ? void 0 : settings.modal_size_select_display_limit) && (settings === null || settings === void 0 ? void 0 : settings.modal_size_select_display_limit) !== null ? settings.modal_size_select_display_limit : 6;
    var variants = [];
    (ref2 = Object.keys(product === null || product === void 0 ? void 0 : product.variants)) === null || ref2 === void 0 ? void 0 : ref2.map(function(variantIndex) {
        variants.push(product === null || product === void 0 ? void 0 : product.variants[variantIndex]);
    });
    var baseUrl =  true && window.location.origin ? window.location.origin : '';
    var warehouseId = (stores === null || stores === void 0 ? void 0 : (ref3 = stores.selectedStore) === null || ref3 === void 0 ? void 0 : ref3.warehouseId) ? stores === null || stores === void 0 ? void 0 : (ref4 = stores.selectedStore) === null || ref4 === void 0 ? void 0 : ref4.warehouseId : SizeCard_process.env.CUSTOM_WAREHOUSE ? SizeCard_process.env.CUSTOM_WAREHOUSE : null;
    var discountPriceFormat = settings === null || settings === void 0 ? void 0 : settings.discounted_price_display_format;
    var displayFlexPrice = settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day;
    var isDisplayTotalRentPrice = productSettings === null || productSettings === void 0 ? void 0 : (ref5 = productSettings.data) === null || ref5 === void 0 ? void 0 : ref5.display_total_rental_price;
    var currentPromotion = promotions === null || promotions === void 0 ? void 0 : promotions.currentPromotion;
    var currentFullUrl = baseUrl + router.asPath;
    //For now the stock alert is made only for sub stores
    var showStockAlert = constants/* isSubscription */.Nn;
    var productLayout = productSettings === null || productSettings === void 0 ? void 0 : (ref6 = productSettings.data) === null || ref6 === void 0 ? void 0 : ref6.product_layout;
    var addFromPack = settings === null || settings === void 0 ? void 0 : settings.only_add_with_pack;
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var secondHandStock = (0,react.useMemo)(function() {
        var ref;
        return stock === null || stock === void 0 ? void 0 : (ref = stock.stock) === null || ref === void 0 ? void 0 : ref.filter(function(skuStock) {
            return !!(skuStock === null || skuStock === void 0 ? void 0 : skuStock.secondHand);
        });
    }, [
        stock === null || stock === void 0 ? void 0 : stock.stock
    ]);
    var mainTaxon = (0,react.useMemo)(function() {
        var ref, ref44, ref45, ref46;
        if (!taxons.length || !(taxons === null || taxons === void 0 ? void 0 : (ref = taxons[0]) === null || ref === void 0 ? void 0 : (ref44 = ref.children) === null || ref44 === void 0 ? void 0 : ref44.length) || !product) return null;
        var taxonsMap = new Map(taxons[0].children.map(function(taxon) {
            return [
                taxon.code,
                taxon
            ];
        }));
        var mainTaxons = product === null || product === void 0 ? void 0 : (ref45 = product.taxons) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.others) === null || ref46 === void 0 ? void 0 : ref46.map(function(code) {
            return taxonsMap.get(code);
        });
        return mainTaxons === null || mainTaxons === void 0 ? void 0 : mainTaxons[0];
    }, [
        taxons,
        product
    ]);
    var mainTaxonSlug = (product === null || product === void 0 ? void 0 : (ref7 = product.taxons) === null || ref7 === void 0 ? void 0 : ref7.main) || (mainTaxon === null || mainTaxon === void 0 ? void 0 : mainTaxon.slug);
    var isNewButRepairedTaxon = mainTaxonSlug === constants/* NEW_BUT_REPAIRED_TAXON_SLUG */.Q0;
    var handleSizeSelected = function(sku) {
        var ref;
        var qualitiesArray = (0,takeBack/* createProductsQualityArrayBySize */.vO)(takeBackLP === null || takeBackLP === void 0 ? void 0 : takeBackLP.takeBackStock, sku, states, cart);
        setCurrentSizeQualities(qualitiesArray);
        setCurrentVariantCode((ref = Object.values(product.variants)) === null || ref === void 0 ? void 0 : ref.find(function(el) {
            return el.sku === sku;
        }).code);
        setShowQualities(true);
        setSelectedQuality('');
        setCurrentSku(sku);
        var availableConditions = qualitiesArray.filter(function(quality) {
            return !quality.disabled;
        }).map(function(quality) {
            return quality.quality;
        });
        var filteredConditions = (0,takeBackFiltersConditions/* getAvailableFilteredConditions */.DM)(availableConditions);
        var chosenCondition = (0,filters/* getLowestConditionByConditions */.bE)(filteredConditions ? (0,takeBackFiltersConditions/* getAvailableFilteredConditions */.DM)(availableConditions) : availableConditions);
        var preselectedCondition = qualitiesArray.find(function(qualityInfo) {
            return qualityInfo.quality === chosenCondition;
        });
        handleStateSelected(preselectedCondition);
    };
    var handleStateSelected = function(quality) {
        var _images, _images1;
        var ref, ref47, ref48;
        setSelectedQuality(quality === null || quality === void 0 ? void 0 : quality.quality);
        var numberInCart = (0,takeBack/* currentQualityInCart */.bz)(quality.quality, currentSku, cart);
        var item = SizeCard_objectSpread({}, product);
        var images = [];
        (_images = images).push.apply(_images, SizeCard_toConsumableArray((ref = quality === null || quality === void 0 ? void 0 : quality.products[numberInCart]) === null || ref === void 0 ? void 0 : ref.images));
        (_images1 = images).push.apply(_images1, SizeCard_toConsumableArray(item.images));
        item.images = images;
        setCurrentItem(item);
        var currentPricesByCondition = (ref48 = (ref47 = Object.values(product.variants)) === null || ref47 === void 0 ? void 0 : ref47.find(function(el) {
            return el.sku === currentSku;
        })) === null || ref48 === void 0 ? void 0 : ref48.resalePrice;
        var price = currentPricesByCondition[quality.quality];
        setTakeBackPrice(price);
    };
    (0,react.useEffect)(function() {
        // reset quantity when cart change (ie if a product is delete, it update the quantity)
        var cartQuantity = cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
            return el.product.variants[0].code === code1;
        }) !== 'undefined' ? cart.item.items.find(function(el) {
            return el.product.variants[0].code === code1;
        }).quantity : 0;
        setCartQuantity(cartQuantity);
        if (cartQuantity !== 0) {
            setChoosenQuantity(cartQuantity);
        }
    }, [
        cart.item
    ]);
    (0,react.useEffect)(function() {
        var loadProductData = function() {
            var _ref = SizeCard_asyncToGenerator(runtime_default().mark(function _callee() {
                var SKUArray, takeBackStockPreLoaded, data, res, ChosenSizeAndCondition, currentProductSkus, secondHandStockForThisProduct;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            SKUArray = (0,utils/* getSkus */.ES)(product);
                            ;
                            if (!(SKUArray.length > 0)) {
                                _ctx.next = 8;
                                break;
                            }
                            data = {
                                lizeeSKUs: SKUArray
                            };
                            _ctx.next = 6;
                            return getTakeBackStock1(data);
                        case 6:
                            res = _ctx.sent;
                            takeBackStockPreLoaded = res.response;
                        case 8:
                            ChosenSizeAndCondition = (0,takeBack/* preSelectedSkuAndCondition */.dE)(secondHandStock, product, takeBackStockPreLoaded, states, cart, setNoMoreStockAvailable, router);
                            if ((ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.chosenSku) !== null && ChosenSizeAndCondition.chosenQuality !== undefined) {
                                setCurrentSku(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.chosenSku);
                                setCurrentSizeQualities(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.qualitiesArray);
                                setCurrentVariantCode(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.chosenCode);
                                setOriginalPrice(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.originalPrice);
                                setTakeBackPrice(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.currentPrice);
                                setSelectedQuality(ChosenSizeAndCondition.chosenQuality !== null ? ChosenSizeAndCondition.chosenQuality : ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.qualitiesArray.find(function(quality) {
                                    return !quality.disabled;
                                }).quality);
                                setCurrentItem(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.item);
                                currentProductSkus = Object.values(product.variants).map(function(variant) {
                                    return variant.sku;
                                });
                                secondHandStockForThisProduct = secondHandStock.filter(function(skuStock) {
                                    return currentProductSkus.includes(skuStock.lizeeSKU);
                                });
                                setRemainSecondHandSkusAfterCheckCart((0,takeBack/* getRemainSkusAvailableAfterCheckCart */.gd)(cart, secondHandStockForThisProduct));
                            }
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadProductData() {
                return _ref.apply(this, arguments);
            };
        }();
        loadProductData();
    }, [
        product
    ]);
    (0,react.useEffect)(function() {
        var ref50;
        var priceArray = [];
        var originalPriceArray = [];
        var takeBackPriceArray = [];
        var takeBackMinPriceArray = [];
        if (product && (stock === null || stock === void 0 ? void 0 : stock.stock) && (stock === null || stock === void 0 ? void 0 : (ref50 = stock.stock) === null || ref50 === void 0 ? void 0 : ref50.length) > 0) {
            var _Math, _Math1;
            // Handle rental availability
            var productAvailability = (0,utils/* checkProductAvailability */.HF)(stock, product);
            setAvailability(productAvailability.available);
            // Handle second hand availability
            setTakeBackAvailability(productAvailability.secondHandAvailable);
            // Handle Prices
            product === null || product === void 0 ? void 0 : product.variants.forEach(function(variant) {
                var ref;
                if (!(variant === null || variant === void 0 ? void 0 : variant.purchase)) {
                    var ref49;
                    priceArray.push(variant === null || variant === void 0 ? void 0 : (ref49 = variant.price) === null || ref49 === void 0 ? void 0 : ref49.current);
                    setIsBuyableProduct(false);
                } else {
                    priceArray.push(variant === null || variant === void 0 ? void 0 : variant.purchasePrice);
                    setIsBuyableProduct(true);
                }
                originalPriceArray.push(variant === null || variant === void 0 ? void 0 : (ref = variant.originalPrice) === null || ref === void 0 ? void 0 : ref.current);
            });
            // The price displayed on loading is the lowest price between all the variants
            setMinPrice((_Math = Math).min.apply(_Math, SizeCard_toConsumableArray(priceArray)));
            // Same logic for the original price
            setOriginalPrice((_Math1 = Math).min.apply(_Math1, SizeCard_toConsumableArray(originalPriceArray)));
            // Same logic for second hand prices with takeBackAvailability in mind
            if (productAvailability.secondHandAvailable) {
                product.variants.forEach(function(variant) {
                    if (variant === null || variant === void 0 ? void 0 : variant.resalePrice) {
                        Object.values(variant === null || variant === void 0 ? void 0 : variant.resalePrice).forEach(function(price) {
                            takeBackPriceArray.push(price);
                        });
                    }
                });
            }
            // find lowest 2nd hand price available
            if (productAvailability.secondHandAvailable) {
                takeBackMinPriceArray = (0,utils/* productLowestPrice */.OC)(product, takeBackLP);
            }
            if (takeBackMinPriceArray.length > 0) {
                // find the element with minimum price on takeBackMinPriceArray
                var foundTakeBackMinPriceObj = takeBackMinPriceArray.reduce(function(prev, curr) {
                    return prev.price < curr.price ? prev : curr;
                }, takeBackMinPriceArray[0]);
                var price1 = foundTakeBackMinPriceObj.price, taxIncludedInPrice = foundTakeBackMinPriceObj.taxIncludedInPrice, taxRate = foundTakeBackMinPriceObj.taxRate;
                var pricingWithTax = (0,taxPricing/* getPricingWithTaxInfo */.B)(price1, taxIncludedInPrice, taxRate);
                setTakeBackPriceMin(pricingWithTax.priceHt);
                setTakeBackPriceMinTtc(pricingWithTax.priceTtc);
            }
        }
    }, [
        product,
        stock,
        takeBackLP
    ]);
    (0,react.useEffect)(function() {
        var isAvailable = false;
        isAvailable = (0,utils/* checkProductAvailability */.HF)(stock, product).available;
        setAvailability(isAvailable);
        if (variants && variants.length <= 1) {
            setCode(variants[0].code);
            var variant = product.variants[0];
            var inStock = 0;
            var itemType = isSecondHandTaxon ? 'SECOND_HAND' : 'RENTAL';
            if (type === 'pack') {
                inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock, product.variants[0], itemType);
            } else {
                inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock, variant, itemType);
            }
            setHasInStock(inStock);
        }
    }, []);
    var handleSelect = function(event) {
        handleChange(event.target.value, event.target.value);
    };
    var handleChange = function(code, name) {
        var variant1 = product.variants.find(function(variant) {
            return variant.code === code;
        });
        setCode(code);
        setName(name);
        var inStock = 0;
        var cartQuantity = cart && cart.item && cart.item.items.length > 0 && typeof cart.item.items.find(function(el) {
            return el.product.variants[0].code === code;
        }) !== 'undefined' ? cart.item.items.find(function(el) {
            return el.product.variants[0].code === code;
        }).quantity : 0;
        var maxItemInStock;
        var itemType = isSecondHandTaxon ? 'SECOND_HAND' : 'RENTAL';
        if (type === 'pack') {
            var ref;
            if ((product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                var ref51;
                var id = product.variants.findIndex(function(variant) {
                    return variant.code === code;
                });
                maxItemInStock = (ref51 = product.variants[id]) === null || ref51 === void 0 ? void 0 : ref51.maxStock;
                setMaxItemStock(maxItemInStock ? maxItemInStock - cartQuantity : null);
                inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock, product.variants[id], itemType);
            } else {
                inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock, variant1, itemType);
                maxItemInStock = variant1 === null || variant1 === void 0 ? void 0 : variant1.maxStock;
                setMaxItemStock(maxItemInStock || null);
            }
        } else {
            inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock, variant1, itemType);
            maxItemInStock = variant1 === null || variant1 === void 0 ? void 0 : variant1.maxStock;
            setMaxItemStock(maxItemInStock || null);
        }
        setHasInStock(inStock);
        setCartQuantity(cartQuantity);
        if (type === 'pack') {
            var ref52, ref53, ref54;
            if (maxItemInStock === null || cartQuantity < maxItemInStock) {
                handlePackSelection(product.isSimpleProduct, product.code, code, choosenQuantity);
            } else {
                handlePackSelection(product.isSimpleProduct, product.code, code, 0);
            }
            var currentVariant = product.variants.find(function(variant) {
                return variant.code === code;
            });
            trackEvent({
                category: 'Products',
                action: "Size selected",
                name: "".concat(((ref52 = currentVariant.optionValues) === null || ref52 === void 0 ? void 0 : ref52.length) > 0 && ((ref53 = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.optionValues[0]) === null || ref53 === void 0 ? void 0 : ref53.code) ? (ref54 = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.optionValues[0]) === null || ref54 === void 0 ? void 0 : ref54.code : currentVariant.name)
            });
        } else {
            trackEvent({
                category: 'Products',
                action: "Size selected",
                name: "".concat(variant1 === null || variant1 === void 0 ? void 0 : variant1.size)
            });
        }
    };
    var changeQuantity = function(quantity) {
        // get stock
        var inStock = 0;
        var itemType = isSecondHandTaxon ? 'SECOND_HAND' : 'RENTAL';
        if (type === 'pack') {
            var id = getProductVariantIdByCode(product === null || product === void 0 ? void 0 : product.variants, code1);
            inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock, product.variants[id], itemType);
            if (quantity <= inStock) {
                trackEvent({
                    category: 'Products',
                    action: "Quantity changed",
                    name: "product ".concat(product === null || product === void 0 ? void 0 : product.name, " from ").concat(currentUrl),
                    value: quantity
                });
            }
        } else {
            var variant2 = product.variants.find(function(variant) {
                return variant.code === code1;
            });
            inStock = (0,utils/* checkStockQuantityByItemType */.qe)(stock, variant2, itemType);
            if (quantity <= inStock) {
                trackEvent({
                    category: 'Products',
                    action: "Quantity changed",
                    name: "product ".concat(product === null || product === void 0 ? void 0 : product.name, " from ").concat(currentUrl),
                    value: quantity
                });
            }
        }
        setHasInStock(inStock);
        // limit maximum product a client can select
        if (quantity <= inStock) {
            setChoosenQuantity(quantity);
            if (type === 'pack') {
                handlePackSelection(product.isSimpleProduct, product.code, code1, quantity);
            }
        }
    };
    var handleAdd = function() {
        var ref, ref55, ref56;
        var quantity = (settings === null || settings === void 0 ? void 0 : settings.has_quantity_selector) ? choosenQuantity : cartQuantity1 + 1;
        onQuantityChange(code1, name1, quantity);
        var price = isSecondHandTaxon ? (ref = product === null || product === void 0 ? void 0 : product.variants[0]) === null || ref === void 0 ? void 0 : ref.resalePrice[base/* SecondHandCondition.PERFECT_CONDITION */.pJ.PERFECT_CONDITION] : (ref55 = product === null || product === void 0 ? void 0 : product.variants[0]) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.price) === null || ref56 === void 0 ? void 0 : ref56.current;
        var unitaryPrice = (0,utils/* numberToPrice */.e8)(price);
        trackEvent({
            category: 'Add to Cart',
            action: "".concat(name1),
            name: "".concat(currentUrl),
            value: unitaryPrice
        });
    };
    (0,react.useEffect)(function() {
        var isAvailable = false;
        isAvailable = (0,utils/* checkProductAvailability */.HF)(stock, product).available;
        if (product.variants.length === 1 && isAvailable) {
            //ie there is only one variant
            handlePackSelection(product.isSimpleProduct, product.code, product.variants[0].code, choosenQuantity);
        }
    }, [
        availability
    ]);
    (0,react.useEffect)(function() {
        if (!takeBackAvailability && availability) {
            setSelectedTakeBackOrRental(0);
        }
        if (constants/* isSecondHandOnly */.G7 || isSecondHandTaxon) setSelectedTakeBackOrRental(1);
    }, [
        constants/* isSecondHandOnly */.G7,
        isSecondHandTaxon,
        takeBackAvailability,
        availability
    ]);
    //This part of code is made to identify the current short product selected
    //and its unique variant it is needed for the stockAlert component
    var currentVariantSelected = variants.find(function(variant) {
        return variant.code === code1;
    });
    var currentVariantSKU = currentVariantSelected === null || currentVariantSelected === void 0 ? void 0 : currentVariantSelected.sku;
    var currentVariantQuantity = (ref8 = stock === null || stock === void 0 ? void 0 : stock.stock.find(function(unit) {
        return unit.lizeeSKU === currentVariantSKU;
    })) === null || ref8 === void 0 ? void 0 : ref8.quantity;
    var shortProduct = currentVariantSKU ? [
        {
            sku: currentVariantSKU,
            quantity: currentVariantQuantity
        }, 
    ] : undefined;
    var sizeStockColor = function(variant) {
        var ref;
        var sku = stock === null || stock === void 0 ? void 0 : (ref = stock.stock) === null || ref === void 0 ? void 0 : ref.find(function(varSku) {
            return varSku.lizeeSKU === variant.sku;
        });
        return "sizes__btn-withoutStock ".concat((sku === null || sku === void 0 ? void 0 : sku.quantity) === 0 ? classes.withoutStock : classes.withStock);
    };
    var QuantitySelectorWrapper = function() {
        var ref;
        return hasInStock === 0 && showStockAlert ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockAlert/* default */.Z, {
            singleProductPrismicData: singleProductRes === null || singleProductRes === void 0 ? void 0 : singleProductRes.data,
            products: shortProduct,
            url: currentFullUrl,
            warehouseId: warehouseId
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.addButton,
            children: [
                availability && ((settings === null || settings === void 0 ? void 0 : settings.has_quantity_selector) && type === 'pack' || type === 'product' && (settings === null || settings === void 0 ? void 0 : settings.has_quantity_selector)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.quantSelector,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                        value: choosenQuantity,
                        disable: code1 === '' || !availability,
                        handleChange: changeQuantity,
                        min: 0,
                        max: maxItemStock,
                        variantSku: currentVariantSelected === null || currentVariantSelected === void 0 ? void 0 : currentVariantSelected.sku
                    })
                }),
                type === 'product' && !constants/* isSecondHandOnly */.G7 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    size: 'small',
                    color: "secondary",
                    "data-testid": "sizeValidbutton",
                    id: "sizeValidbutton",
                    disabled: cartQuantity1 + 1 === 0 || code1 === '' || maxItemStock !== null && cartQuantity1 + 1 > maxItemStock,
                    onClick: handleAdd,
                    children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : (ref = text.data) === null || ref === void 0 ? void 0 : ref.product_size_modal_cta_add, t('texts:shop:choose'))
                })
            ]
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)(classes.root, SizeCard_defineProperty({}, 'size-card__root', type !== 'pack')),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: (0,clsx_m/* default */.Z)('size-card', classes.productCard, SizeCard_defineProperty({}, 'size-card__no-spacing', type !== 'pack')),
                    children: [
                        !availability && !takeBackAvailability && variants.length <= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            noWrap: true,
                            component: "p",
                            className: (0,clsx_m/* default */.Z)('size-card__soldout', classes.availability, classes.unavailable),
                            variant: "body2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: text === null || text === void 0 ? void 0 : text.sold_out,
                                defaultText: t('texts:shop:victim_of_success')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(SizeCard_defineProperty({}, classes.details, type === 'pack')),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                className: (0,clsx_m/* default */.Z)(SizeCard_defineProperty({}, 'size-card__grid', type !== 'pack')),
                                container: true,
                                spacing: 2,
                                justify: 'center',
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        sm: 4,
                                        md: 4,
                                        className: (0,clsx_m/* default */.Z)(classes.media, SizeCard_defineProperty({}, 'grid-item__image', type !== 'pack')),
                                        children: [
                                            !(settings === null || settings === void 0 ? void 0 : settings.has_quantity_selector) && productsQty > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,clsx_m/* default */.Z)('badge', classes.badge),
                                                children: [
                                                    "x",
                                                    productsQty
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                "data-ratio": thumbRatio,
                                                height: '100%',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                    imagePaths: currentItem === null || currentItem === void 0 ? void 0 : currentItem.images[0],
                                                    settings: {
                                                        width: thumbWidth,
                                                        ar: thumbRatio === null || thumbRatio === void 0 ? void 0 : thumbRatio.substring(3),
                                                        quality: 50
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        sm: 8,
                                        md: 8,
                                        className: (0,clsx_m/* default */.Z)(classes.valign, 'gird-item__description'),
                                        children: !isSecondHandTaxon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "size-card__top",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            className: "size-card__title ".concat(classes.productName),
                                                            variant: "h4",
                                                            component: "div",
                                                            children: product.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            component: "p",
                                                            className: 'size-card__status',
                                                            children: [
                                                                code1 !== '' && hasInStock === 0 && (0,CMSText/* prismicText */.yz)(settings === null || settings === void 0 ? void 0 : settings.back_soon, t('texts:general:stock_texts:back_soon')),
                                                                code1 !== '' && hasInStock > 0 && hasInStock < 6 && (0,CMSText/* prismicText */.yz)(settings === null || settings === void 0 ? void 0 : settings.few_products_left, t('texts:general:stock_texts:few_products_left')),
                                                                code1 !== '' && hasInStock > 5 && (0,CMSText/* prismicText */.yz)(settings === null || settings === void 0 ? void 0 : settings.in_stock, t('texts:general:stock_texts:in_stock'))
                                                            ]
                                                        }),
                                                        code1 !== '' && maxItemStock !== null && cartQuantity1 + 1 > maxItemStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            component: "p",
                                                            color: 'error',
                                                            children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.max_item_in_cart, t('texts:shop:max_item_in_cart'))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "size-card__bottom",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "sizes ".concat(classes.sizes),
                                                            children: variants && variants.length > 1 && availability && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "h6",
                                                                component: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: type === 'pack' ? settings === null || settings === void 0 ? void 0 : (ref9 = settings.data) === null || ref9 === void 0 ? void 0 : ref9.sizes : settings === null || settings === void 0 ? void 0 : settings.sizes,
                                                                    defaultText: t('texts:general:sizes')
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "sizes__list ".concat(classes.sizes__list),
                                                            children: variants && variants.length > 1 && variants.length < selectVariantLimit + 1 && ((ref10 = variants === null || variants === void 0 ? void 0 : variants.sort(function(a, b) {
                                                                return a.position - b.position;
                                                            })) === null || ref10 === void 0 ? void 0 : ref10.map(function(variant, index) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: sizeStockColor(variant)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes_SizeButton, {
                                                                            classes: classes,
                                                                            variant: variant,
                                                                            index: index,
                                                                            code: code1,
                                                                            type: type,
                                                                            cart: cart,
                                                                            handleChange: handleChange
                                                                        })
                                                                    ]
                                                                }, index));
                                                            }))
                                                        }),
                                                        variants && variants.length > selectVariantLimit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)('sizes__select-container', classes.selectContainer),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                                    value: name1,
                                                                    className: (0,clsx_m/* default */.Z)('sizes__select', classes.sizeSelector),
                                                                    onChange: handleSelect,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: '',
                                                                            selected: true,
                                                                            children: t('texts:packs:select')
                                                                        }),
                                                                        variants === null || variants === void 0 ? void 0 : variants.map(function(variant, index) {
                                                                            var ref, ref57, ref58;
                                                                            var outOfStock = false;
                                                                            if (((ref57 = stock === null || stock === void 0 ? void 0 : (ref = stock.stock) === null || ref === void 0 ? void 0 : ref.find(function(varSku) {
                                                                                return varSku.lizeeSKU === variant.sku;
                                                                            })) === null || ref57 === void 0 ? void 0 : ref57.quantity) === 0) {
                                                                                outOfStock = true;
                                                                            }
                                                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                    value: variant === null || variant === void 0 ? void 0 : variant.code,
                                                                                    disabled: outOfStock,
                                                                                    children: type === 'pack' ? variant === null || variant === void 0 ? void 0 : (ref58 = variant.newSize) === null || ref58 === void 0 ? void 0 : ref58.name : variant === null || variant === void 0 ? void 0 : variant.size
                                                                                }, index)
                                                                            }));
                                                                        })
                                                                    ]
                                                                }),
                                                                cart && ((ref11 = cart.item) === null || ref11 === void 0 ? void 0 : ref11.items.length) > 0 && typeof (cart === null || cart === void 0 ? void 0 : (ref12 = cart.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.items) === null || ref13 === void 0 ? void 0 : ref13.find(function(el) {
                                                                    return el.product.variants[0].code === code1;
                                                                })) !== 'undefined' && (cart === null || cart === void 0 ? void 0 : (ref14 = cart.item) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.items) === null || ref15 === void 0 ? void 0 : ref15.find(function(el) {
                                                                    return el.product.variants[0].code === code1;
                                                                }).quantity) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (0,clsx_m/* default */.Z)('sizes__select-chip', classes.quantityChip, classes.quantitySelected),
                                                                    children: cart && ((ref16 = cart.item) === null || ref16 === void 0 ? void 0 : ref16.items.length) > 0 && typeof (cart === null || cart === void 0 ? void 0 : (ref17 = cart.item) === null || ref17 === void 0 ? void 0 : ref17.items.find(function(el) {
                                                                        return el.product.variants[0].code === code1;
                                                                    })) !== 'undefined' && (cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : ref18.items.find(function(el) {
                                                                        return el.product.variants[0].code === code1;
                                                                    }).quantity)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: 'size-card__quantity-selector-taxon--visible',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelectorWrapper, {})
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTitle/* default */.Z, {
                                                    isModal: true,
                                                    productLayout: productLayout,
                                                    isMobile: isMobile,
                                                    currentItem: currentItem,
                                                    addFromPack: addFromPack,
                                                    promotions: promotions,
                                                    minPrice: minPrice,
                                                    takeBackPrice: takeBackPrice,
                                                    main: settings,
                                                    isBuyableProduct: isBuyableProduct,
                                                    discountPriceFormat: discountPriceFormat,
                                                    selectedTakeBackOrRental: selectedTakeBackOrRental,
                                                    takeback: takeback,
                                                    displayFlexPrice: displayFlexPrice,
                                                    isDisplayTotalRentPrice: isDisplayTotalRentPrice,
                                                    productSettings: productSettings,
                                                    dayRange: dayRange,
                                                    currentPromotion: currentPromotion,
                                                    selectedQuality: selectedQuality,
                                                    originalPrice: originalPrice,
                                                    takeBackPriceMin: takeBackPriceMin,
                                                    takeBackPriceMinTtc: takeBackPriceMinTtc,
                                                    takeBackAvailability: takeBackAvailability,
                                                    isDisplayedPrice: settings === null || settings === void 0 ? void 0 : (ref19 = settings.data) === null || ref19 === void 0 ? void 0 : ref19.is_product_price_displayed,
                                                    isSecondHand: isSecondHandTaxon,
                                                    displayProductState: !isNewButRepairedTaxon,
                                                    productTaxons: currentItem === null || currentItem === void 0 ? void 0 : currentItem.taxons
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: productClasses.selectors,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBackSize/* default */.Z, {
                                                        t: t,
                                                        products: currentItem,
                                                        handleChangeCurrentItem: null,
                                                        noMoreStockAvailable: noMoreStockAvailable,
                                                        cart: cart,
                                                        addProductToCart: addProductToCart,
                                                        settings: settings,
                                                        takeback: takeback,
                                                        currentItem: currentItem,
                                                        selectedQuality: selectedQuality,
                                                        handleStateSelected: handleStateSelected,
                                                        handleSizeSelected: handleSizeSelected,
                                                        showQualities: showQualities,
                                                        sku: currentSku,
                                                        currentSizeQualities: currentSizeQualities,
                                                        currentVariantCode: currentVariantCode,
                                                        productSettings: productSettings === null || productSettings === void 0 ? void 0 : productSettings.data,
                                                        currentQualityInCart: takeBack/* currentQualityInCart */.bz,
                                                        setSelectedQuality: setSelectedQuality,
                                                        availableSkus: remainSecondHandSkusAfterCheckCart,
                                                        addedToCart: addedToCart,
                                                        displayWarrantyText: !isNewButRepairedTaxon,
                                                        secondHandAvailability: secondHandAvailability
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: 'size-card__quantity-selector--visible',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelectorWrapper, {})
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: 'size-card__quantity-selector',
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelectorWrapper, {})
                })
            ]
        })
    }));
};
function getServerSideProps(_) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = SizeCard_asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var locale, previewData, client, lang, singleProductRes;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, previewData = param.previewData;
                    client = createClient({
                        previewData: previewData
                    });
                    lang = setFullLocale(locale);
                    _ctx.next = 5;
                    return getSingleDocument(client, lang, 'single_product');
                case 5:
                    singleProductRes = _ctx.sent;
                    return _ctx.abrupt("return", {
                        props: {
                            singleProductRes: singleProductRes
                        }
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getServerSideProps.apply(this, arguments);
}
/* harmony default export */ var Sizes_SizeCard = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(SizeCard));

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
;// CONCATENATED MODULE: ./components/Sizes/SizeModal.tsx

/* eslint-disable @typescript-eslint/no-unused-expressions */ 







function SizeModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SizeModal_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SizeModal_arrayLikeToArray(arr);
}
function SizeModal_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SizeModal_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SizeModal_toConsumableArray(arr) {
    return SizeModal_arrayWithoutHoles(arr) || SizeModal_iterableToArray(arr) || SizeModal_unsupportedIterableToArray(arr) || SizeModal_nonIterableSpread();
}
function SizeModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SizeModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SizeModal_arrayLikeToArray(o, minLen);
}
var SizeModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            '& .MuiDialog-paper': {
                borderRadius: 0
            }
        },
        closeButton: {
            display: 'inline-flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: theme.extraColors.greyLight
        },
        cross: {
            cursor: 'pointer',
            height: 32,
            width: 32,
            padding: theme.spacing(0.5),
            color: theme.palette.common.white,
            backgroundColor: theme.extraColors.grey,
            borderRadius: '50%',
            margin: theme.spacing(1)
        },
        titleInHeader: {
            padding: theme.spacing(1),
            margin: theme.spacing(1)
        },
        dialogFooter: {
            height: 60,
            backgroundColor: theme.extraColors.greyLight,
            display: 'inline-flex',
            justifyContent: 'space-between',
            position: 'sticky',
            bottom: 0,
            zIndex: 3
        },
        footerButtons: {
            display: 'flex',
            alignItems: 'center',
            margin: theme.spacing(1),
            justifyContent: 'center'
        },
        buttonfoot: {
            padding: theme.spacing(1, 2)
        },
        buttonfootBack: {
            padding: 0,
            color: theme.palette.common.black,
            textDecoration: 'underline',
            textTransform: 'none',
            background: 'none',
            '&:hover, &:focus': {
                textDecoration: 'none',
                background: 'none'
            }
        }
    });
});
var SizeModal = function(param) {
    var open = param.open, handleClose = param.handleClose, products = param.products, text = param.text, stock = param.stock, onQuantityChange = param.onQuantityChange, AddMultipleProductsToCart = param.AddMultipleProductsToCart, type = param.type, cart = param.cart, thumbRatio = param.thumbRatio, thumbWidth = param.thumbWidth, isMobile = param.isMobile, settings = param.settings, currentUrl = param.currentUrl, selection1 = param.selection, setSelection = param.setSelection, isSecondHandTaxon = param.isSecondHandTaxon, secondHandAvailability = param.secondHandAvailability, takeback = param.takeback, productSettings = param.productSettings;
    var ref;
    var classes = SizeModal_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var fullScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('xs'));
    var isMaje =  false || "vaude" === 'maje';
    var handlePackSelection = function(isSimple, productCode, variantCode, quantity) {
        var id = null;
        (selection1 === null || selection1 === void 0 ? void 0 : selection1.length) > 0 && (selection1 === null || selection1 === void 0 ? void 0 : selection1.map(function(select, index) {
            if (select.productCode === productCode) {
                id = index;
            }
        }));
        var productToAdd = {};
        if (isSimple) {
            productToAdd = {
                quantity: quantity,
                productCode: productCode
            };
        } else {
            productToAdd = {
                quantity: quantity,
                variantCode: variantCode,
                productCode: productCode
            };
        }
        if (id !== null) {
            var newArr = SizeModal_toConsumableArray(selection1);
            if (quantity > 0) {
                // if quantity selected by customer is > 0 we add the product in our array
                newArr[id] = productToAdd;
            } else {
                // else we remove the row in our array
                newArr.splice(newArr.findIndex(function(item) {
                    return item.productCode === productCode;
                }), 1);
            }
            // we update the selection with the new array
            setSelection(newArr);
        } else {
            setSelection && setSelection(function(selection) {
                return SizeModal_toConsumableArray(selection).concat([
                    productToAdd
                ]);
            });
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            className: type === 'pack' ? "size-modal size-modal--pack ".concat(classes.root) : "size-modal size-modal--product ".concat(classes.root),
            fullScreen: isMaje ? false : fullScreen,
            open: open,
            onClose: handleClose,
            maxWidth: type === 'pack' ? 'lg' : 'md',
            scroll: 'paper',
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "size-modal__head ".concat(classes.closeButton),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h5",
                            component: "h2",
                            className: "size-modal__title ".concat(classes.titleInHeader),
                            children: type !== 'pack' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : (ref = text.data) === null || ref === void 0 ? void 0 : ref.title_size_modale,
                                defaultText: t('texts:shop:title_size_modale')
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: text === null || text === void 0 ? void 0 : text.title_size_modale_pack,
                                defaultText: t('texts:packs:title_size_modale')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            "data-testid": 'closeModaleButton',
                            className: "size-modal__close ".concat(classes.cross),
                            onClick: handleClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                    dividers: true,
                    className: type === 'pack' ? "size-modal__content" : "size-modal__content size-modal__content-no-padding",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        children: Array.isArray(products) ? products === null || products === void 0 ? void 0 : products.map(function(product, index) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                md: products.length === 1 ? 12 : 6,
                                sm: 12,
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes_SizeCard, {
                                    product: product.product,
                                    productsQty: product === null || product === void 0 ? void 0 : product.packProductQuantity,
                                    text: text,
                                    stock: stock,
                                    onQuantityChange: onQuantityChange,
                                    handlePackSelection: handlePackSelection,
                                    cart: cart,
                                    type: type,
                                    thumbRatio: thumbRatio,
                                    thumbWidth: thumbWidth,
                                    settings: settings,
                                    currentUrl: currentUrl,
                                    productSettings: productSettings,
                                    takeback: takeback,
                                    isSecondHandTaxon: isSecondHandTaxon,
                                    secondHandAvailability: secondHandAvailability,
                                    addedToCart: handleClose
                                })
                            }, index));
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes_SizeCard, {
                                product: products,
                                text: text,
                                stock: stock,
                                onQuantityChange: onQuantityChange,
                                handlePackSelection: handlePackSelection,
                                cart: cart,
                                type: type,
                                thumbRatio: thumbRatio,
                                thumbWidth: thumbWidth,
                                settings: settings,
                                currentUrl: currentUrl,
                                isSecondHandTaxon: isSecondHandTaxon,
                                secondHandAvailability: secondHandAvailability,
                                productSettings: productSettings,
                                takeback: takeback,
                                addedToCart: handleClose
                            })
                        })
                    })
                }),
                type === 'pack' && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "size-modal__foot ".concat(classes.dialogFooter),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "size-modal__btns ".concat(classes.footerButtons),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: handleClose,
                                color: "primary",
                                variant: 'text',
                                size: isMobile ? 'small' : 'medium',
                                className: "".concat(classes.buttonfootBack, " ").concat(classes.buttonfoot),
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: text === null || text === void 0 ? void 0 : text.pack_size_modal_cta_return,
                                    defaultText: t('texts:shop:pack_size_modal_cta_return')
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "size-modal__btns pack-add-to-cart ".concat(classes.footerButtons),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: function() {
                                    return AddMultipleProductsToCart(selection1);
                                },
                                color: "secondary",
                                variant: 'contained',
                                size: isMobile ? 'small' : 'medium',
                                className: classes.buttonfoot,
                                "data-testid": 'pack-add-to-cart',
                                disabled: (selection1 === null || selection1 === void 0 ? void 0 : selection1.length) === 0 || cart.loading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: text === null || text === void 0 ? void 0 : text.pack_size_modal_cta_add,
                                    defaultText: t('texts:shop:pack_size_modal_cta_add')
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Sizes_SizeModal = (SizeModal);


/***/ }),

/***/ 95189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Sizes_TakeBackSize; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./components/Products/AboveProductDescriptionText.tsx
var AboveProductDescriptionText = __webpack_require__(75060);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/InfoOutlined.js
var InfoOutlined = __webpack_require__(45432);
// EXTERNAL MODULE: ./components/Global/GlobalModal.tsx
var GlobalModal = __webpack_require__(29902);
// EXTERNAL MODULE: ./components/BackInStockAlert/SecondHandBackInStockAlertButton.tsx + 1 modules
var SecondHandBackInStockAlertButton = __webpack_require__(74947);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/SwipeableDrawer/SwipeableDrawer.js + 5 modules
var SwipeableDrawer = __webpack_require__(52806);
// EXTERNAL MODULE: ./components/Filters/FilterDrawer.styles.ts
var FilterDrawer_styles = __webpack_require__(64060);
// EXTERNAL MODULE: ./components/BraSizeGuide/BraSizeGuide.tsx
var BraSizeGuide = __webpack_require__(46802);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
;// CONCATENATED MODULE: ./components/BraSizeGuide/BraSizeGuideDrawer.tsx








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        guideLink: _defineProperty({
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: 14,
            marginLeft: theme.spacing(0.5),
            '&:hover': {
                opacity: 0.7
            }
        }, theme.breakpoints.down('md'), {
            fontSize: 11
        })
    });
});
var drawerBleeding = 56;
var BraSizeGuideDrawer = function() {
    var t = (0,useTranslation/* useTranslation */.$)('texts').t;
    var classes = useStyles();
    var drawerClasses = (0,FilterDrawer_styles/* useFilterDrawerStyles */.q)();
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,react.useState)(false), isDrawerOpen = ref[0], setIsDrawerOpen = ref[1];
    var handleOpen = function() {
        setIsDrawerOpen(true);
    };
    var handleClose = function() {
        setIsDrawerOpen(false);
    };
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var anchor = (0,react.useMemo)(function() {
        return isMobile ? 'bottom' : 'right';
    }, [
        isMobile
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "span",
                className: classes.guideLink,
                onClick: handleOpen,
                children: t('size_guide_page.span_title')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeableDrawer/* default */.Z, {
                id: "cart-menu",
                className: (0,clsx_m/* default */.Z)(drawerClasses.drawer),
                onOpen: handleOpen,
                open: isDrawerOpen,
                onClose: handleClose,
                anchor: anchor,
                swipeAreaWidth: drawerBleeding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BraSizeGuide/* default */.Z, {})
            })
        ]
    }));
};
/* harmony default export */ var BraSizeGuide_BraSizeGuideDrawer = (BraSizeGuideDrawer);

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/productVariantDisplay.ts
var productVariantDisplay = __webpack_require__(16758);
// EXTERNAL MODULE: ./components/Shop/QuantitySelector.tsx
var QuantitySelector = __webpack_require__(83230);
;// CONCATENATED MODULE: ./components/Sizes/TakeBackSize.tsx
















function TakeBackSize_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var TakeBackSize_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
        },
        sizes: {
            display: 'flex',
            justifyContent: 'flex-start',
            marginTop: theme.spacing(1)
        },
        sizes__label: {
            paddingRight: theme.spacing(1),
            display: 'flex',
            alignItems: 'center'
        },
        state__label: {
            paddingRight: theme.spacing(1),
            display: 'flex',
            alignItems: 'center'
        },
        sizes__list: {
            padding: theme.spacing(0.25, 0.25, 0.25, 0),
            borderRadius: theme.spacing(1),
            marginBottom: theme.spacing(1),
            flexWrap: 'wrap',
            justifyContent: 'flex-start'
        },
        addButton: TakeBackSize_defineProperty({
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: theme.spacing(3)
        }, theme.breakpoints.down('sm'), {
            justifyContent: 'space-between',
            marginTop: theme.spacing(1)
        }),
        button: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
            width: '100%'
        },
        sizeButton: TakeBackSize_defineProperty({
            height: theme.spacing(4),
            padding: theme.spacing(1, 2),
            margin: theme.spacing(0.5, 0.5, 0.5, 0),
            minWidth: 45,
            backgroundColor: theme.extraColors.greyLight,
            '&:hover': {
                backgroundColor: theme.palette.common.black,
                color: theme.palette.common.white
            },
            '&.sold-out': {
                opacity: 0.5,
                color: theme.palette.error.main
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        selected: TakeBackSize_defineProperty({
            height: theme.spacing(4),
            padding: theme.spacing(1, 2),
            margin: theme.spacing(0.5, 0.5, 0.5, 0),
            minWidth: 45,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
            '&:hover': {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.common.black
            }
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.25)
        }),
        info__icon: {
            marginLeft: theme.spacing(0.5),
            width: 16,
            '&:hover': {
                opacity: 0.5,
                cursor: 'pointer'
            }
        },
        statesModal: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2)
        },
        warrantyText: {
            margin: theme.spacing(1)
        },
        quantitySelectorContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .sizes-add__btn': {
                flexBasis: '50%'
            }
        }
    });
});
var TakeBackSize = function(param) {
    var products = param.products, settings = param.settings, t = param.t, takeBackProps = param.takeBackProps, takeback = param.takeback, noMoreStockAvailable = param.noMoreStockAvailable, currentItem = param.currentItem, cart = param.cart, selectedQuality = param.selectedQuality, handleStateSelected = param.handleStateSelected, handleSizeSelected = param.handleSizeSelected, currentSizeQualities = param.currentSizeQualities, showQualities = param.showQualities, sku = param.sku, currentVariantCode = param.currentVariantCode, productSettings = param.productSettings, currentQualityInCart = param.currentQualityInCart, setSelectedQuality = param.setSelectedQuality, availableSkus = param.availableSkus, addedToCart = param.addedToCart, _displayWarrantyText = param.displayWarrantyText, displayWarrantyText = _displayWarrantyText === void 0 ? true : _displayWarrantyText, _displayBraGuidePanel = param.displayBraGuidePanel, displayBraGuidePanel = _displayBraGuidePanel === void 0 ? false : _displayBraGuidePanel, sizesNamePositionMap = param.sizesNamePositionMap, secondHandAvailability = param.secondHandAvailability, aboveAddToCartNode = param.aboveAddToCartNode;
    var ref28, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var addProductToCart = (0,useCart/* useCart */.j)().addProductToCart;
    var classes = TakeBackSize_useStyles();
    var showAllSize = false;
    var showAllQualities = false;
    var isStatesInformationsModal = takeback === null || takeback === void 0 ? void 0 : (ref28 = takeback.data) === null || ref28 === void 0 ? void 0 : ref28.states_informations_modal;
    var ref25 = (0,react.useState)(false), openStatesModal = ref25[0], setOpenStatesModal = ref25[1];
    var ref26 = (0,react.useState)(1), quantity = ref26[0], setQuantity = ref26[1];
    var ref27 = (0,react.useMemo)(function() {
        var productVariants = Object.values(products === null || products === void 0 ? void 0 : products.variants);
        var _variants = [];
        if (showAllSize) {
            // if you want display all sizes
            _variants = productVariants;
        } else {
            // if you want display available sizes only
            _variants = productVariants.filter(function(variant) {
                var ref;
                return takeBackProps === null || takeBackProps === void 0 ? void 0 : (ref = takeBackProps.takeBackStock) === null || ref === void 0 ? void 0 : ref.some(function(stock) {
                    return stock.lizeeSKU === variant.sku && stock.productsByQuality.length > 0;
                });
            });
        }
        // Apply sorting based on sizesNamePositionMap
        _variants.sort(function(a, b) {
            var ref;
            var aPosition = (ref = sizesNamePositionMap === null || sizesNamePositionMap === void 0 ? void 0 : sizesNamePositionMap[a.size]) !== null && ref !== void 0 ? ref : a.position;
            var ref29;
            var bPosition = (ref29 = sizesNamePositionMap === null || sizesNamePositionMap === void 0 ? void 0 : sizesNamePositionMap[b.size]) !== null && ref29 !== void 0 ? ref29 : b.position;
            return aPosition - bPosition;
        });
        var _isAllVariantsInStock = productVariants.length === _variants.length;
        var allVariantsInStock = productVariants.filter(function(variant) {
            var ref;
            return takeBackProps === null || takeBackProps === void 0 ? void 0 : (ref = takeBackProps.takeBackStock) === null || ref === void 0 ? void 0 : ref.some(function(stock) {
                return stock.lizeeSKU === variant.sku && stock.productsByQuality.length > 0;
            });
        });
        var _allVariantsNotInStock = productVariants.filter(function(variant) {
            return !allVariantsInStock.map(function(allVariantInStock) {
                return allVariantInStock.sku;
            }).includes(variant.sku);
        });
        return [
            _variants,
            _isAllVariantsInStock,
            _allVariantsNotInStock
        ];
    }, [
        products === null || products === void 0 ? void 0 : products.variants,
        showAllSize,
        takeBackProps === null || takeBackProps === void 0 ? void 0 : takeBackProps.takeBackStock,
        sizesNamePositionMap, 
    ]), variants = ref27[0], isAllVariantsInStock = ref27[1], allVariantsNotInStock = ref27[2];
    var handleCloseModal = function() {
        setOpenStatesModal(false);
    };
    // Calculate max available quantity for selected quality
    var maxAvailableQuantity = (0,react.useMemo)(function() {
        var ref;
        if (!selectedQuality) return 0;
        var qualityData = currentSizeQualities.find(function(quality) {
            return quality.quality === selectedQuality;
        });
        var totalAvailable = (qualityData === null || qualityData === void 0 ? void 0 : (ref = qualityData.products) === null || ref === void 0 ? void 0 : ref.length) || 0;
        var alreadyInCart = currentQualityInCart(selectedQuality, sku, cart);
        return Math.max(0, totalAvailable - alreadyInCart);
    }, [
        selectedQuality,
        currentSizeQualities,
        sku,
        cart
    ]);
    var handleQuantityChange = function(newQuantity) {
        if (newQuantity < 1) return;
        // Limit quantity to available stock
        var limitedQuantity = Math.min(newQuantity, maxAvailableQuantity);
        if (limitedQuantity >= 1) {
            setQuantity(limitedQuantity);
        }
    };
    var handleAddTakeBackProductToCart = function() {
        if (quantity <= 0) {
            return;
        }
        var quantityIteration = quantity;
        var data = {
            productCode: currentItem.code,
            secondHand: 'true',
            units: []
        };
        var puidsInCartForSkuQuality = function() {
            var ref35, ref30;
            var ids = new Set();
            cart === null || cart === void 0 ? void 0 : (ref35 = cart.item) === null || ref35 === void 0 ? void 0 : (ref30 = ref35.items) === null || ref30 === void 0 ? void 0 : ref30.forEach(function(line) {
                var ref, ref32, ref33, ref34;
                if (((ref = line.product) === null || ref === void 0 ? void 0 : (ref32 = ref.variants) === null || ref32 === void 0 ? void 0 : (ref33 = ref32[0]) === null || ref33 === void 0 ? void 0 : ref33.sku) !== sku) return;
                (ref34 = line.units) === null || ref34 === void 0 ? void 0 : ref34.forEach(function(u) {
                    if (u.productCondition === selectedQuality) ids.add(u.puid);
                });
            });
            return ids;
        };
        while(quantityIteration > 0){
            var ref31;
            var qualityData = currentSizeQualities.find(function(currentQuality) {
                return currentQuality.quality === selectedQuality;
            });
            if (!(qualityData === null || qualityData === void 0 ? void 0 : (ref31 = qualityData.products) === null || ref31 === void 0 ? void 0 : ref31.length)) break;
            var reserved = puidsInCartForSkuQuality();
            data.units.forEach(function(u) {
                return reserved.add(u.puid);
            });
            var nextProduct = qualityData.products.find(function(p) {
                return !reserved.has(p.puid);
            });
            if (!nextProduct) break;
            var puid = nextProduct.puid;
            data.units.push({
                puid: puid,
                condition: selectedQuality
            });
            quantityIteration--;
        }
        if (!(currentItem === null || currentItem === void 0 ? void 0 : currentItem.isSimpleProduct)) {
            data.variantCode = currentVariantCode.toString();
        }
        addProductToCart(data);
        setQuantity(1);
        // FIX: we commented this line to prevent resetting quality selection after adding to cart
        // setSelectedQuality('')
        if (addedToCart) addedToCart();
    };
    var stockAlertSecondHand = (takeback === null || takeback === void 0 ? void 0 : (ref1 = takeback.data) === null || ref1 === void 0 ? void 0 : ref1.take_back_stock_alert_enable) && !isAllVariantsInStock;
    var showSizeAxisLabel = !constants/* hideSecondHandSizes */.Qv && (0,productVariantDisplay/* productVariantsHaveAnyDisplayableSize */.BS)(variants);
    var showSizeButtons = !constants/* hideSecondHandSizes */.Qv && (0,productVariantDisplay/* shouldShowVariantSizeButtons */.lP)(variants);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            !noMoreStockAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showSizeAxisLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sizes ".concat(classes.sizes),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            component: 'div',
                            className: "size__label ".concat(classes.sizes__label),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: settings === null || settings === void 0 ? void 0 : settings.sizes,
                                        defaultText: t('texts:general:sizes')
                                    })
                                }),
                                displayBraGuidePanel && /*#__PURE__*/ (0,jsx_runtime.jsx)(BraSizeGuide_BraSizeGuideDrawer, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sizes__list ".concat(classes.sizes__list),
                        children: [
                            showSizeButtons && variants && (variants === null || variants === void 0 ? void 0 : variants.map(function(variant, index) {
                                var ref, ref36;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: "small",
                                    className: variant.sku === sku ? "sizes__btn selected ".concat(classes.selected) : "sizes__btn ".concat(classes.sizeButton),
                                    onClick: function() {
                                        return handleSizeSelected(variant.sku);
                                    },
                                    "data-testid": "btn-size-".concat(index),
                                    disabled: showAllSize && ((ref36 = takeBackProps === null || takeBackProps === void 0 ? void 0 : (ref = takeBackProps.takeBackStock) === null || ref === void 0 ? void 0 : ref.find(function(varSku) {
                                        return varSku.lizeeSKU === variant.sku;
                                    })) === null || ref36 === void 0 ? void 0 : ref36.productsByQuality.length) === 0 || !availableSkus.includes(variant.sku),
                                    children: (0,productVariantDisplay/* getVariantChoiceLabel */.nA)(variant)
                                }, index));
                            })),
                            stockAlertSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondHandBackInStockAlertButton/* default */.Z, {
                                prismicTakeback: takeback === null || takeback === void 0 ? void 0 : takeback.data,
                                allVariantsNotInStock: allVariantsNotInStock
                            }),
                            showQualities && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        component: 'div',
                                        className: "state__label ".concat(classes.state__label),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: takeback === null || takeback === void 0 ? void 0 : (ref2 = takeback.data) === null || ref2 === void 0 ? void 0 : ref2.state_label,
                                                    defaultText: t('texts:takeBack:select_label_state')
                                                })
                                            }),
                                            isStatesInformationsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                fontSize: "small",
                                                onClick: function() {
                                                    return setOpenStatesModal(true);
                                                },
                                                className: classes.info__icon
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModal/* default */.Z, {
                                        open: openStatesModal,
                                        onClose: handleCloseModal,
                                        modalTitle: {
                                            data: takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.states_information_modal_title,
                                            defaultText: t('texts:takeBack:take_back_states_information_modal_title')
                                        },
                                        customClass: 'take_back_states_informations',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.statesModal,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'h4',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: takeback === null || takeback === void 0 ? void 0 : (ref4 = takeback.data) === null || ref4 === void 0 ? void 0 : ref4.perfectcondition,
                                                                defaultText: takeback === null || takeback === void 0 ? void 0 : (ref5 = takeback.data) === null || ref5 === void 0 ? void 0 : ref5.state_1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: takeback === null || takeback === void 0 ? void 0 : (ref6 = takeback.data) === null || ref6 === void 0 ? void 0 : ref6.perfectconditiondefinition,
                                                                defaultText: takeback === null || takeback === void 0 ? void 0 : (ref7 = takeback.data) === null || ref7 === void 0 ? void 0 : ref7.state_1
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'h4',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: takeback === null || takeback === void 0 ? void 0 : (ref8 = takeback.data) === null || ref8 === void 0 ? void 0 : ref8.verygoodcondition,
                                                                defaultText: takeback === null || takeback === void 0 ? void 0 : (ref9 = takeback.data) === null || ref9 === void 0 ? void 0 : ref9.state_1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: takeback === null || takeback === void 0 ? void 0 : (ref10 = takeback.data) === null || ref10 === void 0 ? void 0 : ref10.verygoodconditiondefinition,
                                                                defaultText: takeback === null || takeback === void 0 ? void 0 : (ref11 = takeback.data) === null || ref11 === void 0 ? void 0 : ref11.state_1
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !(takeback === null || takeback === void 0 ? void 0 : (ref12 = takeback.data) === null || ref12 === void 0 ? void 0 : ref12.disable_good_condition) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'h4',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: takeback === null || takeback === void 0 ? void 0 : (ref13 = takeback.data) === null || ref13 === void 0 ? void 0 : ref13.goodcondition,
                                                                defaultText: takeback === null || takeback === void 0 ? void 0 : (ref14 = takeback.data) === null || ref14 === void 0 ? void 0 : ref14.state_1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: takeback === null || takeback === void 0 ? void 0 : (ref15 = takeback.data) === null || ref15 === void 0 ? void 0 : ref15.goodconditiondefinition,
                                                                defaultText: takeback === null || takeback === void 0 ? void 0 : (ref16 = takeback.data) === null || ref16 === void 0 ? void 0 : ref16.state_1
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    currentSizeQualities.map(function(quality, index) {
                                        var Btn = function() {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                size: "small",
                                                className: quality.quality === selectedQuality ? "sizes__btn selected ".concat(classes.selected) : "sizes__btn ".concat(classes.sizeButton),
                                                disabled: quality.disabled,
                                                onClick: function() {
                                                    return handleStateSelected(quality);
                                                },
                                                children: quality.title
                                            });
                                        };
                                        if (showAllQualities) {
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Btn, {}, index));
                                        }
                                        if (!quality.disabled) {
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Btn, {}, index));
                                        }
                                        return null;
                                    })
                                ]
                            })
                        ]
                    }),
                    aboveAddToCartNode,
                    (settings === null || settings === void 0 ? void 0 : settings.second_hand_has_quantity_selector) && secondHandAvailability ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.quantitySelectorContainer, 'second-hand-quantity-selector-container'),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                value: quantity,
                                handleChange: handleQuantityChange,
                                min: 1,
                                max: maxAvailableQuantity,
                                variantSku: sku,
                                disable: selectedQuality === '' || ((ref17 = currentSizeQualities.find(function(quality) {
                                    return quality.quality === selectedQuality;
                                })) === null || ref17 === void 0 ? void 0 : ref17.disabled) || maxAvailableQuantity === 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "secondary",
                                "data-testid": 'btn-addToCart',
                                id: "btn-addToCart",
                                disabled: selectedQuality === '' || ((ref18 = currentSizeQualities.find(function(quality) {
                                    return quality.quality === selectedQuality;
                                })) === null || ref18 === void 0 ? void 0 : ref18.disabled),
                                className: "sizes-add__btn",
                                onClick: handleAddTakeBackProductToCart,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: productSettings === null || productSettings === void 0 ? void 0 : (ref19 = productSettings.data) === null || ref19 === void 0 ? void 0 : ref19.buy_button,
                                    defaultText: t('texts:single_product:buy_button')
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "secondary",
                        "data-testid": 'btn-addToCart',
                        id: "btn-addToCart",
                        disabled: selectedQuality === '' || ((ref20 = currentSizeQualities.find(function(quality) {
                            return quality.quality === selectedQuality;
                        })) === null || ref20 === void 0 ? void 0 : ref20.disabled),
                        className: "sizes-add__btn",
                        onClick: handleAddTakeBackProductToCart,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: productSettings === null || productSettings === void 0 ? void 0 : (ref21 = productSettings.data) === null || ref21 === void 0 ? void 0 : ref21.buy_button,
                            defaultText: t('texts:single_product:buy_button')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboveProductDescriptionText/* default */.Z, {
                        productSettings: productSettings,
                        className: classes.warrantyText
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        className: 'product__unavailable',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: productSettings === null || productSettings === void 0 ? void 0 : (ref22 = productSettings.data) === null || ref22 === void 0 ? void 0 : ref22.sold_out,
                            defaultText: t('texts:packs:victim_of_success')
                        })
                    }),
                    stockAlertSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondHandBackInStockAlertButton/* default */.Z, {
                        prismicTakeback: takeback === null || takeback === void 0 ? void 0 : takeback.data,
                        allVariantsNotInStock: allVariantsNotInStock
                    })
                ]
            }),
            (0,CMSText/* isPrismicText */.LT)(takeback === null || takeback === void 0 ? void 0 : (ref23 = takeback.data) === null || ref23 === void 0 ? void 0 : ref23.warranty_text) && displayWarrantyText && !(0,AboveProductDescriptionText/* hasAboveProductDescriptionText */.J)(productSettings) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: 'div',
                variant: 'caption',
                className: (0,clsx_m/* default */.Z)(classes.warrantyText, 'warranty_text'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    data: takeback === null || takeback === void 0 ? void 0 : (ref24 = takeback.data) === null || ref24 === void 0 ? void 0 : ref24.warranty_text
                })
            })
        ]
    }));
};
var mapStateToProps = function(state) {
    return {
        takeBackProps: state.takeBack,
        sizesNamePositionMap: state.taxons.sizesNamePositionMap
    };
};
var mapDispatchToProps = {};
/* harmony default export */ var Sizes_TakeBackSize = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(TakeBackSize));


/***/ }),

/***/ 89910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jC": function() { return /* binding */ billingAddressForThermorCheckoutPut; },
/* harmony export */   "wR": function() { return /* binding */ getCartSecondHandItems; },
/* harmony export */   "Vk": function() { return /* binding */ getCurrentSkuProductInCart; },
/* harmony export */   "_y": function() { return /* binding */ getCurrentProductTypeInCart; },
/* harmony export */   "Lj": function() { return /* binding */ getSecondHandProductInformation; },
/* harmony export */   "Ci": function() { return /* binding */ isOnlySecondHandInCart; }
/* harmony export */ });
/* unused harmony exports getCartSecondHandItem, getProductTypeInCart, getProductsTypeInCart */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66026);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var cartHasPersistedBilling = function(b) {
    var ref, ref1;
    return !!(b && (((ref = b.street) === null || ref === void 0 ? void 0 : ref.trim()) || ((ref1 = b.postcode) === null || ref1 === void 0 ? void 0 : ref1.trim())));
};
/**
 * Si Thermor SSO et que le panier a déjà une facturation, renvoie celle du panier ;
 * sinon la valeur proposée (ex. formulaire ou profil).
 */ var billingAddressForThermorCheckoutPut = function(proposed, cartItem) {
    if (!_constants__WEBPACK_IMPORTED_MODULE_0__/* .isThermorSSO */ .y || !cartItem) return proposed;
    var existing = cartItem.billingAddress;
    if (cartHasPersistedBilling(existing)) return _objectSpread({}, existing);
    return proposed;
};
// format second hand informations from cart
var getCartSecondHandItem = function(item) {
    var units = item.units.map(function(unit) {
        return {
            productState: unit.productCondition,
            productPuid: unit.puid
        };
    });
    return {
        sku: item.product.variants[0].sku,
        units: units
    };
};
// get all informations about 2nde hand products in cart according cartSecondHandItems typing
var getCartSecondHandItems = function(cart) {
    var ref, ref2;
    return (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref2 = ref.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
        return getCartSecondHandItem(item);
    })) || [];
};
// get second hand informations products in cart for according current sku
var getCurrentSkuProductInCart = function(secondHandProductsInCart, currentSku) {
    return secondHandProductsInCart === null || secondHandProductsInCart === void 0 ? void 0 : secondHandProductsInCart.filter(function(secondHandProduct) {
        return secondHandProduct.sku === currentSku;
    });
};
// get type of products in cart (second hand or rental)
var getProductTypeInCart = function(item) {
    var ref;
    return {
        code: item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref.code,
        type: item === null || item === void 0 ? void 0 : item.type
    };
};
var getProductsTypeInCart = function(cart) {
    var ref, ref3;
    return cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref3 = ref.items) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
        return getProductTypeInCart(item);
    });
};
// get type of current product in cart (case of rent and 2nde hand)
var getCurrentProductTypeInCart = function(currentItem, cart) {
    var productsInCartWithType = getProductsTypeInCart(cart);
    var currentItemCode = currentItem.code;
    var currentProductInCart = productsInCartWithType === null || productsInCartWithType === void 0 ? void 0 : productsInCartWithType.find(function(product) {
        return product.code === currentItemCode;
    });
    if (!currentProductInCart) return null;
    return currentProductInCart.type;
};
// second hand informations to display them on confirmation's page
var getSecondHandProductInformation = function(secondHandProduct) {
    var ref, ref4, ref5, ref6;
    var units = secondHandProduct.units.map(function(unit) {
        return {
            productState: unit.productCondition,
            productPuid: unit.puid,
            productPrice: unit.price
        };
    });
    return {
        productName: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : (ref = secondHandProduct.product) === null || ref === void 0 ? void 0 : ref.name,
        productImage: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : (ref4 = secondHandProduct.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.images) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.cachedPath,
        units: units,
        taxonPromotionPercent: secondHandProduct === null || secondHandProduct === void 0 ? void 0 : secondHandProduct.taxonPromotionPercent
    };
};
// there is only second hand in cart
var isOnlySecondHandInCart = function(cart) {
    var ref;
    return !((ref = getProductsTypeInCart(cart)) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return item.type === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_ITEM_TYPE.RENTAL */ ._$.RENTAL;
    }));
};


/***/ }),

/***/ 4676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ evaluateCondition; }
/* harmony export */ });
/* unused harmony export getConditionString */
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FORBIDDEN_PATTERN = /\b(this|window|document|globalThis|Function|eval|constructor|prototype|__proto__|new)\b|=>|;|`/i;
var ALLOWED_CHARS_PATTERN = /^[\w\s.$()[\]!<>=&|+\-*/%:'",?]+$/;
var IDENTIFIER_PATTERN = /\b[a-zA-Z_][\w.]*/g;
var RESERVED_WORDS = new Set([
    'true',
    'false',
    'null',
    'undefined',
    'NaN',
    'Infinity', 
]);
var isValidExpression = function(expression) {
    if (!expression || expression.length > 300) return false;
    if (FORBIDDEN_PATTERN.test(expression)) return false;
    return ALLOWED_CHARS_PATTERN.test(expression);
};
var hasOnlyAllowedIdentifiers = function(expression, context) {
    var rootKeys = new Set(Object.keys(context));
    var tokens = expression.match(IDENTIFIER_PATTERN) || [];
    return tokens.every(function(token) {
        if (RESERVED_WORDS.has(token)) return true;
        var root = token.split('.')[0];
        return rootKeys.has(root);
    });
};
var getConditionString = function(condition) {
    if (!condition) return '';
    if (typeof condition === 'string') return condition.trim();
    if (Array.isArray(condition)) {
        return condition.map(function(block) {
            return 'text' in block ? block.text : '';
        }).join(' ').trim();
    }
    return '';
};
var evaluateCondition = function(condition, context) {
    var expression = getConditionString(condition);
    if (!expression) return false;
    if (!isValidExpression(expression)) return false;
    if (!hasOnlyAllowedIdentifiers(expression, context)) return false;
    try {
        var keys = Object.keys(context);
        var values = keys.map(function(key) {
            return context[key];
        });
        var evaluator = _construct(Function, _toConsumableArray(keys).concat([
            "\"use strict\"; return Boolean(".concat(expression, ");")
        ]));
        return Boolean(evaluator.apply(void 0, _toConsumableArray(values)));
    } catch (error) {
        return false;
    }
};


/***/ }),

/***/ 92412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jk": function() { return /* binding */ isProductConditionFiltered; },
/* harmony export */   "Sk": function() { return /* binding */ getProductConditionsFiltered; },
/* harmony export */   "bE": function() { return /* binding */ getLowestConditionByConditions; },
/* harmony export */   "V5": function() { return /* binding */ getProductSizesFiltered; }
/* harmony export */ });
/* unused harmony exports getFilters, isProductSizesFiltered */
var hasFiltersExist = function(router) {
    var ref, ref1;
    if (router === undefined || router.query === undefined) return false;
    return ((ref = router.query) === null || ref === void 0 ? void 0 : ref.filters) !== undefined && ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.filters) !== '';
};
var getFilters = function(router) {
    var hasFilters = hasFiltersExist(router);
    if (!hasFilters) return [];
    return JSON.parse(router.query.filters);
};
var isProductConditionFiltered = function(router) {
    return getProductConditionsFiltered(router).length > 0;
};
var getProductConditionsFiltered = function(router) {
    var filters = getFilters(router);
    if (filters.length === 0) return [];
    var productConditions = filters.find(function(filter) {
        return (filter === null || filter === void 0 ? void 0 : filter.code) === 'productCondition';
    });
    if (productConditions === undefined) return [];
    return productConditions.values;
};
var getLowestConditionByConditions = function(conditions) {
    if (conditions.includes('goodCondition')) return 'goodCondition';
    if (conditions.includes('veryGoodCondition')) return 'veryGoodCondition';
    if (conditions.includes('perfectCondition')) return 'perfectCondition';
};
var isProductSizesFiltered = function(router) {
    return getProductSizesFiltered(router).length > 0;
};
var getProductSizesFiltered = function(router) {
    if (router === undefined) return [];
    var filters = getFilters(router);
    if (filters.length === 0) return [];
    var productSizes = filters.find(function(filter) {
        return filter.code === 'size';
    });
    if (productSizes === undefined) return [];
    return productSizes.values;
};


/***/ }),

/***/ 16758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nA": function() { return /* binding */ getVariantChoiceLabel; },
/* harmony export */   "BS": function() { return /* binding */ productVariantsHaveAnyDisplayableSize; },
/* harmony export */   "lP": function() { return /* binding */ shouldShowVariantSizeButtons; }
/* harmony export */ });
/* unused harmony export variantHasDisplayableSize */
/** Non-empty `size` after trim (handles `null` / absent). */ function variantHasDisplayableSize(variant) {
    var ref;
    return Boolean((ref = variant.size) === null || ref === void 0 ? void 0 : ref.trim());
}
/** Text on a variant chip: prefer size axis, otherwise name or code. */ function getVariantChoiceLabel(variant) {
    var ref, ref1;
    var size = (ref = variant.size) === null || ref === void 0 ? void 0 : ref.trim();
    if (size) return size;
    var name = (ref1 = variant.name) === null || ref1 === void 0 ? void 0 : ref1.trim();
    if (name) return name;
    return variant.code;
}
function productVariantsHaveAnyDisplayableSize(variants) {
    return (variants !== null && variants !== void 0 ? variants : []).some(variantHasDisplayableSize);
}
/** Hide the lone empty size chip when there is a single variant with no size. */ function shouldShowVariantSizeButtons(variants) {
    var list = variants !== null && variants !== void 0 ? variants : [];
    return list.length > 1 || productVariantsHaveAnyDisplayableSize(list);
}


/***/ }),

/***/ 71323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vO": function() { return /* binding */ createProductsQualityArrayBySize; },
  "bz": function() { return /* binding */ currentQualityInCart; },
  "U9": function() { return /* binding */ getChosenQualityObject; },
  "gd": function() { return /* binding */ getRemainSkusAvailableAfterCheckCart; },
  "sd": function() { return /* binding */ getSecondHandImageForRelatedProduct; },
  "Fk": function() { return /* binding */ handlePreselectedSizeAndCondition; },
  "vM": function() { return /* binding */ handleTakeBackOriginalPrice; },
  "dE": function() { return /* binding */ preSelectedSkuAndCondition; }
});

// UNUSED EXPORTS: getSecondHandPrice, setCurrentItemImagesAndGetDescription

// EXTERNAL MODULE: ./utils/cart.tsx
var utils_cart = __webpack_require__(89910);
// EXTERNAL MODULE: ./utils/takeBackFiltersConditions.tsx
var takeBackFiltersConditions = __webpack_require__(61429);
// EXTERNAL MODULE: ./utils/filters.tsx
var filters = __webpack_require__(92412);
;// CONCATENATED MODULE: ./utils/variants.tsx
var getVariantsSkus = function(variants) {
    return Object.values(variants).map(function(variant) {
        return variant.sku;
    });
};
var filterSkus = function(variants, availableSkus, sizesToFilter) {
    if (sizesToFilter.length === 0) return availableSkus;
    var adaptedSkus = adaptSizesToSkus(sizesToFilter, variants);
    if (adaptedSkus.length === 0) return [];
    return availableSkus.filter(function(availableSku) {
        return adaptedSkus.includes(availableSku);
    });
};
var adaptSizesToSkus = function(sizes, variants) {
    var selectedVariants = Object.values(variants).filter(function(variant) {
        return sizes.includes(variant.size);
    });
    if (selectedVariants.length === 0) return [];
    return selectedVariants.map(function(selectedVariant) {
        return selectedVariant.sku;
    });
};
var getCodeBySku = function(sku, variants) {
    var variantBySku = Object.values(variants).filter(function(variant) {
        return variant.sku === sku;
    });
    if (variantBySku.length > 0) return variantBySku[0].code;
    return null;
};

;// CONCATENATED MODULE: ./utils/takeBackFiltersSize.tsx




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// get the lowest selected sku from filters or get the lowest available sku
var getChosenSku = function(variants, secondHandStockSkus, secondHandStock, cart, setNoMoreStockAvailable, router) {
    //get all existing skus for this product
    var skus = getVariantsSkus(variants);
    // get all skus in stock for this product
    var availableSkusFilteredByStock = getAvailableSkus(skus, secondHandStockSkus);
    //get filtered sizes from url, if there is nothing, result = []
    var filterSizes = (0,filters/* getProductSizesFiltered */.V5)(router);
    //get skus filtered by stock and filter
    var filteredSkus = filterSkus(variants, availableSkusFilteredByStock, filterSizes);
    // get one prelected sku
    var preSelectedSku = getSizeToPreselected(filteredSkus, secondHandStock, cart);
    setNoMoreStockAvailable(false);
    // get second hand products information from cart => cartSecondHandItems type
    var secondHandInCart = (0,utils_cart/* getCartSecondHandItems */.wR)(cart);
    var remainStockAfterCheckCart = getSecondHandStockRemainsCompareCart(secondHandStock, secondHandInCart);
    if (preSelectedSku === null) {
        //set le out of stock
        if (remainStockAfterCheckCart.length === 0) {
            setNoMoreStockAvailable(true);
        } else {
            setNoMoreStockAvailable(false);
            //else set the first size available if there is no more filtered siz available
            return remainStockAfterCheckCart[0].sku;
        }
    }
    return preSelectedSku;
};
var getAvailableSkus = function(allSkus, skusInStock) {
    return allSkus.filter(function(sku) {
        return skusInStock.includes(sku);
    });
};
var getSizeToPreselected = function(filteredSkus, secondHandStock, cart) {
    for(var index = 0; index < filteredSkus.length; index++){
        var chosenCondition = (0,takeBackFiltersConditions/* getChosenCondition */.G8)(filteredSkus[index], secondHandStock, cart);
        if (chosenCondition !== null && chosenCondition.length > 0) return filteredSkus[index];
    }
    return null;
};
// get second hand stock remains after remove second hand put in cart
var getSecondHandStockRemainsCompareCart = function(secondHandStock, secondHandInCart) {
    var _loop = function(index) {
        //get second hand products in cart according sku
        var secondHandInCartBySku = secondHandInCart.filter(function(inCart) {
            return inCart.sku === secondHandStock[index].lizeeSKU;
        });
        var productsInCartBySku = secondHandInCartBySku.length > 0 ? secondHandInCartBySku[0].units : [];
        //get second hand stock according sku
        var secondHandStockBySku = secondHandStock[index].secondHand;
        var restInStockForThisSku = [];
        if (productsInCartBySku !== undefined) {
            secondHandStockBySku === null || secondHandStockBySku === void 0 ? void 0 : secondHandStockBySku.map(function(stock) {
                var exists = productsInCartBySku.filter(function(productInCartBySku) {
                    return productInCartBySku.productState === stock.quality;
                });
                var numberAvailable = stock.quantity - exists.length;
                if (numberAvailable > 0) {
                    restInStockForThisSku.push({
                        quality: stock.quality,
                        quantity: numberAvailable
                    });
                }
            });
            var secondHandInformations = _toConsumableArray(restInStockForThisSku);
            if (secondHandInformations.length > 0) {
                remainStock.push({
                    sku: secondHandStock[index].lizeeSKU,
                    secondHand: secondHandInformations
                });
            }
        }
    };
    var remainStock = [];
    for(var index = 0; index < secondHandStock.length; index++)_loop(index);
    return remainStock;
};

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./utils/takeBack.tsx





function takeBack_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function takeBack_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return takeBack_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function takeBack_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function takeBack_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function takeBack_toConsumableArray(arr) {
    return takeBack_arrayWithoutHoles(arr) || takeBack_iterableToArray(arr) || takeBack_unsupportedIterableToArray(arr) || takeBack_nonIterableSpread();
}
function takeBack_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return takeBack_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return takeBack_arrayLikeToArray(o, minLen);
}
// return the number of product in cart according to sku and quality
var currentQualityInCart = function(quality, sku, cart) {
    var ref;
    var numberInCart = 0;
    cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.items.map(function(products) {
        products.units.map(function(product) {
            if (product.productCondition === quality && products.product.variants[0].sku === sku) {
                numberInCart += 1;
            }
        });
    });
    return numberInCart;
};
// get informations about all available qualities for the preselected size in order to display them
var createProductsQualityArrayBySize = function(takeBackState, sku, states, cart) {
    var ref2;
    var qualitiesArray = [];
    var currentSkuQualities = (ref2 = takeBackState === null || takeBackState === void 0 ? void 0 : takeBackState.find(function(varSku) {
        return varSku.lizeeSKU === sku;
    })) === null || ref2 === void 0 ? void 0 : ref2.productsByQuality;
    var skuStateKeys = Object.keys(states);
    skuStateKeys.forEach(function(skuStateKey) {
        var ref, ref1;
        var currentProducts = (ref = currentSkuQualities === null || currentSkuQualities === void 0 ? void 0 : currentSkuQualities.find(function(quality) {
            return quality.quality === skuStateKey;
        })) === null || ref === void 0 ? void 0 : ref.products;
        // a product exist within the quality
        var numberInCart = currentQualityInCart(skuStateKey, sku, cart);
        qualitiesArray.push({
            title: (ref1 = states[skuStateKey]) === null || ref1 === void 0 ? void 0 : ref1.title,
            quality: skuStateKey,
            products: currentProducts,
            disabled: typeof currentProducts === 'undefined' || numberInCart >= currentProducts.length
        });
    });
    return qualitiesArray;
};
// return the original price for current product
var handleTakeBackOriginalPrice = function(currentItem, currentSku) {
    var ref, ref3;
    var originalPrice = (ref3 = (ref = Object.values(currentItem.variants)) === null || ref === void 0 ? void 0 : ref.find(function(el) {
        return el.sku === currentSku;
    })) === null || ref3 === void 0 ? void 0 : ref3.originalPrice.current;
    return originalPrice;
};
// get all informations related to the chosen sku and chosen quality
var getChosenQualityObject = function(chosenQuality, qualitiesArray, chosenSku, secondHandStock) {
    var ref, ref4;
    var chosenQualityObject = qualitiesArray.find(function(qualityObject) {
        return qualityObject.quality === chosenQuality;
    });
    var chosenQualityStock = (ref = secondHandStock.find(function(stock) {
        return stock.lizeeSKU === chosenSku;
    })) === null || ref === void 0 ? void 0 : (ref4 = ref.secondHand) === null || ref4 === void 0 ? void 0 : ref4.find(function(quality) {
        return quality.quality === chosenQualityObject.quality;
    });
    return _objectSpread({}, chosenQualityObject, chosenQualityStock);
};
//set current item 2nde hand images
var setCurrentItemImagesAndGetDescription = function(chosenQualityObject, chosenSku, cart, currentItem) {
    var ref, ref5, ref6;
    var numberInCart = currentQualityInCart(chosenQualityObject === null || chosenQualityObject === void 0 ? void 0 : chosenQualityObject.quality, chosenSku, cart);
    var secondHandDescription = (chosenQualityObject === null || chosenQualityObject === void 0 ? void 0 : chosenQualityObject.products) !== undefined && ((ref = chosenQualityObject === null || chosenQualityObject === void 0 ? void 0 : chosenQualityObject.products[numberInCart]) === null || ref === void 0 ? void 0 : ref.note);
    var images = [];
    if (chosenQualityObject !== undefined && (chosenQualityObject === null || chosenQualityObject === void 0 ? void 0 : (ref5 = chosenQualityObject.products) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[numberInCart]) === null || ref6 === void 0 ? void 0 : ref6.images)) {
        var _images;
        (_images = images).push.apply(_images, takeBack_toConsumableArray(chosenQualityObject.products[numberInCart].images));
    }
    if (!constants/* show2ndHandWarehouseImagesFirst */.QB) {
        var _images1;
        (_images1 = images).push.apply(_images1, takeBack_toConsumableArray(currentItem.images));
    } else {
        var // insert the warehouse images at the beginning of the array
        _images2;
        (_images2 = images).unshift.apply(_images2, takeBack_toConsumableArray(currentItem.images));
    }
    currentItem.images = images;
    return {
        item: currentItem,
        secondHandDescription: secondHandDescription
    };
};
var getSecondHandPrice = function(item, chosenQualityObject, chosenSku) {
    var ref, ref7;
    var currentPricesByCondition = (ref7 = (ref = Object.values(item.variants)) === null || ref === void 0 ? void 0 : ref.find(function(el) {
        return el.sku === chosenSku;
    })) === null || ref7 === void 0 ? void 0 : ref7.resalePrice;
    var price = currentPricesByCondition !== undefined && currentPricesByCondition[chosenQualityObject === null || chosenQualityObject === void 0 ? void 0 : chosenQualityObject.quality];
    return price;
};
//return preselected sku and condition and all informations according to this 2 parameters (ex: price, current images)
var preSelectedSkuAndCondition = function(secondHandStock, currentItem, takeBackState, states, cart, setNoMoreStockAvailable, router) {
    var ref;
    var secondHandStockSkus = secondHandStock.map(function(secondHandStockItem) {
        return secondHandStockItem.lizeeSKU;
    });
    var chosenSku = getChosenSku(currentItem === null || currentItem === void 0 ? void 0 : currentItem.variants, secondHandStockSkus, secondHandStock, cart, setNoMoreStockAvailable, router);
    var qualitiesArray = createProductsQualityArrayBySize(takeBackState, chosenSku, states, cart);
    var originalPrice = handleTakeBackOriginalPrice(currentItem, chosenSku);
    var noMoreFilterAvailable = (ref = qualitiesArray.find(function(quality) {
        return !quality.disabled;
    })) === null || ref === void 0 ? void 0 : ref.quality;
    var chosenQuality = (0,takeBackFiltersConditions/* getChosenCondition */.G8)(chosenSku, secondHandStock, cart) !== null ? (0,takeBackFiltersConditions/* getChosenCondition */.G8)(chosenSku, secondHandStock, cart) : noMoreFilterAvailable;
    var chosenCode = getCodeBySku(chosenSku, currentItem === null || currentItem === void 0 ? void 0 : currentItem.variants);
    var chosenQualityObject = getChosenQualityObject(chosenQuality, qualitiesArray, chosenSku, secondHandStock);
    var currentItemAndDescription = setCurrentItemImagesAndGetDescription(chosenQualityObject, chosenSku, cart, currentItem);
    var secondHandCurrentPrice = getSecondHandPrice(currentItemAndDescription === null || currentItemAndDescription === void 0 ? void 0 : currentItemAndDescription.item, chosenQualityObject, chosenSku);
    return {
        chosenSku: chosenSku,
        chosenCode: chosenCode,
        chosenQuality: chosenQuality,
        originalPrice: originalPrice,
        qualitiesArray: qualitiesArray,
        chosenQualityObject: chosenQualityObject,
        item: currentItemAndDescription === null || currentItemAndDescription === void 0 ? void 0 : currentItemAndDescription.item,
        secondHandDescription: currentItemAndDescription === null || currentItemAndDescription === void 0 ? void 0 : currentItemAndDescription.secondHandDescription,
        currentPrice: secondHandCurrentPrice
    };
};
// return an array of available skus after remove quantity already in cart
var getRemainSkusAvailableAfterCheckCart = function(cart, secondHandStock) {
    var secondHandInCart = (0,utils_cart/* getCartSecondHandItems */.wR)(cart);
    var remainStockAfterCheckCart = getSecondHandStockRemainsCompareCart(secondHandStock, secondHandInCart);
    return remainStockAfterCheckCart.map(function(stockBySku) {
        return stockBySku.sku;
    });
};
var handlePreselectedSizeAndCondition = function(secondHandStock, productToChangeForPreselection, takeBackStockPreLoaded, states, cart, setOriginalPrice, setCurrentVariantCode, setCurrentSizeQualities, setShowQualities, setSelectedQuality, setSelectedQualityObject, setCurrentSku, setCurrentItem, setCurrentSecondHandDescription, setTakeBackPrice, setGliderReady, setNoMoreStockAvailable, setRemainSecondHandSkusAfterCheckCart, router) {
    var ChosenSizeAndCondition = preSelectedSkuAndCondition(secondHandStock, productToChangeForPreselection, takeBackStockPreLoaded, states, cart, setNoMoreStockAvailable, router);
    if ((ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.chosenSku) !== null && ChosenSizeAndCondition.chosenQuality !== undefined) {
        // use the same steps as handleSizeSelected and handleStateSelected but with preloaded take back data
        setOriginalPrice(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.originalPrice);
        setCurrentVariantCode(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.chosenCode);
        setCurrentSizeQualities(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.qualitiesArray);
        setShowQualities(true);
        // in case of there is no more size and state filtered, we take the first state available according to preselected sku
        setSelectedQuality(ChosenSizeAndCondition.chosenQuality !== null ? ChosenSizeAndCondition.chosenQuality : ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.qualitiesArray.find(function(quality) {
            return !quality.disabled;
        }).quality);
        setCurrentSku(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.chosenSku);
        setCurrentItem(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.item);
        setCurrentSecondHandDescription(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.secondHandDescription);
        setTakeBackPrice(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.currentPrice);
        setSelectedQualityObject(ChosenSizeAndCondition === null || ChosenSizeAndCondition === void 0 ? void 0 : ChosenSizeAndCondition.chosenQualityObject);
        if (setGliderReady) setGliderReady(true);
        setRemainSecondHandSkusAfterCheckCart(getRemainSkusAvailableAfterCheckCart(cart, secondHandStock));
    } else {
        if (setGliderReady) setGliderReady(true);
        setNoMoreStockAvailable(true);
    }
};
var getSecondHandImageForRelatedProduct = function(relatedItemSkus, currentItemAndAssociationTBStock) {
    var ref, ref8, ref9;
    var skusInStock = currentItemAndAssociationTBStock.filter(function(item) {
        return item.productsByQuality.length > 0;
    });
    var relatedItemSkusInStock = skusInStock.filter(function(TBStock) {
        return relatedItemSkus.includes(TBStock.lizeeSKU);
    });
    return (ref9 = (ref8 = (ref = relatedItemSkusInStock[0]) === null || ref === void 0 ? void 0 : ref.productsByQuality[0]) === null || ref8 === void 0 ? void 0 : ref8.products[0]) === null || ref9 === void 0 ? void 0 : ref9.images;
};


/***/ }),

/***/ 61429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ getChosenCondition; },
/* harmony export */   "DM": function() { return /* binding */ getAvailableFilteredConditions; }
/* harmony export */ });
/* unused harmony export getAvailableSecondHandProductBySize */
/* harmony import */ var _cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89910);
/* harmony import */ var _filters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92412);


// get the lowest selected condition from filters or get the lowest available condition
var getChosenCondition = function(chosenSku, secondHandStock, cart) {
    var currentSkuProductInCart;
    var currentAvailableStock = [];
    var currentAvailableConditions = [];
    var availableSecondHandProduct = getAvailableSecondHandProductBySize(chosenSku, secondHandStock);
    if (!availableSecondHandProduct) return [];
    var availableSecondHandProductsConditions = availableSecondHandProduct.secondHand;
    var ref1;
    // available conditions in stock by sku
    currentAvailableConditions = (ref1 = availableSecondHandProductsConditions === null || availableSecondHandProductsConditions === void 0 ? void 0 : availableSecondHandProductsConditions.map(function(conditionInStock) {
        return conditionInStock.quality;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var secondHandItemsInCart = (0,_cart__WEBPACK_IMPORTED_MODULE_0__/* .getCartSecondHandItems */ .wR)(cart);
    if ((secondHandItemsInCart === null || secondHandItemsInCart === void 0 ? void 0 : secondHandItemsInCart.length) > 0) {
        // check if this sku is in cart
        currentSkuProductInCart = (0,_cart__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentSkuProductInCart */ .Vk)(secondHandItemsInCart, chosenSku);
        if (currentSkuProductInCart.length > 0) {
            // check which conditions are in cart and compare with stock
            availableSecondHandProductsConditions.map(function(availableSecondHand) {
                var ref;
                var exists = (ref = currentSkuProductInCart[0]) === null || ref === void 0 ? void 0 : ref.units.filter(function(unit) {
                    return unit.productState === availableSecondHand.quality;
                });
                // remove quantity in cart in order to get remain available stock
                var quantityAvailable = availableSecondHand.quantity - exists.length + (availableSecondHand.reservedCount || 0);
                currentAvailableStock.push({
                    quality: availableSecondHand.quality,
                    quantity: quantityAvailable
                });
                currentAvailableStock = currentAvailableStock.filter(function(currentItem) {
                    return currentItem.quantity > 0;
                });
            });
            currentAvailableConditions = currentAvailableStock.map(function(AvailableStock) {
                return AvailableStock.quality;
            });
        }
    }
    var availablefilteredConditions = getAvailableFilteredConditions(currentAvailableConditions);
    if (availablefilteredConditions.length === 0) return null;
    return (0,_filters__WEBPACK_IMPORTED_MODULE_1__/* .getLowestConditionByConditions */ .bE)(availablefilteredConditions);
};
// get all qualities available for the selected sku
var getAvailableSecondHandProductBySize = function(sku, secondHandStock) {
    var availableQualitiesForSize = secondHandStock.find(function(secondHandStockItem) {
        return secondHandStockItem.lizeeSKU === sku;
    });
    return availableQualitiesForSize;
};
var getAvailableFilteredConditions = function(currentAvailableConditions) {
    if (!(0,_filters__WEBPACK_IMPORTED_MODULE_1__/* .isProductConditionFiltered */ .jk)()) return currentAvailableConditions;
    var filteredConditions = (0,_filters__WEBPACK_IMPORTED_MODULE_1__/* .getProductConditionsFiltered */ .Sk)();
    return filteredConditions.filter(function(filteredCondition) {
        return currentAvailableConditions.includes(filteredCondition);
    });
};


/***/ })

}]);